import { Component, ViewChild, ElementRef, EventEmitter, Output, ChangeDetectorRef, Injector } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Parametros } from 'src/app/services/domain/services-domain';
import { inputType, newmetadate, style } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { UtilService } from 'src/app/services/util.service';
import { Router, RouteReuseStrategy } from '@angular/router';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { StorageService } from 'src/app/services/storage.service';
import { Title } from '@angular/platform-browser';
import { DatosCompartidosService } from 'src/app/services/datos-compartidos.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ListContenedor, ListIncoter, ListItem, ListPrtoD, ListPrtoO, ListaCliente2, ListaContactoJ, ListaDetalleProforma, ListaMantProforma, ListaTarifa, TransportistaResponse, listadogastoslocales, listadonaves, listadoproformagastoslocales, listadoserviciolocales, listaejecutivos, listcontacto, response_serviciolocales } from 'src/app/proforma/domain/response/proforma_response';
import { contactoRequest, requestcontacto, rucInternoRequest, sunatRequest, tarifaRequest } from 'src/app/proforma/domain/request/proforma_request';
import { BuscarServicio_ByViaRegimenRequest, ConsultarEntidadServicio_Request, ConsultarTarifaRequest, ConsultarTariffDetailByIdRequest, CrudOrdenesVentaRequest, DetalleServiciosLocalesRequest, EvenSiRequest, GetServiceCalculatedByTariffRequest, ServiciosLocalesRequest, TransaccionAgrupadorRequest, ItemsAgrupador, ListarTarifaCotizacionRequest, ListarAgrupacionRequest, listAllOVRequest, SLI_ValidacionGruposProfitMinimo_Request, itemsValidacionGrupos, AutorizacionSliRequest } from 'src/app/comercial/orden-venta/domain/request/comercial-orden-venta-request';
import { ContactoComponent } from '../contacto/contacto.component';
import { co, en, R } from '@fullcalendar/core/internal-common';
import { BuscarContratoComponent } from '../buscar-contrato/buscar-contrato.component';
import { NonFullScreenPageMode } from 'pdf-lib';
import { ConsultarEntidadServicioResponse, ConsultarTarifaResponse, InsertarServiciosLocalesResponse, ItemsListarOrdenesVentaResponse, ItemsServiciosCalculadosTarifaResponse, ItemsTarifaDetalleResponse, itemsTarifaFleteResponse } from 'src/app/comercial/orden-venta/domain/response/comercial-orden-venta-response';
import { catchError, concatMap, firstValueFrom, forkJoin, iif, Observable, of, Subject, switchMap, tap, throwError } from 'rxjs';
import { ConsultarProfitTCambioRequest, ConsultarVigenciaTokenRequest, EliminarOPTransportistaRequest, GenerarTokenAutorizacionRequest, ListarDatosLoginRequest, TransaccionAuthCambioVtaRequest, Transportista_CAB_Cotizacion_OV_Request, TransportistaRequest } from '../../domain/request/cotizacion-request';
import { TransportistaCotizacionResponse } from '../../domain/response/cotizacion-response';
import { TransportistasAdicionalesComponent } from '../transportistas-adicionales/transportistas-adicionales.component';
import { Dropdown } from 'primeng/dropdown';
import { Button } from 'primeng/button';
import { AutoComplete } from 'primeng/autocomplete';
import { ActualizarComisionesBrokerIRequest } from 'src/app/comision-broker/domain/request/Comisiones-Broker-Request';
import { PRI_ReporteTarifa_3Request } from 'src/app/supply/reportes/pricing/domain/reportes-pricing.request';
import { ReporteTarifaRepository } from 'src/app/supply/reportes/servicio/reporte-tarifa.repository';
import { BuscarCamposRequest } from 'src/app/mantenimiento/mantenimiento-de-campos/domain/mantenimiento-de-campos.request';
import { MantenimientoRespository } from 'src/app/mantenimiento/servicio/mantenimiento.repository';
import { DatatableComponent } from 'src/app/shared/components/datatable/datatable.component';
import { UserEntity } from 'src/app/usuario/domain/user-entity';
import { ca } from 'date-fns/locale';
import { ObtenerParametrosRequest } from 'src/app/parametros/domain/parametros.request';
import { parametrosRepository } from 'src/app/parametros/servicio/parametros.repository';
import { COD_ROLES } from 'src/app/shared/constantes/constantes';
import { getRutaByPlaceRequest, getZoneByProviderRequest } from 'src/app/features/logistica/gestion-transporte/domain/gestion-transporte.request';
import { LogisticaRepository } from 'src/app/features/logistica/services/logistica.repository';
import { readonlyMetadataTable } from 'src/app/shared/components/readonly-data-table/domain/readonly-data-table.domain';
import { LogisticaService } from 'src/app/features/logistica/services/logistica.service';
import { DialogService } from 'primeng/dynamicdialog';
import { BandejaTarifarioSliComponent } from 'src/app/features/pricing/tarifario-sli/presentacion/bandeja-tarifario-sli/bandeja-tarifario-sli.component';


@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.css'],
  standalone: false,
  providers: [ConfirmationService, MessageService,
    { provide: LogisticaRepository, useClass: LogisticaService },
  ]
})
export class CotizacionComponent {
  constructor(
    private readonly router: Router,
    private cdr: ChangeDetectorRef,
    private readonly proformaService: ProformaRepository,
    private readonly ordenventaService: ComercialRepository,
    private readonly util: UtilService,
    private readonly title: Title,
    public storage: StorageService,
    private datosCompartidosService: DatosCompartidosService,
    private confirmationService: ConfirmationService,
    private readonly servreporte: ReporteTarifaRepository,
    private readonly mantenimientoservice: MantenimientoRespository,
    private cd: ChangeDetectorRef,
    private messageService: MessageService,
    private readonly servParametros: parametrosRepository,
    private readonly servLogistica: LogisticaRepository,
    public dialogService: DialogService,
    private reuseStrategy: RouteReuseStrategy,
    private injector: Injector

  ) {
    this.title.setTitle('Nueva Cotización')
    this.datosRecibidos = JSON.parse(localStorage.getItem('datoov'))
    this.datos = this.datosRecibidos

    this.accion = localStorage.getItem('Opcion')
    this.mostrarBotonTransportista = this.accion === 'EDITAR' || this.accion === 'VISUALIZAR';
  }

  protected _onDestroy = new Subject<void>();
  @Output() onDpValueChangeEvento: EventEmitter<any> = new EventEmitter();
  @Output() onDpValueChangeFleteEvento: EventEmitter<any> = new EventEmitter();
  @ViewChild('dtServiciosRef') dtServiciosRef!: DatatableComponent;
  @ViewChild('dtServiciosRef2') dtServiciosRef2!: DatatableComponent;
  @ViewChild('dataFlete') dataFlete!: DatatableComponent;
  @Output() onProcesado = new EventEmitter<any>();
  enviarEventoBandejaOv(objeto) {
    const resultado = { objeto };
    this.onProcesado.emit(resultado);
  }

  estilos: style = {
    header: {
      align: 'left',
      justify: 'center',
      size: '10px'
    },
    body: {
      size: '9px'
    }
  }

  nombreUsuario: string = '';
  rol: string = '';
  mostrarBotonTransportista: boolean = false;
  transportistasAdicionales: boolean = false;
  transportistasAdicionalesData: any
  rutaComponente = '/comercialcotizacion';
  item2: ItemsListarOrdenesVentaResponse;
  datos: any[] = []
  date: Date = new Date();
  datosRecibidos: any = [];
  parametros: Parametros[] = []
  activeIndex: number = 0;
  accion: string;
  cont_codigo: number;
  dataTarifa: any;
  opcionalTransportista: any
  esVisualizar: boolean = false;
  bloqueoObservaciones: boolean = false;
  bloqueoCheckboxSLI: 'nolock' | 'lock' = 'nolock';
  bloqueoserviciolocal: boolean = false;
  visibleAuth: boolean;
  // visible: boolean
  visibleTarifa: boolean

  listarServTariff: ItemsServiciosCalculadosTarifaResponse[] = [];
  listarTarifaDetalle: ItemsTarifaDetalleResponse[] = [];
  listartransportistasAdicionales: Transportista_CAB_Cotizacion_OV_Request[];

  group_tabcotizacion: FormGroup
  group_datosGenerales: FormGroup
  group_datosAdicionales: FormGroup
  group_tarifasAdicionales: FormGroup
  group_Transporte: FormGroup
  groupAuth: FormGroup
  datatable_tarifas: any[] = []
  metadatableTarifas: newmetadate[]
  serviciosytarifas_dataflete: any[] = []
  // metadatableFlete: newmetadate[]
  metadatableFleteConCostos: newmetadate[]
  serviciosytarifas_dataservicios: any[] = []
  metadatableServicio: newmetadate[]
  datosembarque_dataflete: any[] = []
  metadatableFleteEmbarque: newmetadate[]
  servicioslocales_dataObservaciones: any[] = []
  metadatableDataObservaciones: newmetadate[]
  servicioslocales_tarifa: any[] = []
  metadatableTarifa: newmetadate[]
  servicioslocales_datadetalle: any[] = []
  metadatableDataDetalle: newmetadate[] = [
    { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'text' },
    { title: 'UNIDAD BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'text' },
    { title: 'TIPO ENTIDAD', field: 'tipoentidad', filterType: 'text', inputType: 'text', required: true },
    { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', filterType: 'text', inputType: 'text' },
    { title: 'TIPO DE CAMBIO', field: 'tipocambioventa', filterType: 'numeric', inputType: 'decimal', verColumna: (row) => this.verColumnaMetadata(row, 'tipo_cambio'), },
    {
      title: 'VENTA (UNIDAD)', field: 'dope_preciounitvta', filterType: 'text', operacion: 'multiplicar', inputType: 'decimal', toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      validar: 'dope_preciounit_prom', tipoValidar: 'venta', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null }],
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }],
      rowFooter: 'sum_misma_moneda',
    },
    // { title: 'PROFIT', field: 'profit_fijo', filterType: 'text', inputType: 'decimal' },
    // { title: 'PROFIT MINIMO', field: 'profitminimo', filterType: 'text', inputType: 'decimal' },
    { title: 'MONEDA', field: 'nombremndvta', filterType: 'text', inputType: 'text' },
    {
      title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', operacion: 'multiplicar', inputType: 'int',
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }]
    },
    {
      title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum_misma_moneda',
    },
    { title: 'Descripción<br>Tarifa', field: 'desctarifa', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Vigencias<br>Tarifa', field: 'vigencias', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Estado', field: 'cons_descest', filterType: 'text', inputType: 'textdisabled' },
    // { title: 'AGRUPADO', field: 'agrupado', inputType: 'checkbox' },
    // { title: '', field: 'veragrupado', inputType: 'buttonPersonalizado', icon: "pi pi-eye", toolTip: "Ver Tarifa", function: (row) => this.viewTarifas(row), condicion: 'agrupado' }
  ]
  servicioslocales_dataservicios: any[] = []
  metadatableDataServicios: newmetadate[]
  dataTableDetalleAgrupado: any[] = []
  metadataTableDetalleAgrupado: newmetadate[]
  dataTableTransporte: any[] = []
  metadataTableTransporte: newmetadate[] = []
  dataTableTarifaServicioLogistico: any[] = []
  metadataTableTarifaServicioLogistico: newmetadate[] = []
  servicioslocales_detalleTarifa: any[] = []
  metadatableDetalleTarifa: newmetadate[] = [
    { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'text' },
    { title: 'UNIDAD BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'text' },
    { title: 'TIPO ENTIDAD', field: 'tipoentidad', filterType: 'text', inputType: 'text' },
    { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', filterType: 'text', inputType: 'text' },
    { title: 'TIPO DE CAMBIO', field: 'tipocambioventa', filterType: 'numeric', inputType: 'decimal', verColumna: (row) => this.verColumnaMetadata(row, 'tipo_cambio'), },
    {
      title: 'VENTA (UNIDAD)', field: 'dope_preciounitvta', filterType: 'numeric', operacion: 'multiplicar', inputType: 'decimal', toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      validar: 'dope_preciounitcosto', tipoValidar: 'menor', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }], rowFooter: 'sum_misma_moneda',
    },
    // { title: 'PROFIT', field: 'profit_fijo', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum', },
    // { title: 'PROFIT MINIMO', field: 'profitminimo', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum', },
    { title: 'MONEDA', field: 'nombremndvta', filterType: 'text', inputType: 'text' },
    {
      title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', operacion: 'multiplicar', inputType: 'int',
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }]
    },
    {
      title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum_misma_moneda',
    },
    { title: 'Descripción<br>Tarifa', field: 'desctarifa', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Vigencias<br>Tarifa', field: 'vigencias', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Estado', field: 'cons_descest', filterType: 'text', inputType: 'textdisabled' },
  ]
  tablaAgrupados: any[] = []
  listadoOriginal: any[] = []
  listadoOriginalAgrupados: any[] = []
  servicioslocales_detalleAgrupacion: any[] = []
  metadataTableDetalleAgrupacion: newmetadate[] = []
  dataTableAgeAduana: any[] = []
  metadataTableAgeAduana: newmetadate[] = []
  ListaNombreEntidadesDP: any[] = [];
  listaItinerariosOV: any[] = []

  blockedColumnsSL: string[] = ['resumen_eliminar'];
  modovisualizar: boolean = true
  reset = [
    { icon: 'pi pi-history', function: () => this.ResetTabla(), toolTip: "Refrescar", loading: false, disabled: this.modovisualizar }
  ];
  leyendasAgrupacionRow = []
  avisoLl_z: string = 'Aviso de llegada ';
  fechaEm_z: string = 'F. Embarque';
  readOnlyVisualizar: boolean;
  readOnlyNumeroDGDG: boolean;
  readOnlyVersionCotizacionDG: boolean;
  readOnlyEstadoDG: boolean;
  readOnlyNoCRMDG: boolean;
  readonlyOrdenCompraDG: boolean;
  readonlySADADSL: boolean;
  readonlyIMODSL: boolean;
  readonlyTipoDSL: boolean;
  readonlyVigenciaDesdeDSL: boolean;
  readonlyVigenciaHastaDSL: boolean;
  readonlyDescripcionDSL: boolean;
  readonlyDepositoNov: boolean;
  adicional: boolean = false;

  // --Servicio Locales
  readOnlyCodigoOperacionDSL: boolean;
  readOnlyNumeroOpeacionDSL: boolean;
  readonlyFechaEmisionDSL: boolean;
  readOnlyClienteDSL: boolean;
  readOnlyTransportistaAMDSL: boolean;
  readOnlyAlmacenDSL: boolean;
  readOnlyAgenciaMaritimaDSL: boolean;
  readOnlyTerminalPortuarioDSL: boolean;
  readOnlyCondicionEmbarqueDSL: boolean;
  readonlyTransportistaDSL: boolean;
  readonlyTarifaDSL: boolean;
  readonlyObservacionesDSL: boolean;
  readOnlyVentaTotalDSL: boolean;
  readonlyImoClassDE: boolean;
  readOnlyImoUnDE: boolean;

  ListaTodosEstado: any[] = []
  ListaTodosRegimen: any[] = []
  ListaTodosVia: any[] = []
  ListaTodosLineaNegocio: any[] = []
  ListaTodosCliente: any[] = []
  ListaTodosCustomer: any[] = []
  ListaTodosAgentes: any[] = []
  ListaTodosIncoterm: any[] = []
  ListaTodosEjecutivos: any[] = []
  ListaTodosPuertoOrigen: any[] = []
  ListaTodosServicios: any[] = []
  ListaTodosPuertoOrigenyDestino: any[] = []
  ListaTodosRazonSocial: any[] = []
  ListaTipoPaquete: any[] = []
  ListaPaqueteOriginal: any[] = []
  ListaTodosTransportista: any[] = []
  ListaTodosTrafico: any[] = []
  ListaTodosTipoFechaTarifa: any[] = []
  ListaTodosMoneda: any[] = []
  ListaTodosCondicion: any[] = []
  ListaTodosPCMBL: any[] = []
  ListaTodosPCHBL: any[] = []
  ListaTodosImoClass: any[] = []
  ListaTodosShipper: any[] = []
  ListaTodosConsignee: any[] = []
  ListaTodosNotify: any[] = []
  ListaTodosDescripcionServiciosLocales: any[] = []
  ListaTodosDeposito: any[] = []
  ListadoOperaciones: any[] = []
  ListadoGrupoPaquete: any[] = []
  ListadoServicioContenedores: any[] = []
  ListadoTarifaAsociada: any[] = []
  ListadoControlAsociados: any[] = []
  bloqueoColumnas: string[] = ['nombremndvta', 'entc_razonsocial', 'tipoentidad', 'cons_desc_spa', 'serv_nombre_spa',
    'agrupado', 'dope_preciototvta', 'profit_fijo', "profitminimo", "desctarifa", "vigencias", "cons_descest", "tipocambioventa"];
  ListaTodosAgeMND: any[] = []
  listRutas: any[] = []
  ListaServiciosByViaRegimen: SelectItem[] = []
  ListaPuertosByVia: SelectItem[] = []
  ListaServicio: SelectItem[] = []
  //ListaIngreEgre: any[]=[]
  ListaTipoEntidad: SelectItem[] = []
  ListaProveedorG: SelectItem[] = []
  ListaBase: SelectItem[] = []
  ListaMoneda: SelectItem[] = []
  ListaComodity: SelectItem[] = []
  ListaUnidadMedida: SelectItem[] = []
  ListaTipoDocumento: SelectItem[] = []
  ListaTipoPaqueteDP: SelectItem[] = []
  ListaTodosTransportistaDP: SelectItem[] = []
  ListaServiciosByViaRgmLngDP: SelectItem[] = []
  dataTableTarifaAlmacen: any[] = []
  metadataTableTarifaAlmacen: newmetadate[] = []

  listRazonSocial: any[] = [];
  // limitedOptions: string[] = [];

  datosViajePorPuerto2: any[] = []
  codigoRazonSocial: string;
  razonSocial: string;
  ruc: string;
  codigoIncoter: string;
  contactoComponent = ContactoComponent;
  contratoComponent = BuscarContratoComponent;
  transportistasComponent = TransportistasAdicionalesComponent
  tipoAuth: any[] = [
    { key: 'U', name: 'Usuario' },
    { key: 'T', name: 'Token' }
  ]



  public changedByEnterOrClick = false;
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.changedByEnterOrClick = true;
    }
  }

  onClick() {
    this.changedByEnterOrClick = true;
  }

  ngAfterViewInit() {
    //this.focusRegimenDropdown();
  }

  listarDatosParam() {
    const request = <ObtenerParametrosRequest>{}
    request.codigos = [
      { codigo: "RUTAS" }
    ]
    this.servParametros.ObtenerParametros(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.listRutas = response.datos.result["RUTAS"]
      }
    })
  }

  isadmin: boolean = false;
  soloLectura: boolean;
  transportistaSeleccionado: string;
  coordLog: string = COD_ROLES.coord_log;
  gerentLog: string = COD_ROLES.ger_log;
  async ngOnInit(): Promise<void> {
    this.nombreUsuario = this.storage.get('usuario');
    this.rol = this.storage.get('rol');
    const rol = this.rol;
    if (rol != '4') {
      this.isadmin = true
    } else {
      this.isadmin = false
    }
    const roladd = this.rol;
    if (roladd === '1') {
      this.adicional = null;
    } else if (['1', '10', '11', '14', this.coordLog, this.gerentLog].includes(roladd)) {
      this.adicional = true;
    } else {
      this.adicional = false;
    }
    this.parametros = await this.util.getParametros()
    await this.ListarParametros()
    this.listarDatosParam()
    this.listarParametrosDP()
    this.inicializarMetadate()
    this.onClickRecargo('init');
    switch (this.accion) {
      case "NUEVO":

        this.inicializaFormulario("I", [])
        this.group_datosGenerales.get('diaslibres').setValue(0);

        this.readOnlyEstadoDG = true;
        this.group_tabcotizacion.get('estado')?.setValue('001');
        this.group_tarifasAdicionales.get('condicion')?.setValue("FCL/FCL");
        this.onAgenteChange(event);
        this.soloLectura = false;
        this.readonlyFechaEmisionDSL = true;
        break;
      case "EDITAR":
        this.obtenerDatosOV()
        if (
          Array.isArray(this.datosRecibidos["listadooperaciones"]) &&
          this.datosRecibidos["listadooperaciones"].some(op => op.cons_codestado == "002" || op.cons_codestado == "004")
        ) {
          this.bloqueoserviciolocal = true;
          this.bloqueoCheckboxSLI = 'lock';
          this.servicioslocales_tarifa = [];
          this.bloqueoObservaciones = true
        }

        this.onEditaryVisualizarInit()
        this.filtrarServicios();
        this.inicializarCodigos();
        this.soloLectura = true
        this.transportistaSeleccionado = this.datosRecibidos.entc_nomtransportista;
        this.dope_items = []
        this.cope_codigos = []
        // this.readOnlyVisualizar = true;
        // this.buscarTarifas()
        break;
      case "VISUALIZAR":

        this.onEditaryVisualizarInit()
        this.readOnlyNumeroDGDG = true;
        this.readOnlyEstadoDG = true;
        this.readOnlyNoCRMDG = true;
        this.esVisualizar = true;
        this.readonlyOrdenCompraDG = true;
        this.readOnlyEstadoDG = true;
        this.readOnlyNoCRMDG = true;
        this.readonlyOrdenCompraDG = true;
        this.readOnlyVisualizar = true;
        // --Servicio Locales
        this.readOnlyCodigoOperacionDSL = true;
        this.readOnlyNumeroOpeacionDSL = true;
        this.readonlyFechaEmisionDSL = true;
        this.readOnlyClienteDSL = true;
        this.readOnlyTransportistaAMDSL = true;
        this.readOnlyAlmacenDSL = true;
        this.readOnlyAgenciaMaritimaDSL = true;
        this.readOnlyTerminalPortuarioDSL = true;
        this.readOnlyCondicionEmbarqueDSL = true;
        this.readonlyTransportistaDSL = true;
        this.readonlySADADSL = true;
        this.readonlyIMODSL = true;
        this.readonlyTarifaDSL = true;
        this.readonlyTipoDSL = true;
        this.readonlyVigenciaDesdeDSL = true;
        this.readonlyVigenciaHastaDSL = true;
        this.readonlyDescripcionDSL = true;
        this.readonlyObservacionesDSL = true;
        this.readonlyImoClassDE = true;
        this.soloLectura = true
        break;
      default:
        break;
    };

    this.readOnlyNumeroDGDG = true
    this.readOnlyVersionCotizacionDG = true
    this.readOnlyEstadoDG = true
    this.readOnlyNoCRMDG = true

    // --Servicio Locales
    this.readOnlyCodigoOperacionDSL = true;
    this.readOnlyNumeroOpeacionDSL = true;
    this.readonlyFechaEmisionDSL = true;
    this.readOnlyClienteDSL = true;
    this.readOnlyTransportistaAMDSL = true;
    this.readOnlyAlmacenDSL = true;
    this.readOnlyAgenciaMaritimaDSL = true;
    this.readOnlyTerminalPortuarioDSL = true;
    this.readOnlyCondicionEmbarqueDSL = true;
    this.readonlyTransportistaDSL = true;
    this.readonlySADADSL = true;
    this.readonlyIMODSL = true;
    this.readonlyTarifaDSL = true;
    this.readonlyTipoDSL = true;
    this.readonlyVigenciaDesdeDSL = true;
    this.readonlyVigenciaHastaDSL = true;
    this.readonlyDescripcionDSL = true;
    this.readonlyObservacionesDSL = true;
    this.readonlyDepositoNov = true;

  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  obtenerDataStorage() {
    if (this.datos) {

    } else {

    }
    if (this.datos && this.datos['listadoservicio']) {
      this.serviciosytarifas_dataservicios = this.datos['listadoservicio'];

    } else {

    }
    if (this.datosViajePorPuerto2) {

    } else {

    }
    if (this.datos && this.datos['listadooperaciones']) {
      this.ListadoOperaciones = this.datos['listadooperaciones'];

    } else {

    }
    if (this.datos && this.datos['listadogrupopaquete']) {
      this.ListadoGrupoPaquete = this.datos['listadogrupopaquete'];

    } else {

    }
    if (this.datos && this.datos['listadoserviciocontenedores']) {
      this.ListadoServicioContenedores = this.datos['listadoserviciocontenedores'];

    } else {

    }
    if (this.datos && this.datos['listadotarifaasociada']) {
      this.ListadoTarifaAsociada = this.datos['listadotarifaasociada'];

    } else {

    }
    if (this.datos && this.datos['listadodetalleasociada']) {//Es una tabla
      this.servicioslocales_dataservicios = this.datos['listadodetalleasociada'];

    } else {

    }
    if (this.datos && this.datos['listadoserviciosasociados']) {//Es una tabla
      this.listadoOriginal = structuredClone(this.datos['listadoserviciosasociados']);
      this.servicioslocales_datadetalle = structuredClone(this.datos['listadoserviciosasociados']);
      this.servicioslocales_datadetalle.forEach((row, index) => {
        row['ESTADO_OBJ'] = 'U'
      });
      console.log("Los datos de ListadoServiciosAsociados: ", this.servicioslocales_datadetalle);
      this.servicioslocales_datadetalle = this.servicioslocales_datadetalle
        .filter(item =>
          (item.agrupado === null || item.agrupado === false) && item.dope_changecontrol === false
        )
        .map(row => {
          row['disabled'] = (row.cons_codest !== '001' || row.fact_proveedor != null);
          return row;
        });

      this.listadoOriginal = this.listadoOriginal
        .filter(item =>
          (item.agrupado === null || item.agrupado === false) && item.dope_changecontrol === false
        )
        .map(row => {
          row['disabled'] = (row.cons_codest !== '001' || row.fact_proveedor != null);
          return row;
        });

      const existeAutorizado = this.servicioslocales_datadetalle.some(row => row.desc_autorizado != null);
      if (existeAutorizado) {
        this.metadatableDataDetalle.push({ field: 'desc_autorizado', title: 'Estado<br>Autorizado', inputType: 'textdisabled', filterType: 'text', maxWidth: '80px' });
      }
    } else {

    }
    if (this.datos && this.datos['listadocontrolasociados']) {
      this.ListadoControlAsociados = this.datos['listadocontrolasociados'];

    } else {

    }
    if (this.datos && this.datos['listadoeventosasociados']) {//Es un tabla
      this.servicioslocales_dataObservaciones = this.datos['listadoeventosasociados'];

    } else {

    }
    if (this.datos && Array.isArray(this.datos['listadofletes'])) {

      this.serviciosytarifas_dataflete = this.datos['listadofletes'].map((flete, index) => ({
        ...flete,
        transportistaObj: {
          label: this.datosRecibidos.entc_nomtransportista,
          value: this.ListaTodosTransportistaDP.find(item => item.label === this.datosRecibidos.entc_nomtransportista)?.value.toString(),
        },
        codigo: flete.cont_codigo || this.datosRecibidos.cont_codigo,
        contrato: this.datosRecibidos.cont_numero,
        descripcion: flete.cont_descrip || this.datosRecibidos.cont_descrip,
        paqueteObj: {
          label: flete.pack_desc,
          value: flete.pack_codigo.toString()
        },
        Item: index + 1,
        select: false,
        dcot_preciounicosto: flete.dcot_preciounicosto || null,
        dcot_preciouniventa: flete.dcot_preciouniventa || null,
        dcot_totaluniventa: flete.dcot_totaluniventa || 0,
        dcot_totalunicosto: flete.dcot_preciounicosto * flete.dcot_cantidad
      }));

      this.datosembarque_dataflete = [...this.serviciosytarifas_dataflete];

      console.log("Datos mapeados de FLETES: ", this.serviciosytarifas_dataflete);
    } else {

    }

    if (this.datos && this.datos['listadoAgrupadores']) {
      this.servicioslocales_detalleAgrupacion = this.datos['listadoAgrupadores'].map((asc) => ({
        ctar_codigo: asc.ctaR_Codigo,
        dtar_codigo: asc.dtaR_Codigo,
        cope_codigo: asc.cope_codigo,
        dope_item: asc.dope_item,
        dope_cantidad: asc.dopE_Cantidad,
        dope_preciototvta: asc.dopE_PrecioTotVta,
        dope_preciounitvta: asc.dopE_PrecioUnitVta,
        serv_nombre_spa: asc.serV_Descripcion,
        agrupado: true,
        cod_padre: null,
        ESTADO_OBJ: 'U'
      }))
      this.listadoOriginalAgrupados = this.datos['listadoAgrupadores'];
    } else {
    }

    this.item2 = {
      //=====DATOS GENERALES============
      ccot_numdoc: this.datosRecibidos.ccot_numdoc,
      ccot_numdoccot: this.datosRecibidos.ccot_numdoccot,
      cons_codest: this.datosRecibidos.cons_codest,
      cons_descest: this.datosRecibidos.cons_descest,
      cons_codrgm: this.datosRecibidos.cons_codrgm,
      cons_descrgm: this.datosRecibidos.cons_descrgm,
      cons_codvia: this.datosRecibidos.cons_codvia,
      cons_descvia: this.datosRecibidos.cons_descvia,
      cons_codlng: this.datosRecibidos.cons_codlng,
      cons_descfle: this.datosRecibidos.cons_descfle,
      ccot_propia: this.datosRecibidos.ccot_propia,
      ccot_enviaavisollegada: this.datosRecibidos.ccot_enviaavisollegada,
      ccot_serviciologistico: this.datosRecibidos.ccot_serviciologistico,
      ccot_serviciotransmision: this.datosRecibidos.ccot_serviciotransmision,
      ccot_fecemi: this.datosRecibidos.ccot_fecemi,
      ccot_fecemiformat: this.datosRecibidos.ccot_fecemiformat,
      ccot_fecvcto: this.datosRecibidos.ccot_fecvcto,
      ccot_fecaprueba: this.datosRecibidos.ccot_fecaprueba,
      ddov_fecembarque: this.datosRecibidos.ddov_fecembarque,
      entc_nomcliente: this.datosRecibidos.entc_nomcliente,
      entC_NomCustomer: this.datosRecibidos.entc_nomcustomer,
      entc_nomagente: this.datosRecibidos.entc_nomagente,
      tipo_codinc: this.datosRecibidos.tipo_codinc,
      ccot_ordencompra: this.datosRecibidos.ccot_ordencompra,
      entc_nomejecutivo: this.datosRecibidos.entc_nomejecutivo,
      ccot_numpresupuesto: this.datosRecibidos.ccot_numpresupuesto,

      //=====SERVICIOS Y TARIFA============================
      ///---datos de contrato
      entc_nomtransportista: this.datosRecibidos.entc_nomtransportista,
      puer_nombretrasbordo: this.datosRecibidos.puer_codtrasbordo,

      tipo_codtrf: this.datosRecibidos.tipo_codtrf,
      puer_nombreorigen: this.datosRecibidos.puer_codorigen,
      puer_nombredestino: this.datosRecibidos.puer_coddestino,
      tipo_codmnd: this.datosRecibidos.tipo_codmnd,
      cons_codtft: this.datosRecibidos.cons_codtft,
      ccot_fectarifa: this.datosRecibidos.ccot_fectarifa,
      cons_codfle: this.datosRecibidos.cons_codfle,//Es la condicion?
      cont_codigo: this.datosRecibidos.cont_codigo,
      cont_numero: this.datosRecibidos.cont_numero,
      cont_descrip: this.datosRecibidos.cont_descrip,
      ///--flete
      ccot_pagombl: this.tranformarDa(this.datosRecibidos.ccot_pagombl),
      ccot_pagohbl: this.tranformarDa(this.datosRecibidos.ccot_pagohbl),
      dcot_totaluniventa: this.datosRecibidos["listadofletes"].length > 0 ? this.datosRecibidos["listadofletes"][0].dcot_totaluniventa : null,
      //Dias Libres sobre Estadia es lo mimso que está en Observaciones
      //--servicios        
      dcot_preciounicosto: this.datosRecibidos.dcot_preciounicosto,
      //--seguro
      //DATOS EMBARQUE=============================
      ccot_cargarefrigerada: this.datosRecibidos.ccot_cargarefrigerada,
      ccot_cargapeligrosa: this.datosRecibidos.ccot_cargapeligrosa,
      ccot_roundtrip: this.datosRecibidos.ccot_roundtrip,
      ccot_temperatura: this.datosRecibidos.ccot_temperatura,
      tipo_codimo: this.datosRecibidos.tipo_codimo,
      ccot_imoun: this.datosRecibidos.ccot_imoun,
      entc_nomshipper: this.datosRecibidos.entc_nomshipper,
      entc_nomconsignee: this.datosRecibidos.entc_nomconsignee,
      entc_nomnotify: this.datosRecibidos.entc_nomnotify,
      doov_codreferencia: this.datosRecibidos.doov_codreferencia,
      //OBSERVACIONES-----------
      ccot_almacenaje: this.datosRecibidos.ccot_almacenaje,
      ccot_sobreestadia: this.datosRecibidos.ccot_sobreestadia,
      ccot_tiempoviaje: this.datosRecibidos.ccot_tiempoviaje,
      ccot_validezoferta: this.datosRecibidos.ccot_validezoferta,
      ccot_observaciones: this.datosRecibidos.ccot_observaciones,
      //VIAJE ITENERARIO------------------
      //NOVEDADES--------------------
      ddov_nrobooking: this.datosRecibidos.ddov_nrobooking,
      //fechaRecepcion
      entc_nomdeptemporal: this.datosRecibidos.entc_nomdeptemporal,
      ddov_hblnieto: this.datosRecibidos.ddov_hblnieto,
      doov_hbl: this.datosRecibidos.doov_hbl,
      doov_mbl: this.datosRecibidos.doov_mbl,
      doov_cntr: this.datosRecibidos.doov_cntr,
      nvia_codigo: this.datosRecibidos.nvia_codigo,
      //zARPE
      //ETA
      nave_nombre: this.datosRecibidos.nave_nombre,
      //ARCHIVO------------------
      //EVENTOS/TAREAS-------------
      //SERVICIOS LOCALES-----------
      cope_codigo: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_codigo : 0,
      cope_numdoc: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_numdoc : null,
      cope_fecemi: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi : null,
      entc_nombrecliente: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombrecliente : null,
      entc_nombretransportista: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombretransportista : null,
      entc_nombrealmacen: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombrealmacen : null,
      entc_nombreagenciamaritima: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombreagenciamaritima : null,
      entc_nombreterminalportuario: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombreterminalportuario : null,
      descripcioncondicionembarque: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].descripcioncondicionembarque : null,
      cope_fechaSL: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fechaSL : null,
      codigo_ruta: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].codigo_ruta : null,
      cope_dam: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_dam : null,
      cope_cifLogistico: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_cifLogistico : null,
      cope_cifEjecVta: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_cifEjecVta : null,
      cope_peso_sli: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_peso_sli : null,
      cope_volumen_sli: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_volumen_sli : null,
      cope_unmd_peso: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_unmd_peso : null,
      cope_unmd_volumen: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_unmd_volumen : null,

      // descripcioncondicionembarque: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].terr : null,
      //Transportista (Jalado de arriba)?????
      //SADA???
      //IMO?????
      ctar_codigo: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].ctar_codigo : null,
      tarifftype: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].tarifftype : null,
      validfrom: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].validfrom : null,
      validto: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].validto : null,
      remarks: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].remarks : null,
      terminal_portuario: this.datosRecibidos.terminal_portuario,
      sucursal: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].sucursal : null,
      entc_codcliente: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_codcliente : null,
      entc_codlinaerea: this.datosRecibidos.entc_codlinaerea,
      doov_fecsalida: this.datosRecibidos.doov_fecsalida,
      doov_fecconexion: this.datosRecibidos.doov_fecconexion,
      ccot_descshipper: this.datosRecibidos.ccot_descshipper,
      ccot_descconsignee: this.datosRecibidos.ccot_descconsignee
      //observaciones
    };



  }

  onEditaryVisualizarInit() {
    // this.inicializaFormulario("I", [])
    this.obtenerDataStorage()

    this.inicializaFormulario("U", this.item2)
    this.filtrarPuertosSegunVia()
    this.obtenerTransportista()
    this.cargaRucInterno('I')


    this.group_datosGenerales.get('puertoorigen').setValue(this.datosRecibidos.puer_codorigen);
    this.group_datosGenerales.get('puertoorigen').setValue(this.datosRecibidos.puer_codorigen);
    this.group_datosGenerales.get('puertodestino').setValue(this.datosRecibidos.puer_coddestino);
    this.group_datosGenerales.get('puertotransbordo').setValue(this.datosRecibidos.puer_codtrasbordo);
    // this.group_tabcotizacion.get('razonSocial').setValue(this.datosRecibidos.entc_nomcliente)
    this.group_datosGenerales.get('contenedor').setValue(this.datosRecibidos.doov_cntr)


    // inicializar valores en SL
    var nombreCliente = this.group_tabcotizacion.get('razonSocial')?.value
    this.codigoRazonSocial = this.ListaTodosCliente.find(item => item.nombre === nombreCliente)?.codigo
    var nombreTransportista: string = this.group_datosGenerales.value["transportista"]
    this.codTransporte = Number(this.ListaTodosTransportista.find(item => item.nombre === nombreTransportista)?.codigo)
    this.codTransTerr = this.group_tarifasAdicionales.get('transportistaTerre')?.value
    this.group_tabcotizacion.get('version').setValue(this.datosRecibidos.ccot_version)





    if (this.datosRecibidos?.listadofletes?.length > 0) {
      this.group_datosGenerales.get('contenedor').setValue(this.datosRecibidos.listadofletes[0].pack_codigo?.toString())
    }

    // read onyl
    if (this.item2?.cons_codest == "004" || this.item2?.cons_codest == "003") { this.readOnlyVisualizar = true; }
    this.readOnlyCodigoOperacionDSL = true
    this.readOnlyNumeroOpeacionDSL = true
    this.readonlyFechaEmisionDSL = true
    this.readOnlyClienteDSL = true
    this.readOnlyTransportistaAMDSL = true
    this.readOnlyAlmacenDSL = true
    this.readOnlyAgenciaMaritimaDSL = true
    this.readOnlyTerminalPortuarioDSL = true
    this.readOnlyCondicionEmbarqueDSL = true
    this.readonlySADADSL = true
    this.readonlyIMODSL = true
    this.readOnlyVentaTotalDSL = true
    this.mostrarBotonTransportista = true

    this.onChangeCif('INI', '');
    this.seleccionarFlete(-1, '');
  }
  confirmarContinuar(mensaje: string): Promise<boolean> {
    return new Promise(resolve => {
      this.confirmationService.confirm({
        message: mensaje,
        icon: 'pi pi-exclamation-triangle',
        key: 'C',
        rejectButtonProps: {
          label: 'Cancelar',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Continuar',
        },
        header: 'Confirmation',
        closable: false,
        closeOnEscape: false,
        accept: () => resolve(true),
        reject: () => resolve(false),
      })
    });
  }
  itemagrupador: ItemsAgrupador[] = []
  async guardarCotizacion() {
    this.itemagrupador = []
    if (this.group_tabcotizacion.get('estado').value == "004") {
      this.util.ShowMessage({
        titulo: "La Cotización se encuentra en estado ANULADA y no se guardará ningún cambio realizado.", mensaje: "",
        tipo: "warning", icono: 'pi pi-exclamation-triangle'
      });
      return;
    }

    this.group_tabcotizacion.markAllAsTouched();
    this.group_datosGenerales.markAllAsTouched();
    this.group_datosAdicionales.markAllAsTouched();
    const errorMessage: string[] = [];
    const validateFormGroup = (formGroup: FormGroup, groupName: string) => {
      Object.entries(formGroup.controls).forEach(([controlName, control]) => {
        if (control.invalid && control.errors?.['required']) {
          errorMessage.push(`El campo "${controlName}" en "${groupName}" es obligatorio.`);
        }
      });
    };

    validateFormGroup(this.group_tabcotizacion, 'Cotización');
    validateFormGroup(this.group_datosGenerales, 'Datos Generales');
    validateFormGroup(this.group_datosAdicionales, 'Datos Generales');

    if (errorMessage.length > 0) {
      if (errorMessage.length === 1) {
        this.util.ShowMessage({
          titulo: 'ERROR',
          mensaje: errorMessage[0],
          tipo: 'warning',
        });
      } else {
        this.util.ShowMessage({
          titulo: 'ERROR',
          mensaje: 'Se han encontrado los siguientes errores. Revisar los detalles.',
          tipo: 'warning',
          detalle: errorMessage.join('\n'),
        });
      }
      return;
    }

    // obtener datos para el crud


    let totalVenta = 0;
    let totalCosto = 0;
    let totalProfitMinimo = 0;
    let totalProfitFijo = 0;
    let totalNuevoProfit = 0;

    this.servicioslocales_datadetalle.forEach((rowdata: any) => {
      const valorCosto = Number(rowdata['dope_preciounitcosto']) || 0;
      const valorVenta = Number(rowdata['dope_preciounitvta']) || 0;
      const valorProfitFijo = Number(rowdata['profit_fijo']) || 0;
      const tipoprofitm = rowdata['tipoprofitm'];
      const profitMinimo = tipoprofitm === '002' ? (valorProfitFijo * Number(rowdata['profitminimo'])) / 100 : Number(rowdata['profitminimo']);
      const tipoCambio = Number(rowdata['tipocambioventa']) || 0;

      const costoDolares = rowdata['tipo_codmnd'] === '001'
        ? valorCosto / tipoCambio
        : valorCosto;

      const ventaDolares = rowdata['tipo_codmndventa'] === '001'
        ? valorVenta / tipoCambio
        : valorVenta;

      const pfminimoDolares = rowdata['tipomonedam'] === '001'
        ? profitMinimo / tipoCambio
        : profitMinimo;

      const pftfijoDolares = rowdata['tipo_codmndprofit'] === '001'
        ? valorProfitFijo / tipoCambio
        : valorProfitFijo;

      const nuevoProfit = Math.round((ventaDolares - Number(costoDolares.toFixed(2))) * 100) / 100;

      totalVenta += ventaDolares;
      totalCosto += costoDolares;
      totalProfitMinimo += pfminimoDolares;
      totalProfitFijo += pftfijoDolares;
      totalNuevoProfit += nuevoProfit;
    });
    let MensajeError: string;
    // if (Number(totalNuevoProfit) < 0) {
    //   MensajeError = 'El profit total es negativo';
    // } else {
    //   if (Number(totalNuevoProfit) < Number(totalProfitFijo)) {
    //     if (Number(totalNuevoProfit) < totalProfitMinimo) {
    //       MensajeError = 'El profit total es menor al profit mínimo total';
    //     } else {
    //       MensajeError = 'El profit total es menor al profit local total';
    //     }
    //   }
    // }

    if (MensajeError != null || MensajeError != undefined) {
      const confirmado = await this.confirmarContinuar(`${MensajeError} ¿Está seguro que desea continuar?`);
      if (!confirmado) {
        return;
      }
    }

    const request = <CrudOrdenesVentaRequest>{};
    request.pintCCOT_Numero = (this.datosRecibidos && this.datosRecibidos.ccot_numero != null) ? this.datosRecibidos.ccot_numero : 100;// 1. pintCCOT_Numero
    request.psinCCOT_Tipo = 1// 2. psinCCOT_Tipo
    request.psinEMPR_Codigo = 1//3. psinEMPR_Codigo
    request.psinSUCR_Codigo = 1// 4. psinSUCR_Codigo 1
    request.pvchCCOT_NumDoc = (this.datosRecibidos && this.datosRecibidos.ccot_numdoc != null) ? this.datosRecibidos.ccot_numdoc : "2024-3342"; // 5. pvchCCOT_NumDoc
    request.pintCCOT_NumPadre = (this.datosRecibidos && this.datosRecibidos.ccot_numpadre != null) ? this.datosRecibidos.ccot_numpadre : null; // 6. pintCCOT_NumPadre SIEMPRE NULL
    request.psinCCOT_TipoPadre = (this.datosRecibidos && this.datosRecibidos.ccot_tipopadre != null) ? this.datosRecibidos.ccot_tipopadre : null;// 7. psinCCOT_TipoPadre NULL
    request.psinCCOT_Version = this.group_tabcotizacion.value["version"] ?? null // 8. psinCCOT_Version 1
    request.pbitCCOT_Propia = this.group_tabcotizacion.value["cotizacionpropia"] || false// 9. pbitCCOT_Propia
    request.pintENTC_CodCliente = parseInt(this.codigoRazonSocial);
    request.pintENTC_CodTransportista = this.codTransporte;
    request.pintENTC_CodBroker = null // 12. pintENTC_CodBroker NULL
    request.pintENTC_CodAgente = this.codAgente ?? null// 13
    request.pintENTC_CodCustomer = this.codCustomer ?? null // 14
    request.pintENTC_CodEjecutivo = this.codEjecutivo ?? null// 15
    request.pintCCOT_NumPresupuesto = this.group_tabcotizacion.value["numerocrm"]// PREGUNTAR como se genera este valor, en la bd a veces es null 16. pintCCOT_NumPresupuesto
    request.pdtmCCOT_FecEmi = this.util.formatearfecha(this.group_tabcotizacion.value["fechaemision"], "yyyy-MM-ddTHH:mm:ss");// 17. pdtmCCOT_FecEmi
    request.pdtmCCOT_FecVcto = this.util.formatearfecha(this.group_tabcotizacion.value["fechavencimiento"], "yyyy-MM-ddTHH:mm:ss");// 18. pdtmCCOT_FecVcto
    request.pbitCCOT_ServicioLogistico = this.group_tabcotizacion.value["serviciologistico"] || false// 19. pbitCCOT_ServicioLogistico
    request.pbitCCOT_VoBoGateIn = false // PREGUNTAR siempre 0 en la bd 20. pbitCCOT_VoBoGateIn 
    request.pbitCCOT_CargaRefrigerada = this.group_datosAdicionales.value["cargarefrigerada"]// 21. pbitCCOT_CargaRefrigerada
    request.pnumCCOT_Temperatura = this.group_datosAdicionales.value["temperatura"]// PREGUNTAR sale siempre con 0.0000 22. pnumCCOT_Temperatura
    request.pbitCCOT_CargaPeligrosa = this.group_datosAdicionales.value["cargapeligrosa"]// 23. pbitCCOT_CargaPeligrosa
    request.pbitCCOT_Roundtrip = this.group_datosAdicionales.value["roundtrip"]// 24. pbitCCOT_Roundtrip
    request.pvchCCOT_Observaciones = this.group_datosAdicionales.value["instrucciones"] ? this.group_datosAdicionales.value["instrucciones"] : ""; // 25. pvchCCOT_Observaciones
    request.pdtmCCOT_FecCierre = null// 26. pdtmCCOT_FecCierre NULL 
    request.psinCCOT_Almacenaje = this.group_datosAdicionales.value["almacenaje"]// 27. psinCCOT_Almacenaje
    request.psinCCOT_SobreEstadia = (this.group_datosAdicionales.value["sobreestadia"] != null && this.group_datosAdicionales.value["sobreestadia"] !== " ") ? this.group_datosAdicionales.value["sobreestadia"] : 0; // 28. psinCCOT_SobreEstadia
    request.psinCCOT_TiempoViaje = this.group_datosAdicionales.value["tiempoviaje"]// 29. psinCCOT_TiempoViaje
    request.psinCCOT_ValidezOferta = this.group_datosAdicionales.value["validezoferta"]// 30. psinCCOT_ValidezOferta
    request.pchrTIPO_TabINC = "INC" //PREGUNTAR null o INC, con q esta relacionado // 31. pchrTIPO_TabINC
    request.pchrTIPO_CodINC = this.group_tabcotizacion.value["incoterm"]// 32. pchrTIPO_CodINC
    request.pchrTIPO_TabImo = "IMO"// 33. pchrTIPO_TabImo
    request.pchrTIPO_CodImo = this.group_datosAdicionales.value["imoclass"]// 34. pchrTIPO_CodImo
    request.pvchCCOT_ImoUN = this.group_datosAdicionales.value["imoun"]// siempre es null, lo bloqueo ?35. pvchCCOT_ImoUN
    request.pintCONT_Codigo = this.cont_codigo // 36. pintCONT_Codigo 
    request.pchrCONS_TabRGM = "RGM";//37. pchrCONS_TabRGM
    request.pchrCONS_CodRGM = this.group_tabcotizacion.value["regimen"];//38. pchrCONS_CodRGM
    request.pchrCONS_TabVia = "VIA";// 39. pchrCONS_TabVia
    request.pchrCONS_CodVia = this.group_tabcotizacion.value["via"];//40. pchrCONS_CodVia       
    request.pchrCONS_TabFLE = "FLE";// 41. pchrCONS_TabFLE
    request.pchrCONS_CodFLE = this.group_datosGenerales.value["condicion"]; // 42. pchrCONS_CodFLE
    request.pchrCONS_TabEST = "COT";// PREGUNTAR es orden de venta y por eso siempre va con ove ? 43. pchrCONS_TabEST 
    request.pchrCONS_CodEST = this.group_tabcotizacion.value["estado"];// PREGUNTAR en nextsoft aparece por defecto ingresado 44. pchrCONS_CodEST
    request.pintPUER_CodDestino = this.group_datosGenerales.value["puertodestino"];
    request.pintPUER_CodTrasbordo = this.group_datosGenerales.value["puertotransbordo"]
    request.pintPUER_CodOrigen = this.group_datosGenerales.value["puertoorigen"]
    request.pvchCCOT_UsrAprueba = null// 48. pvchCCOT_UsrAprueba n
    request.pdtmCCOT_FecAprueba = this.util.formatearfecha(this.group_tabcotizacion.value["fechaaprobacion"], "yyyy-MM-ddTHH:mm:ss")// 49. pdtmCCOT_FecAprueba
    request.pvchCCOT_UsrAceptaRechaza = null// 50. pvchCCOT_UsrAceptaRechaza
    request.pdtmCCOT_FecAceptaRechaza = null// PREGUNTAR que es, no se q dato, no sale en el html va 51. pdtmCCOT_FecAceptaRechaza NULL
    request.pchrTIPO_TabMOT = (this.datosRecibidos && this.datosRecibidos.tipo_tabmot != null) ? this.datosRecibidos.tipo_tabmot : null; // 52. pchrTIPO_TabMOT tipo e y t
    request.pchrTIPO_CodMOT = (this.datosRecibidos && this.datosRecibidos.tipo_codmot != null) ? this.datosRecibidos.tipo_codmot : null;  // 53. pchrTIPO_CodMOT
    request.pintENTC_CodShipper = this.codShipper ?? null;
    request.pintENTC_CodConsignee = this.codConsignee ?? null;
    request.pintENTC_CodNotify = this.codNotify ?? null;
    request.pchrCONS_TabTFT = "TFT"// PREGUNTAR siempre TFT o null en la bd 57. pchrCONS_TabTFT
    request.pchrCONS_CodTFT = this.group_datosGenerales.value["tipofechatarifa"]// 58. pchrCONS_CodTFT
    request.pdtmCCOT_FecTarifa = this.util.formatearfecha(this.group_datosGenerales.value["fechatarifa"], "yyyy-MM-ddTHH:mm:ss");//.toISOString().slice(0, 19).replace('T', ' ')// 59. pdtmCCOT_FecTarifa
    request.pchrCCOT_PagoMBL = this.group_datosGenerales.value["pcmbl"] ?? ''// 60. pchrCCOT_PagoMBL pcmbl
    request.pchrCCOT_PagoHBL = this.group_datosGenerales.value["pchbl"] ?? ''// 61. pchrCCOT_PagoHBL
    request.pchrTIPO_TabMND = "MND"// 62. pchrTIPO_TabMND
    request.pchrTIPO_CodMND = this.group_datosGenerales.value["moneda"]// 63. pchrTIPO_CodMND
    request.pvchDOOV_Cntr = this.codContenedor // en la bd sale null o con data 64. pvchDOOV_Cntr contenedor
    request.pchrDOOV_HBL =null //esto se comenta por que la cotizacion no tiene HBL (this.datosRecibidos && this.datosRecibidos.doov_hbl != null) ? this.datosRecibidos.doov_hbl : null; //PREGUNTAR se genera automatica en la bd, lo bloqueo ? // 65. pchrDOOV_HBL
    request.pchrDOOV_MBL = null //esto se comenta por que la cotizacion no tiene MBL (this.datosRecibidos && this.datosRecibidos.ddov_fecrecbooking != null) ? this.datosRecibidos.ddov_fecrecbooking : null; // PREGUNTAR se genera automatica en la bd, lo bloqueo ? 66. pchrDOOV_MBL
    request.pvchDDOV_NroBooking =  null //esto se comenta por que la cotizacion no tiene booking(this.datosRecibidos && this.datosRecibidos.ddov_nrobooking != null) ? this.datosRecibidos.ddov_nrobooking : null;// se genera automatico en la bd 67. pvchDDOV_NroBooking
    request.pdtmDDOV_FecRecBooking = (this.datosRecibidos && this.datosRecibidos.ddov_fecrecbooking != null) ? this.datosRecibidos.ddov_fecrecbooking : null;// PREGUNTAR no sale en el html 68. pdtmDDOV_FecRecBooking NULL
    request.pdtmDDOV_FecEmbarque = (this.datosRecibidos && this.datosRecibidos.ddov_fecembarque != null) ? this.datosRecibidos.ddov_fecembarque : null; // no se q valor es 69. pdtmDDOV_FecEmbarque
    request.pintENTC_CodDepTemporal = this.codDeposito;
    request.pvchDOOV_CodReferencia = this.group_datosAdicionales.value["referencia"]// 71. pvchDOOV_CodReferencia
    request.pintNVIA_Codigo = null //esto se comenta por que la cotizacion no tiene NVIA CODIGO //(this.datosRecibidos && this.datosRecibidos?.nvia_codigo != null) ? this.datosRecibidos.nvia_codigo : 0;
    //this.datosRecibidos.nvia_codigo //Number(this.group_tabcotizacion.value["via"])// 72. pintNVIA_Codigo
    request.pvchDOOV_Feeder_IMPO = (this.datosRecibidos && this.datosRecibidos.doov_feeder_impo != null) ? this.datosRecibidos.doov_feeder_impo : null; // PREGUNTAR de donde sale este dato, null o con data en la bd 73. pvchDOOV_Feeder_IMPO NULL
    request.pdtmDOOV_FecETDFeeder_IMPO = (this.datosRecibidos && this.datosRecibidos.doov_fecetdfeeder_impo != null) ? this.datosRecibidos.doov_fecetdfeeder_impo : null; // PREGUNTAR de donde sale este dato, null o con data en la bd 74. pdtmDOOV_FecETDFeeder_IMPO NULL
    request.pbitDDOV_HBLNieto = null// 75. pbitDDOV_HBLNieto
    request.pbitCCOT_ServicioTransmision = null // 76. pbitCCOT_ServicioTransmision NULL
    request.pchrTIPO_TabTRF = "TRF"// PREGUNTAR TRF o null 77. pchrTIPO_TabTRF
    request.pchrTIPO_CodTRF = this.group_datosGenerales.value["trafico"]// 78. pchrTIPO_CodTRF
    request.pbitCCOT_EnviaAvisoLlegada = null // 79. pbitCCOT_EnviaAvisoLlegada 
    request.pchrCONS_TabLNG = "LNG"// PREGUNTAR siempre LNG o null en la bd 80. pchrCONS_TabLNG
    request.pchrCONS_CodLNG = this.group_tabcotizacion.value["lineanegocio"]// 81. pchrCONS_CodLNG
    request.pvchAUDI_UsrCrea = this.nombreUsuario// 82. pvchAUDI_UsrCrea
    request.pvchAUDI_UsrMod = this.nombreUsuario
    request.pvchCCOT_OrdenCompra = null // falta bloquear 83. pvchCCOT_OrdenCompra
    request.sli = false
    request.tablaFlete = []
    request.tablaServicio = []
    request.transportistasAdicionales = []
    request.pvch_ccot_descshipper = this.group_datosAdicionales.value["desc_shipper"]
    request.pvch_ccot_descconsignee = this.group_datosAdicionales.value["desc_consignee"]

    const datosembarqueMap = new Map<string, any>();
    this.datosembarque_dataflete.forEach((item, i) => {
      if (item.dcot_item) {
        datosembarqueMap.set(item.dcot_item ?? i, item);
      }
    });
    console.log(request.tablaFlete)
    request.tablaFlete = request.tablaFlete || [];
    let filasGuardadas: any[] = [];

    // if (this.serviciosytarifas_dataflete.length > 1 && this.serviciosytarifas_dataflete.every(item => item.ESTADO_OBJ !== "D")) {
    //   filasGuardadas = this.serviciosytarifas_dataflete.filter(fila => fila.select === true);

    //   if (filasGuardadas.length === 0) {
    //     this.util.ShowMessage({
    //       titulo: "Error", mensaje: "Debe elegir al menos un transportista como principal.", icono: "Error", tipo: "error"
    //     });
    //     return;
    //   }
    // } else {
    //   filasGuardadas = this.serviciosytarifas_dataflete;
    // }

    filasGuardadas = this.serviciosytarifas_dataflete.filter(row => row.ESTADO_OBJ !== 'D') || [];

    filasGuardadas.forEach((item, i) => {
      const datosembarqueItem = datosembarqueMap.get(item.dcot_item);
      const unmCod = this.ListaUnidadMedida.find(r => r.label === this.extraerLabelSinObjeto(datosembarqueItem?.unm_desc));
      const cdtCod = this.ListaComodity.find(r => r.label === datosembarqueItem?.cdt_desc);
      const estadoObj = item.ESTADO_OBJ !== undefined ? item.ESTADO_OBJ : "NA";

      if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
        const itemTablaFlete = {
          CCOT_Tipo: request.psinCCOT_Tipo || 1,
          CCOT_Numero: request.pintCCOT_Numero || 0,
          DCOT_Item: item.dcot_item ?? i,
          PACK_Codigo: item.paqueteObj?.value ?? item.pacK_Codigo ?? item.pack_codigo,
          DCOT_Producto: datosembarqueItem ? datosembarqueItem?.dcot_producto || " " : " ",
          DCOT_Cantidad: item.dcot_cantidad || 1.0000,
          DCOT_PrecioUniCosto: item.dcot_preciounicosto || 0.00,
          DCOT_TotalUniCosto: item.dcot_totalunicosto || 0.00,
          DCOT_TotalUniVenta: item.dcot_totaluniventa || 0.00,
          DCOT_PrecioUniVenta: item.dcot_preciouniventa || 0.00,
          DCOT_Importe: item.dcot_importe || 0.00,
          DCOT_Peso: datosembarqueItem ? datosembarqueItem?.dcot_peso || 0.00 : 0.00,
          DCOT_Volumen: datosembarqueItem ? datosembarqueItem?.dcot_volumen || 0.00 : 0.00,
          DCOT_Bultos: datosembarqueItem ? datosembarqueItem?.dcot_bultos || 0.00 : 0.00,
          DCOT_Largo: datosembarqueItem ? datosembarqueItem?.dcot_largo || 0.00 : 0.00,
          DCOT_Ancho: datosembarqueItem ? datosembarqueItem?.dcot_ancho || 0.00 : 0.00,
          DCOT_Alto: datosembarqueItem ? datosembarqueItem?.dcot_alto || 0.00 : 0.00,
          TIP_TabUnm: "UNM", // item.tipo_tabunm || 
          TIP_CodUnm: unmCod ? unmCod.value : null,
          TIP_TabCDT: "CDT", // item.tipo_tabcdt || 
          TIP_CodCDT: cdtCod ? cdtCod.value : null,
          TARI_Codigo: item.tari_codigo || null,
          AUDI_UsrMod: this.nombreUsuario || null,
          AUDI_UsrCrea: this.nombreUsuario || null,
          SERV_Codigo: null,
          ESTADO_OBJ: estadoObj,
          itemAnterior: item.dcot_item ?? i,
        };
        request.tablaFlete.push(itemTablaFlete);
      }
    });

    // obtener datos servicio

    request.tablaServicio = request.tablaServicio || [];
    this.serviciosytarifas_dataservicios.forEach((item) => {
      const servicio = this.ListaServiciosByViaRgmLngDP.find(r => r.label === item.serv_nombre);
      const moneda = this.ListaMoneda.find(r => r.label === item.tipo_descmnd || r.value === item.tipo_descmnd);
      const entidad = this.ListaTipoEntidad.find(r => r.label === item.tipedescripcion);
      const proveedor = this.ListaProveedorG.find(r => r.label === item.entc_nomcom);
      const base = this.ListaBase.find(r => r.label === item.cons_desc_spa || r.value === item.cons_desc_spa);
      const ingeg = this.ListaServicio.find(r => r.label === item.ccot_ingresogasto || r.value === item.ccot_ingresogasto);
      const codTDO = this.ListaTipoDocumento.find(r => r.label === item.tipo_desctdo);

      const estadoObj = item.ESTADO_OBJ !== undefined ? item.ESTADO_OBJ : "NA";

      if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
        const itemTablaServicio = {
          CCOT_Tipo: request.psinCCOT_Tipo || 1,
          CCOT_Numero: request.pintCCOT_Numero || null,
          SCOT_Item: item.scot_item,
          CCOT_IngresoGasto: (ingeg && ingeg.value === '001') || item.ccot_ingresogasto.value === '001' ? "I" :
            (ingeg && ingeg.value === '002') || item.ccot_ingresogasto.value === '002' ? "E" :
              ingeg ? ingeg.value : item.ccot_ingresogasto.value,
          SERV_Codigo: servicio ? Number(servicio.value) : item.serv_nombre.value,
          SCOT_Origen: "D",
          SCOT_Cantidad: item.scot_cantidad || null,
          SCOT_PrecioUni: item.scot_preciouni || null,
          SCOT_Importe_Ingreso: item.scot_importe_ingreso || 0.00,
          SCOT_Importe_Egreso: item.scot_importe_egreso || 0.00,
          TIPO_TabMnd: "MND",
          TIPO_CodMnd: item.tipo_descmnd.value ?? moneda.value ?? moneda.label,
          SCOT_PreSugerido: 0.00,
          TIPE_Codigo: entidad ? entidad.value : item.tipedescripcion.value,
          ENTC_Codigo: proveedor ? proveedor.value : item.entc_nomcom.value,
          TARI_Codigo: item.tari_codigo || null,
          CONS_TabBas: item.cons_desc_spa.nombre || "BAS",
          CONS_CodBas: item.cons_desc_spa.value ?? base.value,
          SCOT_Exonerado: item.scot_exonerado || false,
          SCOT_ChageControl: false,
          PFAC_Numero: null,
          TIPO_TabTDO: "TDO",
          TIPO_CodTDO: codTDO ? (codTDO.value || null) : null,
          SCOT_NumeroTDO: item.scot_numerotdo || " ",
          SCOT_SerieTDO: item.scot_serietdo || null,
          AUDI_UsrMod: this.nombreUsuario || null,
          AUDI_UsrCrea: this.nombreUsuario || null,
          SCOT_FechaOperacion: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
          SCOT_FechaEmision: this.util.formatearfecha(item.audi_feccrea, "yyyy-MM-ddTHH:mm:ss") || null,
          EMPR_Codigo: 1,
          CCCT_Codigo: 0,
          SCOT_FechaPrefactura: null,
          SCOT_ItemChangeControl: 1,
          SCOT_CodMotivo: null,
          SCOT_Solicitante: " ",
          SCOT_Autoriza: " ",
          AUDI_FecCrea: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
          ESTADO_OBJ: estadoObj,
        };

        request.tablaServicio.push(itemTablaServicio);
      }
    });

    this.servicioslocales_detalleAgrupacion = this.servicioslocales_detalleAgrupacion.map(item => ({
      ...item,
      tipotran: item.ESTADO_OBJ
    }));

    // Crear un nuevo array con solo los campos necesarios
    this.itemagrupador = this.servicioslocales_detalleAgrupacion.map(item => ({
      CODE_Agrupador: item.dope_item ?? null,
      COPE_Codigo: item.cope_codigo ?? null,
      SERV_Descripcion: item.serv_nombre_spa ?? null,
      CTAR_Codigo: item.ctar_codigo ?? null,
      DTAR_Codigo: item.dtar_codigo ?? null,
      RTAR_Codigo: item.rtar_codigo ?? null,
      DOPE_PrecioUnitVta: item.dope_preciounitvta ?? null,
      DOPE_Cantidad: item.dope_cantidad ?? null,
      DOPE_PrecioTotVta: item.dope_preciototvta ?? null,
      DOPE_PrecioUnitCosto: item.dope_preciounitcosto ?? null,
      DOPE_PrecioTotCosto: item.dope_preciototcosto ?? null,
      AUDI_Usuario: this.nombreUsuario,
      tipotran: item.ESTADO_OBJ,
    }));

    request.request_sli = {} as ServiciosLocalesRequest;
    request.request_sli.tablaagrupador = this.itemagrupador;

    // obtener data servicios locales

    request.request_sli.cope_codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
      this.datosRecibidos["listadooperaciones"].length > 0)
      ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
      : 0;
    const cope_codigo = this.group_tarifasAdicionales.get('codigooperacion')?.value;
    request.request_sli.ESTADO_OBJ = this.accion === 'NUEVO' ? 'I' : cope_codigo == null || cope_codigo == '' || cope_codigo == 0 ? 'I' : 'U'; // aqui
    request.request_sli.cope_numdoc = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
      this.datosRecibidos["listadooperaciones"].length > 0)
      ? this.datosRecibidos["listadooperaciones"][0].cope_numdoc
      : null;
    request.request_sli.cope_fecemi = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
      this.datosRecibidos["listadooperaciones"].length > 0)
      ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi
      : new Date();
    request.request_sli.cope_observacion = null;
    request.request_sli.cope_hbl = this.datosRecibidos != null ? this.datosRecibidos.doov_hbl ?? ' ' : "  ";
    request.request_sli.ccot_codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
      this.datosRecibidos["listadooperaciones"].length > 0)
      ? this.datosRecibidos["listadooperaciones"][0].ccot_codigo
      : null;
    request.request_sli.ccot_numero = this.datosRecibidos != null ? this.datosRecibidos.ccot_numero : null;
    request.request_sli.ccot_tipo = "1";
    request.request_sli.entc_codcliente = parseInt(this.group_tarifasAdicionales.get('clienteDSL')?.value ?? this.codigoRazonSocial);
    request.request_sli.entc_codtransporte = this.codTransporte;
    request.request_sli.entc_codagente = this.codAgente
    request.request_sli.cons_codestado = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
      this.datosRecibidos["listadooperaciones"]?.length > 0)
      ? this.datosRecibidos["listadooperaciones"][0].cons_codestado
      : '001';
    request.request_sli.cons_tabestado = "OPE";
    request.request_sli.cope_excepcion = null;
    request.request_sli.cope_fob = 0.00;
    request.request_sli.cope_seguro = 0.00;
    request.request_sli.cope_flete = 0.00;
    request.request_sli.cope_cif = 0.00;
    request.request_sli.cope_partarancelaria = 0.00;
    request.request_sli.cope_ipm = 0.00;
    request.request_sli.cope_igv = 0.00;
    request.request_sli.cope_percepcion = 0.00;
    request.request_sli.cope_tasadespacho = 0.00;
    request.request_sli.cope_advalorem = 0.00;
    request.request_sli.cope_1erembarque = null;
    request.request_sli.audi_usrmod = this.nombreUsuario;
    request.request_sli.audi_usrcrea = this.nombreUsuario;
    request.request_sli.tipo_tabmnd = "MND";
    request.request_sli.tipo_codmnd = this.group_datosGenerales.value["moneda"]
    request.request_sli.cons_codcrg = null;  // preguntar a miguel
    request.request_sli.cons_tabcrg = "CRG";
    request.request_sli.ccot_codaduana = null;
    request.request_sli.ccot_codlogistico = null;
    request.request_sli.ccot_codtransporte = null;
    request.request_sli.cope_nave = null;
    request.request_sli.cope_viaje = null;
    request.request_sli.cope_mbl = ' ';// preguntar
    request.request_sli.cope_fechaarribo = null;
    request.request_sli.cope_cantidaddias = null;
    request.request_sli.cope_kilos = null;
    request.request_sli.cope_volumen = null;
    request.request_sli.cope_preciosada = null;
    request.request_sli.entc_codagenport = null;
    request.request_sli.entc_codtermport = null;
    request.request_sli.entc_coddeptemporal = null;
    request.request_sli.ctar_codigo = this.idTarifa !== undefined
      ? this.idTarifa
      : ((this.datosRecibidos != null && this.datosRecibidos["listadotarifaasociada"] &&
        this.datosRecibidos["listadotarifaasociada"].length > 0)
        ? this.datosRecibidos["listadotarifaasociada"][0].ctar_codigo
        : null);
    request.request_sli.ctar_version = 1;
    request.request_sli.entc_codtransterre = this.group_tarifasAdicionales.get('transportistaTerre')?.value || null;
    request.request_sli.cope_version = 1;
    request.request_sli.cons_codlng = "003";// this.group_tabcotizacion.value["lineanegocio"];
    request.request_sli.cons_tablng = "LNG";
    request.request_sli.cons_codrgm = this.group_tabcotizacion.get('regimen')?.value
    request.request_sli.cons_tabrgm = "RGM";
    request.request_sli.cons_codvia = this.group_tabcotizacion.get('via')?.value
    request.request_sli.cons_tabvia = "VIA";
    request.request_sli.cope_fechaSL = this.group_tarifasAdicionales.get('fechasl')?.value ?? null;
    request.request_sli.cope_dam = this.group_tarifasAdicionales.get('montodam')?.value ?? null;
    const ruta = this.group_tarifasAdicionales.get('rutas')?.value;
    request.request_sli.codigo_ruta = ruta != null && ruta != '' ? Number(ruta) : null;
    request.request_sli.cope_cifVta = this.group_tarifasAdicionales.get('cifEjecVta')?.value ?? null;
    request.request_sli.cope_cifLog = this.group_tarifasAdicionales.get('cifLogistico')?.value ?? null;
    request.request_sli.cope_peso_sli = this.group_tarifasAdicionales.get('peso')?.value ?? null;
    request.request_sli.cope_unmd_peso = this.group_tarifasAdicionales.get('unmd_peso')?.value ?? null;
    request.request_sli.cope_tab_unmd_peso = request.request_sli.cope_unmd_peso != null ? 'UNM' : null;
    request.request_sli.cope_volumen_sli = this.group_tarifasAdicionales.get('volumen')?.value ?? null;
    request.request_sli.cope_unmd_volumen = this.group_tarifasAdicionales.get('unmd_volumen')?.value ?? null;
    request.request_sli.cope_tab_unmd_volumen = request.request_sli.cope_unmd_volumen != null ? 'UNM' : null;

    // obtener autorizaciones
    request.request_sli.listaAutorizacionSLI = {} as AutorizacionSliRequest;
    const resp = this.verificarCambiosPorAutorizar();
    if (resp.resultado) {
      {
        const requestAutorizacionSli: AutorizacionSliRequest = {
          cope_codigo: request.request_sli.cope_codigo,
          entc_codcliente: parseInt(this.group_tarifasAdicionales.get('clienteDSL')?.value ?? request.pintENTC_CodCliente),
          usuario: this.storage.get('nombreusr'),
          ccot_numdoc: request.pvchCCOT_NumDoc,
          nombre_cliente: this.group_tabcotizacion.get('razonSocial')?.value,
          correo_remitente: this.storage.get('correo'),
          tbl_operaciones: resp.datos.map(item => ({
            dope_item: item.dope_item ?? null,
            serv_codigo: item.serv_codigo ?? null,
            monto_solicitado: item.precio_modificado ?? null,
            desc_moneda_solicitado: item.desc_moneda_solicitado ?? null,
            cod_moneda_solicitado: item.cod_moneda_solicitado ?? null,
            tab_moneda_solicitado: item.tab_moneda_solicitado ?? null,
            monto_original: item.precio_original ?? null,
            desc_moneda_original: item.precio_desc_mnd ?? null,
            cod_moneda_original: item.precio_cod_mnd ?? null,
            tab_moneda_original: item.precio_tab_mnd ?? null,
            servicio: item.nombre_servicio ?? null,
            tipoauth: item.tipo ?? null
          })),
          cope_numdoc: request.request_sli.cope_numdoc,
          hbl: request.pchrDOOV_HBL,
        };
        request.request_sli.listaAutorizacionSLI = requestAutorizacionSli;
      }
    }
    console.log("request.request_sli.listaAutorizacionSLI", request.request_sli.listaAutorizacionSLI)

    // obtener det de SL

    console.log('this.servicioslocales_datadetalle al guardar', this.servicioslocales_datadetalle)
    const listaDetSL: DetalleServiciosLocalesRequest[] = [];

    this.servicioslocales_datadetalle.forEach((item: any) => {
      let estado_obj = item.ESTADO_OBJ ?? "NA";

      if (estado_obj === "A") {
        const existeEnOriginal = this.listadoOriginal.some(orig => orig.dope_item === item.dope_item);
        estado_obj = existeEnOriginal ? "U" : "I"//(!item.cons_codest ? "I" : "U");
      }
      const requestItem: DetalleServiciosLocalesRequest = {
        dope_item: item.dope_item ?? null,
        cope_codigo: (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
          this.datosRecibidos["listadooperaciones"].length > 0)
          ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
          : 0,
        cope_version: (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
          this.datosRecibidos["listadooperaciones"].length > 0)
          ? this.datosRecibidos["listadooperaciones"][0].cope_version
          : 1,
        dtar_item: item.dtar_item ?? null,
        ctar_codigo: this.idTarifa !== undefined ? this.idTarifa : item.ctar_codigo,
        ctar_tipo: item.ctar_tipo ?? null,
        pack_codigo: item.pack_codigo ?? null,
        cons_codbas: item.cons_codbas ?? null,
        cons_tabbas: item.cons_tabbas ?? "BAS",
        dope_cantidad: item.dope_cantidad ?? null,
        dope_preciounitcosto: item.dope_preciounitcosto ?? null,
        dope_preciototcosto: item.dope_preciototcosto ?? item.dope_preciounitcosto * (item.dope_cantidad || 1),
        dope_preciounitvta: item.dope_preciounitvta ?? null,
        dope_preciototvta: item.dope_preciototvta ?? null,
        dope_minimo: item.dope_minimo ?? 0.00,
        dope_peso: item.dope_peso ?? null,
        dope_volumen: item.dope_volumen ?? null,
        usr_usrmod: this.nombreUsuario,
        audi_usrcrea: this.nombreUsuario,
        dope_costosada: item.dope_costosada ?? null,
        dope_costo: item.dope_costo ?? null,
        dope_ventasada: item.dope_ventasada ?? 0.00,
        dope_venta: item.dope_venta ?? 0.00,
        tipo_tabzon: item.tipo_tabzon ?? null,
        tipo_codzonorigen: item.tipo_codzonorigen ?? null,
        cons_codtra: item.cons_codtra ?? null,
        cons_tabtra: item.cons_tabtra ?? null,
        tipo_codzondestino: item.tipo_codzondestino ?? null,
        tipe_codigo: item.tipe_codigo ?? null,
        entc_codigo: item.entc_codigo ?? null,
        cons_codest: item.cons_codest ?? null,
        cons_tabest: "EDO",
        serv_codigo: item.serv_codigo ?? null,
        tipo_tabmnd: "MND",
        tipo_codmnd: item.tipo_codmnd ?? null,
        cons_tablng: "LNG",
        cons_codlng: "003", // this.group_tabcotizacion.value["lineanegocio"],
        dope_changecontrol: item.dope_changecontrol ?? false,
        dope_itemchangecontrol: item.dope_itemchangecontrol ?? null,
        dope_fechaoperacion: item.dope_fechaoperacion ?? null,
        COPE_ProfitLocal: item.profit_local ?? null,
        profit_fijo: item.profit_fijo ?? null,
        agrupado: item.agrupado ?? null,
        CODE_Agrupador: item.cod_padre ?? null,
        DTAR_Codigo: item.dtar_codigo ?? null,
        RTAR_Codigo: item.rtar_codigo ?? null,
        monto_conversion: item.monto_conversion ?? null,
        TIPO_TabMNDCosto: item.tipo_tabmnd ?? null,
        TIPO_CodMNDCosto: item.tipo_codmnd ?? null,
        TIPO_TabMNDVenta: item.tipo_tabmndventa ?? null,
        TIPO_CodMNDVenta: item.tipo_codmndventa ?? null,
        TIPO_TabMNDProfit: item.tipo_tabmndprofit ?? null,
        TIPO_CodMNDProfit: item.tipo_codmndprofit ?? null,
        TIPO_TabTDS: item.tipo_tabtds ?? "TDS",
        TIPO_CodTDS: item.tipo_codtds ?? '001',
        esadicional: item.esadicional ?? false,
        dope_preciotot_prom: item.dope_preciotot_prom ?? null,
        dope_preciounit_prom: item.dope_preciotot_prom ?? null,
        ESTADO_OBJ: estado_obj,
        tipo_tabmsd: this.extraerValueSinObjeto(item.tipo_codmsd) != null ? "MSD" : null,
        tipo_codmsd: this.extraerValueSinObjeto(item.tipo_codmsd) ?? null,
        transportista: this.codTransporte,
        cliente: parseInt(this.codigoRazonSocial),
        mnd_tarifa: item.mnd_tarifa ?? null,
        tab_tarifa: item.tab_tarifa ?? null,
        monto_tarifa: item.monto_tarifa ?? null,
        tipo_autorizacion: item.tipo_autorizacion ?? null,
      };
      listaDetSL.push(requestItem);
    });

    request.request_sli.listaDetSL = listaDetSL;

    // obtener servicios de SL

    const listaEvenSL: EvenSiRequest[] = [];
    const length = this.listarServTariff.length;
    let itemCounter = 1;

    for (let i = 0; i < length; i++) {
      const servicio = this.listarServTariff[i];
      const item = this.servicioslocales_dataObservaciones[i] || {};

      const rItem: EvenSiRequest = {
        ccot_numero: this.datosRecibidos != null ? this.datosRecibidos.ccot_numero : 1,
        ccot_tipo: 1,
        even_item: itemCounter++,
        even_fecha: item.even_fecha || null,
        even_cumplida: false,
        even_usuario: item.even_usuario || null,
        even_observaciones: item.even_observaciones || null,
        tipo_tabeve: "EVE",
        tipo_codeve: servicio.tipe_codigo.toString(),
        cons_tabmod: "MOD",
        cons_codmod: "001",
        even_manual: false,
        audi_usrcrea: this.nombreUsuario || null,
        audi_usrmod: this.nombreUsuario || null,
        // even_filename: item.even_filename || null,
        // even_filecontent: null
      };

      listaEvenSL.push(rItem);
    }

    request.request_sli.listaEvenSL = listaEvenSL;

    switch (this.accion) {
      case "NUEVO":

        this.listartransportistasAdicionales = []
        this.asignacionTransportistasParaGuardarNuevo();
        request.transportistasAdicionales = this.listartransportistasAdicionales

        this.ordenventaService.TnsInsertarOvCot(request).subscribe(response => {
          const codOVgenerada = response.datos.codigoEntidad
          if (response.datos.status === 200) {
            this.setFiltrosBusqueda();
            const numeroDocumento = response.datos?.numeroDocumento ?? ''
            this.util.MessageDialog({ titulo: "Cotización", mensaje: "Se guardó correctamente la cotización: " + numeroDocumento, icono: "OK", tipo: "ok", });
            this.router.navigate([this.rutaComponente]);
            this.ngOnDestroy()
          }
        }, (err) => {
          const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
          this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
          console.error("Error en handleAdditionalInserts:", err);
        });

        break;
      case "EDITAR":
        request.transportistasAdicionales = this.listartransportistasAdicionales

        this.ordenventaService.TnsEditarOvCot(request).subscribe(response => {
          const codOVgenerada = response.datos.codigoEntidad
          if (response.datos.status === 200) {
            this.setFiltrosBusqueda();
            this.util.MessageDialog({ titulo: "Cotización", mensaje: "Se actualizó correctamente", icono: "OK", tipo: "ok" });
            this.router.navigate([this.rutaComponente]);
            this.ngOnDestroy()
          }
        }, (err) => {
          const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
          this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
          console.error("Error en handleAdditionalInserts:", err);
        });

        break;
      default:
        break;
    }
  }

  Salir(path: string): void {



    this.setFiltrosBusqueda();
    localStorage.removeItem('listadoservicio');
    localStorage.removeItem('datoov');
    this.router.navigate([this.rutaComponente]);
    this.ngOnDestroy()

    const reuseStrategy = this.injector.get(RouteReuseStrategy) as any;
    if (reuseStrategy.clearRoute) {
      reuseStrategy.clearRoute("NuevaCotizacion");
    }
  }

  metadatableFlete: newmetadate[] = [ // original
    { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete, maxWidth: "40px", widthInput: "100px" },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: 'int', operacion: 'multiplicar', maxWidth: "20px",
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar', maxWidth: "20px",
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL VENTA2', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado', maxWidth: "20px" },
  ]

  metadatableFlete1ConCostos: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete, style: { width: "40%" } },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: 'int', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' },
      { columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
      , style: { width: "12%" }
    },
    {
      title: 'P.U. COSTO', field: 'dcot_preciounicosto', filterType: 'numeric', inputType: 'decimal', inputStatus: 'lock', operacion2: 'multiplicar2', style: { width: "12%" },
      relacionMultiplicacion: [{ columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
      , style: { width: "12%" }
    },
    { title: 'TOTAL COSTO', field: 'dcot_totalunicosto', filterType: 'numeric', inputType: 'decimalResultado2', rowFooter: 'sum', inputStatus: 'lock', style: { width: "12%" } },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado', style: { width: "12%" } },
  ]

  inputtype: inputType = 'decimal';
  metadatableFlete1: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: this.inputtype, operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' },
      { columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. COSTO', field: 'dcot_preciounicosto', filterType: 'numeric', inputType: 'decimal', inputStatus: 'lock', operacion2: 'multiplicar2',
      relacionMultiplicacion: [{ columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL COSTO', field: 'dcot_totalunicosto', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum', inputStatus: 'lock' },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado' },
  ]

  metadatableFlete2: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: this.inputtype, operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado' },
  ]

  metadatableFlete2ConCostos: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: this.inputtype, operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado' },
  ]

  inicializarMetadate() {
    this.metadatableTarifas = [
      { title: 'ORIGEN', field: 'eta_contable', filterType: 'text', inputType: 'text' },
      { title: 'DESTINO', field: 'eta_operativo', filterType: 'text', inputType: 'text' },
      { title: 'TRANSPORTISTA', field: 'nvia_feccutoff_expo', filterType: 'text', inputType: 'text' },
      { title: 'CONTRATO', field: 'fechallegada', filterType: 'numeric', inputType: 'int' },
      { title: 'PAQUETE', field: 'fechazarpe', filterType: 'text', inputType: 'text' },
      { title: 'CANTIDAD', field: 'fechaarribo', filterType: 'numeric', inputType: 'int' },
      { title: 'FECHA INICIO', field: 'nvia_feccierredire_impo_termemba_expo', filterType: 'text', inputType: 'date' },
      { title: 'FECHA FIN', field: 'nvia_fecdescarga_impo', filterType: 'text', inputType: 'date' },
      { title: 'SOBRESTADIA', field: 'nvia_fecplazovistobueno', filterType: 'numeric', inputType: 'int' },
      { title: 'VALOR', field: 'nvia_nromanifiesto', filterType: 'numeric', inputType: 'decimal' },
      { title: 'TOTAL', field: 'nvia_normanifiestodescon', filterType: 'numeric', inputType: 'decimal' }
    ]
    // if (this.isadmin == true) {
    //   this.metadatableFlete = [
    //     { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
    //     // { title: 'TRANSPORTISTA', field: 'transportistaObj', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosTransportistaDP },
    //     // { title: 'NÚMERO CONTRATO', field: 'contrato', filterType: 'text', inputType: 'text' },
    //     // { title: 'DESCRIPCIÓN', field: 'descripcion', filterType: 'text', inputType: 'text' },
    //     { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', filterType: 'text', dropdown: this.ListaTipoPaqueteDP },
    //     {
    //       title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'text', inputType: 'int', operacion: 'multiplicar',
    //       relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' },
    //       { columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    //     },
    //     {
    //       title: 'P.U. COSTO', field: 'dcot_preciounicosto', filterType: 'numeric', inputType: 'decimal', operacion2: 'multiplicar2', inputStatus: 'lock',
    //       relacionMultiplicacion: [{ columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    //     },
    //     {
    //       title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
    //       relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    //     },
    //     { title: 'TOTAL COSTO', field: 'dcot_totalunicosto', filterType: 'numeric', inputType: 'decimalResultado2', rowFooter: 'sum', inputStatus: 'lock' },
    //     { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', inputType: 'decimalResultado', rowFooter: 'sum' },
    //   ]
    // } else {
    //   this.metadatableFlete = [
    //     { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
    //     { title: 'TRANSPORTISTA', field: 'transportistaObj', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosTransportistaDP },
    //     { title: 'NÚMERO CONTRATO', field: 'contrato', filterType: 'text', inputType: 'text' },
    //     { title: 'DESCRIPCIÓN', field: 'descripcion', filterType: 'text', inputType: 'text' },
    //     { title: 'TIPO PAQUETE', field: 'paqueteObj', inputType: 'autocomplete', filterType: 'text', dropdown: this.ListaTipoPaqueteDP },
    //     {
    //       title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'text', inputType: 'int', operacion: 'multiplicar',
    //       relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    //     },
    //     {
    //       title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
    //       relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    //     },
    //     { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum' },
    //   ]
    // }

    this.metadatableServicio = [
      { title: 'EXONERADO', field: 'scot_exonerado', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'SERVICIO', field: 'serv_nombre', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP },
      { title: 'INGRESO/EGRESO', field: 'ccot_ingresogasto', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServicio },
      { title: 'TIPO ENTIDAD', field: 'tipedescripcion', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, buscar: 'tipe_codigo', children: 'entc_nomcom' },
      { title: 'PROVEEDOR', field: 'entc_nomcom', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaProveedorG },
      { title: 'BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase },
      { title: 'CANTIDAD', field: 'scot_cantidad', filterType: 'text', inputType: 'int' },
      { title: 'MONEDA', field: 'tipo_descmnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaMoneda },
      { title: 'PRECIO UNITARIO', field: 'scot_preciouni', filterType: 'text', inputType: 'decimal' },
      { title: 'IMPORTE INGRESO', field: 'scot_importe_ingreso', filterType: 'text', inputType: 'decimal' },
      { title: 'IMPORTE EGRESO', field: 'scot_importe_egreso', filterType: 'text', inputType: 'decimal' },
      { title: 'AFECTO IGV', field: 'serv_afeigv', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'AFECTO DETRACCIÓN', field: 'serv_afedet', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'TIPO DOCUMENTO', field: 'tipo_desctdo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoDocumento },
      { title: 'SERIE DOCUMENTO', field: 'scot_serietdo', filterType: 'text', inputType: 'text' },
      { title: 'NRO. DOCUMENTO', field: 'scot_numerotdo', filterType: 'text', inputType: 'text' },
      { title: 'FEC. EMISIÓN', field: 'audi_feccrea', filterType: 'text', inputType: 'date' },
    ]
    this.metadatableFleteEmbarque = [
      { title: 'COMODITY', field: 'cdt_desc', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaComodity },//?
      { title: 'PRODUCTO', field: 'dcot_producto', filterType: 'text', inputType: 'text' },
      { title: 'BULTOS', field: 'dcot_bultos', filterType: 'numeric', inputType: 'decimal' },
      { title: 'UNIDAD MEDIDA', field: 'unm_desc', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaUnidadMedida },
      { title: 'PESO (Kg)', field: 'dcot_peso', filterType: 'numeric', inputType: 'decimal' },
      { title: 'VOLUMEN (m3)', field: 'dcot_volumen', filterType: 'numeric', inputType: 'decimal' },
      { title: 'LARGO (cm)', field: 'dcot_largo', filterType: 'numeric', inputType: 'decimal' },
      { title: 'ANCHO (cm)', field: 'dcot_ancho', filterType: 'numeric', inputType: 'decimal' },
      { title: 'ALTO (cm)', field: 'dcot_alto', filterType: 'numeric', inputType: 'decimal' },
    ]

    this.metadatableDataObservaciones = [
      { title: 'FECHA', field: 'even_fecha', filterType: 'text', inputType: 'text' },
      { title: 'USUARIO', field: 'even_usuario', filterType: 'text', inputType: 'text' },
      { title: 'OBSERVACIONES', field: 'even_observaciones', filterType: 'text', inputType: 'text' },//??????
      { title: 'ARCHIVO', field: 'even_filename', filterType: 'text', inputType: 'text' },

    ]

    this.metadatableTarifa = [
      { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
      { title: 'TARIFA', field: 'idtariff', filterType: 'text', inputType: 'int' },
      { title: 'VIGENTE DESDE', field: 'vigente_desde', filterType: 'text', inputType: 'date' },
      { title: 'VIGENTE HASTA', field: 'vigente_hasta', filterType: 'text', inputType: 'date' },
      { title: 'DESCRIPCIÓN', field: 'descripcion', filterType: 'text', inputType: 'text' },
      { title: 'CONCEPTO', field: 'concepto', filterType: 'text', inputType: 'text' },
      { title: 'UNIDAD BASE', field: 'unidad_base', filterType: 'text', inputType: 'text' },
      { title: 'MONEDA', field: 'moneda', filterType: 'text', inputType: 'text' },
      { title: 'IMPORTE VENTA', field: 'importe_venta', filterType: 'text', inputType: 'decimal' },
      { title: 'UNIDAD NEGOCIO', field: 'unidad_negocio', filterType: 'text', inputType: 'text' },
      { title: 'PLANTILLA', field: 'plantilla', filterType: 'text', inputType: 'int' },
      { title: 'AGENTE PORTUARIO', field: 'agente_portuario', filterType: 'text', inputType: 'text' },
      { title: 'ALMACÉN', field: 'almacen', filterType: 'text', inputType: 'text' },
      { title: 'CLIENTE', field: 'cliente', filterType: 'text', inputType: 'text' },
      { title: 'RÉGIMEN', field: 'regimen', filterType: 'text', inputType: 'text' },
      { title: 'SEGMENTO DE CLIENTE', field: 'segmento_de_cliente', filterType: 'text', inputType: 'text' },
      { title: 'TERMINAL PORTUARIO', field: 'terminal_portuario', filterType: 'text', inputType: 'text' },
      { title: 'TRANSPORTISTA', field: 'transportista', filterType: 'text', inputType: 'text' },
      { title: 'VÍA', field: 'via', filterType: 'text', inputType: 'text' },
    ]

    this.metadatableDataDetalle = [
      { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'text' },
      { title: 'UNIDAD BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'text' },
      { title: 'TIPO ENTIDAD', field: 'tipoentidad', filterType: 'text', inputType: 'text', required: true  },
      { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', filterType: 'text', inputType: 'text' },
      { title: 'TIPO DE CAMBIO', field: 'tipocambioventa', filterType: 'numeric', inputType: 'decimal', verColumna: (row) => this.verColumnaMetadata(row, 'tipo_cambio'), },
      {
        title: 'VENTA (UNIDAD)', field: 'dope_preciounitvta', filterType: 'text', operacion: 'multiplicar', inputType: 'decimal', toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
        validar: 'dope_preciounit_prom', tipoValidar: 'venta', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
        coversion: true, relacionConversion: [
          { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null },
          { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
          { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
          { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
          { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null }],
        relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }],
        rowFooter: 'sum_misma_moneda'
      },
      // { title: 'PROFIT', field: 'profit_fijo', filterType: 'text', inputType: 'decimal' },
      // { title: 'PROFIT MINIMO', field: 'profitminimo', filterType: 'text', inputType: 'decimal' },
      { title: 'MONEDA', field: 'nombremndvta', filterType: 'text', inputType: 'text' },
      {
        title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', operacion: 'multiplicar', inputType: 'int',
        relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }]
      },
      {
        title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum_misma_moneda'
      },
      { title: 'Descripción<br>Tarifa', field: 'desctarifa', filterType: 'text', inputType: 'textdisabled' },
      { title: 'Vigencias<br>Tarifa', field: 'vigencias', filterType: 'text', inputType: 'textdisabled' },
      { title: 'Estado', field: 'cons_descest', filterType: 'text', inputType: 'textdisabled' },
      // { title: 'AGRUPADO', field: 'agrupado', inputType: 'checkbox' },
      // { title: '', field: 'veragrupado', inputType: 'buttonPersonalizado', icon: "pi pi-eye", toolTip: "Ver Tarifa", function: (row) => this.viewTarifas(row), condicion: 'agrupado' }
    ]

    // this.metadataTableDetalleAgrupado = [
    //   { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', inputType: 'text' },
    //   { title: 'UNIDAD BASE', field: 'cons_desc_spa', inputType: 'text' },
    //   { title: 'TIPO ENTIDAD', field: 'tipoentidad', inputType: 'text' },
    //   { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', inputType: 'text' },
    //   { title: 'VENTA (UNIDAD)', field: 'dope_preciounitvta', inputType: 'decimal' },
    //   { title: 'MONEDA', field: 'nombremnd', inputType: 'text' },
    //   { title: 'CANTIDAD', field: 'dope_cantidad', inputType: 'int' },
    //   { title: 'VENTA (TOTAL)', field: 'dope_preciototvta', inputType: 'decimal' }
    // ]

    // this.metadatableDetalleTarifa = [
    //   { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'text' },
    //   { title: 'UNIDAD BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'text' },
    //   { title: 'TIPO ENTIDAD', field: 'tipoentidad', filterType: 'text', inputType: 'text' },
    //   { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', filterType: 'text', inputType: 'text' },
    //   {
    //     title: 'VENTA (UNIDAD)', field: 'dope_preciounitvta', filterType: 'numeric', operacion: 'multiplicar', inputType: 'decimal', toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
    //     validar: 'dope_preciounitcosto', tipoValidar: 'menor', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
    //     relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }], rowFooter: 'sum',
    //   },
    //   { title: 'PROFIT', field: 'profit_fijo', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum', },
    //   { title: 'PROFIT MINIMO', field: 'profitminimo', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum', },
    //   { title: 'MONEDA', field: 'nombremndvta', filterType: 'text', inputType: 'text' },
    //   {
    //     title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', operacion: 'multiplicar', inputType: 'int',
    //     relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }]
    //   },
    //   {
    //     title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum',
    //   },
    //   // { title: 'AGRUPADO', field: 'agrupado', inputType: 'checkbox' },
    // ]

    this.metadataTableDetalleAgrupacion = [
      { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosDescripcionServiciosLocales },
      { title: 'VENTA GRUPO', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimal', operacion: 'multiplicar' },
      // { title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', inputType: 'int', operacion: 'multiplicar' },
      // { title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado' },
      { title: '', field: '', inputType: 'buttonPersonalizado', icon: "pi pi-eye", toolTip: "Ver Tarifa", function: (row) => this.viewTarifas(row), condicion: 'agrupado' }
    ]

    // this.metadataTableTarifaServicioLogistico = [
    //   { title: 'CONCEPTO', field: 'concepto', inputType: 'text' },
    //   { title: 'DETALLE', field: 'detalle', inputType: 'text' },
    //   { title: 'MAERSK-MAERSK AGENCY', field: 'maersk_agency', inputType: 'decimal' },
    //   { title: 'HAPAG LLOYD-TRAMARSA', field: 'hp_tramarsa', inputType: 'decimal' },
    //   { title: 'MSC-MEDLOG', field: 'msc-medlog', inputType: 'decimal' },
    //   { title: 'VENTAS SLI', field: 'ventas_sli', inputType: 'decimal' },
    // ]
  }

  inicializaFormulario(accion: string, row) {
    if (accion == "I") {
      this.group_tabcotizacion = new FormGroup({
        numeroCotizacion: new FormControl(null, null),
        version: new FormControl(1, null),
        estado: new FormControl("001", [Validators.required]),
        numerocrm: new FormControl(null, null),
        ordencompra: new FormControl(null, null),
        regimen: new FormControl(null, [Validators.required]),
        via: new FormControl(null, [Validators.required]),
        lineanegocio: new FormControl(null, [Validators.required]),
        incoterm: new FormControl(null, null),
        fechaemision: new FormControl(this.date, null),
        fechaaprobacion: new FormControl(null, null),
        fechavencimiento: new FormControl(this.date, null),
        serviciologistico: new FormControl(false, null),
        cotizacionpropia: new FormControl(false, null),
        razonSocial: new FormControl(null, [Validators.required]),
        ruc: new FormControl(null, null),
        contacto: new FormControl(null, null),
        agente: new FormControl("CIMC WETRANS DELFIN LOGISTICS(HK)CO., LIMITED", null),
        ejecutivo: new FormControl(null, null),
        customer: new FormControl(null, null),
      })
      this.group_datosGenerales = new FormGroup({
        puertoorigen: new FormControl(null, null),
        puertodestino: new FormControl(null, null),
        contenedor: new FormControl(null, null),
        cantidad: new FormControl(1, null),
        fechatarifa: new FormControl(this.date, null),
        puertotransbordo: new FormControl(null, null),
        moneda: new FormControl("002", null),
        trafico: new FormControl(null, null),
        tipofechatarifa: new FormControl("001", null),
        condicion: new FormControl(null, null),
        transportista: new FormControl(null, [Validators.required]),
        numerocontrato: new FormControl(null, null),
        adicional: new FormControl(null, null),
        pcmbl: new FormControl(null, [Validators.required]),
        pchbl: new FormControl(null, [Validators.required]),
        fletetotal: new FormControl(0.00, null),
        diaslibres: new FormControl(null, null),
      })
      this.group_datosAdicionales = new FormGroup({
        cargarefrigerada: new FormControl(false, null),
        cargapeligrosa: new FormControl(false, null),
        roundtrip: new FormControl(false, null),
        temperatura: new FormControl(0.00, null),
        imoclass: new FormControl(null, null),
        imoun: new FormControl(null, null),
        shipper: new FormControl(null, null),
        consignee: new FormControl(null, null),
        notify: new FormControl(null, null),
        referencia: new FormControl(null, null),
        almacenaje: new FormControl(0, null),
        sobreestadia: new FormControl(0, null),
        tiempoviaje: new FormControl(0, null),
        validezoferta: new FormControl(0, null),
        instrucciones: new FormControl(" ", null),
        deposito: new FormControl(null, null),
        clienteDSL: new FormControl(null, null),
        transportistaam: new FormControl(null, null),
        almacen: new FormControl(null, null),
        agencia: new FormControl(null, null),
        terminal: new FormControl(null, null),
        condicion: new FormControl(null, null),
        transportista: new FormControl(null, null),
        sada: new FormControl(null, null),
        imo: new FormControl(null, null),
        tarifa: new FormControl(null, null),
        tipo: new FormControl(null, null),
        vigenciadesde: new FormControl(this.date, null),
        vigenciahasta: new FormControl(this.date, null),
        descripcion: new FormControl(null, null),
        observaciones: new FormControl(null, null),
        transportistaTerre: new FormControl(null, null),
        desc_shipper: new FormControl(null, null),
        desc_consignee: new FormControl(null, null),
      });
      this.group_tarifasAdicionales = new FormGroup({
        codigooperacion: new FormControl(null, null),
        numerooperacion: new FormControl(null, null),
        fechaemision: new FormControl(this.date, null),
        clienteDSL: new FormControl(null, null),
        transportistaam: new FormControl(null, null),
        almacen: new FormControl(null, null),
        agencia: new FormControl(null, null),
        terminal: new FormControl(null, null),
        condicion: new FormControl(null, null),
        transportista: new FormControl(null, null),
        sada: new FormControl(null, null),
        imo: new FormControl(null, null),
        tarifa: new FormControl(null, null),
        tipo: new FormControl(null, null),
        vigenciadesde: new FormControl(null, null),
        vigenciahasta: new FormControl(null, null),
        descripcion: new FormControl(null, null),
        observaciones: new FormControl(null, null),
        transportistaTerre: new FormControl(null, null),
        fechasl: new FormControl(null, null),
        rutas: new FormControl(null, null),
        montocif: new FormControl(null, null),
        promedio: new FormControl(true, null),
        montodam: new FormControl(null, null),
        cifLogistico: new FormControl(null, null),
        cifEjecVta: new FormControl(null, null),
        peso: new FormControl(null),
        volumen: new FormControl(null),
        unmd_peso: new FormControl(null),
        unmd_volumen: new FormControl(null),
      });
      this.group_Transporte = new FormGroup({
        condicion: new FormControl(null, null),
      })
      this.groupAuth = new FormGroup({
        tipoauth: new FormControl(null, null),
        usuario: new FormControl(null, [Validators.required]),
        contrasenia: new FormControl(null, [Validators.required]),
        token: new FormControl(null, [Validators.required]),
      })
    }
    else {
      this.group_tabcotizacion = new FormGroup({
        numeroCotizacion: new FormControl(row.ccot_numdoc, null),
        version: new FormControl(row.ccot_version, null),
        estado: new FormControl(row.cons_codest, [Validators.required]),
        numerocrm: new FormControl(row.ccot_numpresupuesto, null),
        ordencompra: new FormControl(row.ccot_ordencompra, null),
        regimen: new FormControl(row.cons_codrgm, null),
        via: new FormControl(row.cons_codvia, [Validators.required]),
        lineanegocio: new FormControl(row.cons_codlng, [Validators.required]),
        incoterm: new FormControl(row.tipo_codinc, row.cons_codrgm === '002' ? Validators.required : null),
        fechaemision: new FormControl(row.ccot_fecemi ? new Date(row.ccot_fecemi) : null, null),
        fechaaprobacion: new FormControl(row.ccoT_FecAprueba ? new Date(row.ccoT_FecAprueba) : null, null),
        fechavencimiento: new FormControl(row.ccot_fecvcto ?? new Date(row.ccot_fecvcto), null),
        serviciologistico: new FormControl(row.ccot_serviciologistico, null),
        cotizacionpropia: new FormControl(row.ccot_propia, null),
        razonSocial: new FormControl(row.entc_nomcliente, [Validators.required]),
        ruc: new FormControl(row.entC_CodCliente, null),
        contacto: new FormControl(row.entC_CodCliente, null),
        agente: new FormControl(row.entc_nomagente, null),
        ejecutivo: new FormControl(row.entc_nomejecutivo, null),
        customer: new FormControl(row.entC_NomCustomer, null),
      })
      this.group_datosGenerales = new FormGroup({
        puertoorigen: new FormControl(row.puer_codorigen, null),
        puertodestino: new FormControl(row.puer_coddestino, null),
        contenedor: new FormControl(row.doov_cntr, null),
        cantidad: new FormControl(1, null),
        fechatarifa: new FormControl(row.ccot_fectarifa ? new Date(row.ccot_fectarifa) : null, null),
        puertotransbordo: new FormControl(row.puer_codtrasbordo, null),
        moneda: new FormControl(row.tipo_codmnd, null),
        trafico: new FormControl(row.tipo_codtrf, null),
        tipofechatarifa: new FormControl(row.cons_codtft, null),
        condicion: new FormControl(row.cons_codfle, null),
        transportista: new FormControl(row.entc_nomtransportista, [Validators.required]),
        numerocontrato: new FormControl(row.cont_numero, null),
        adicional: new FormControl(row.cont_descrip, null),
        pcmbl: new FormControl(row.ccot_pagombl, null),
        pchbl: new FormControl(row.ccot_pagohbl, null),
        fletetotal: new FormControl(row.dcot_totaluniventa, null),
        diaslibres: new FormControl(row.ccot_sobreestadia, null),
      })
      this.group_datosAdicionales = new FormGroup({
        cargarefrigerada: new FormControl(row.ccot_cargarefrigerada, null),
        cargapeligrosa: new FormControl(row.ccot_cargapeligrosa, null),
        roundtrip: new FormControl(row.ccot_roundtrip, null),
        temperatura: new FormControl(row.ccot_temperatura, null),
        imoclass: new FormControl(row.tipo_codimo, null),
        imoun: new FormControl(row.ccot_imoun, null),
        shipper: new FormControl(row.entc_nomshipper, null),
        consignee: new FormControl(row.entc_nomconsignee, null),
        notify: new FormControl(row.entc_nomnotify, null),
        referencia: new FormControl(row.doov_codreferencia, null),
        almacenaje: new FormControl(row.ccot_almacenaje, null),
        sobreestadia: new FormControl(row.ccot_sobreestadia, null),
        tiempoviaje: new FormControl(row.ccot_tiempoviaje, null),
        validezoferta: new FormControl(row.ccot_validezoferta, null),
        instrucciones: new FormControl(row.ccot_observaciones, null),
        deposito: new FormControl(row.entc_nomdeptemporal, null),
        desc_shipper: new FormControl(row.ccot_descshipper, null),
        desc_consignee: new FormControl(row.ccot_descconsignee, null),
      })
      this.group_tarifasAdicionales = new FormGroup({
        codigooperacion: new FormControl(row.cope_codigo, null),
        numerooperacion: new FormControl(row.cope_numdoc, null),
        fechaemision: new FormControl(row.cope_fecemi ? new Date(row.cope_fecemi) : null, null),
        clienteDSL: new FormControl(row.entc_codcliente ?? null, null),
        transportistaam: new FormControl(row.entc_nombretransportista, null),
        almacen: new FormControl(row.entc_nombrealmacen, null),
        agencia: new FormControl(row.entc_nombreagenciamaritima, null),
        terminal: new FormControl(null, null),
        condicion: new FormControl(row.descripcioncondicionembarque, null),
        transportista: new FormControl(null, null),
        sada: new FormControl(null, null),
        imo: new FormControl(null, null),
        tarifa: new FormControl(row.ctar_codigo, null),
        tipo: new FormControl(row.tarifftype, null),
        vigenciadesde: new FormControl(row.validfrom ? new Date(row.validfrom) : null, null),
        vigenciahasta: new FormControl(row.validto ? new Date(row.validto) : null, null),
        descripcion: new FormControl(row.remarks, null),
        observaciones: new FormControl(null, null),
        transportistaTerre: new FormControl(row.entc_codtransterre, null),
        fechasl: new FormControl(row.cope_fechaSL ? new Date(row.cope_fechaSL) : null, null),
        rutas: new FormControl(row.codigo_ruta, null),
        montocif: new FormControl(null, null),
        promedio: new FormControl(true, null),
        montodam: new FormControl(row.cope_dam, null),
        cifLogistico: new FormControl(row.cope_cifLogistico, null),
        cifEjecVta: new FormControl(row.cope_cifEjecVta, null),
        peso: new FormControl(row.cope_peso_sli, null),
        volumen: new FormControl(row.cope_volumen_sli, null),
        unmd_peso: new FormControl(row.cope_unmd_peso, null),
        unmd_volumen: new FormControl(row.cope_unmd_volumen, null),
      });
      this.group_Transporte = new FormGroup({
        condicion: new FormControl(row.cons_codfle, null),
      })
      this.groupAuth = new FormGroup({
        tipoauth: new FormControl(null, null),
        usuario: new FormControl(null, [Validators.required]),
        contrasenia: new FormControl(null, [Validators.required]),
        token: new FormControl(null, [Validators.required]),
      })
    }
  }

  async ListarParametros() {
    this.ListaTodosPuertoOrigen = this.parametros.slice()
      .filter(r => r.tipo === 'PUERTO')
      .map(item => ({
        ...item,
        codigo: Number(item.codigo)
      }));

    this.ListaTodosEstado = this.parametros.slice().filter(r => r.tipo === 'COT')

    this.ListaTodosRegimen = this.parametros.slice().filter(r => r.tipo === 'RGM')
    this.ListaTodosVia = this.parametros.slice().filter(r => r.tipo === 'VIA')
    this.ListaTodosLineaNegocio = this.parametros.slice().filter(r => r.tipo === 'LNG')
    this.ListaTodosCliente = this.parametros.slice()
      .filter(r => r.tipo === 'CLIENTE')
      .map(item => ({
        ...item,
        codigo: Number(item.codigo)
      }));
    // this.ListaTodosCliente = this.parametros.slice().filter(r => r.tipo === 'CLIENTE')

    this.ListaTodosRazonSocial = this.ListaTodosCliente
    this.ListaTodosCustomer = this.parametros.slice().filter(r => r.tipo === 'CUS')

    this.ListaTodosAgentes = this.parametros.slice().filter(r => r.tipo === 'AGE')
    this.ListaTodosIncoterm = this.parametros.slice().filter(r => r.tipo === 'INC')
    this.ListaTodosEjecutivos = this.parametros.slice().filter(r => r.tipo === 'EJECUTIVOS')
    this.ListaTodosAgeMND = this.parametros.slice().filter(r => r.tipo === 'AGENTEMND')
    // --ServiciosYTarifa
    this.ListaTodosServicios = this.parametros.slice().filter(r => r.tipo === 'SERVICIO')

    this.ListaTipoPaquete = this.parametros.slice().filter(r => r.tipo === 'PAQUETE')

    this.ListaPaqueteOriginal = this.parametros.slice().filter(r => r.tipo === 'PAQUETE')

    // this.ListaTipoPaquete = this.parametros.slice()
    //   .filter(r => r.tipo === 'PAQUETE')
    //   .map(item => ({
    //     ...item,
    //     codigo: Number(item.codigo)
    //   }));

    this.ListaTodosTransportista = this.parametros.slice()
      .filter(r => r.tipo === 'TRANSPORTISTA')
      .map(item => ({
        ...item,
        codigo: Number(item.codigo)
      }));
    // this.ListaTodosTransportista = this.parametros.slice().filter(r => r.tipo === 'TRANSPORTISTA')
    this.ListaTodosTrafico = this.parametros.slice().filter(r => r.tipo === 'TRF')


    this.ListaTodosMoneda = this.parametros.slice().filter(r => r.tipo === 'MND')
    console.log("this.ListaTodosMoneda", this.ListaTodosMoneda)
    this.ListaTodosTipoFechaTarifa = this.parametros.slice().filter(r => r.tipo === 'TFT')
    this.ListaTodosCondicion = this.parametros.slice().filter(r => r.tipo === 'FLE')

    this.ListaTodosPCMBL = this.parametros.slice().filter(r => r.tipo === 'CTP')
    this.ListaTodosPCHBL = this.parametros.slice().filter(r => r.tipo === 'CTP')

    // --Datos Embarque    
    this.ListaTodosImoClass = this.parametros.slice().filter(r => r.tipo === 'IMO')
    this.ListaTodosShipper = this.parametros.slice().filter(r => r.tipo === 'SHIPPER')
    this.ListaTodosConsignee = this.parametros.slice().filter(r => r.tipo === 'CLIENTE')
    this.ListaTodosNotify = this.parametros.slice().filter(r => r.tipo == 'CLIENTE')

    this.ListaTodosDeposito = this.parametros.slice().filter(r => r.tipo === 'DepositoTemp')

    // // -ServicioLocales
    // this.ListaTodosTarifa = this.parametros.slice().filter(r => r.tipo === 'WEB') 
    // // this.ListaTodosDescripcionServiciosLocales = this.parametros.slice().filter(r => r.tipo === 'DESCSERVL')
    // this.ListaTodosCodBase = this.parametros.slice().filter(r => r.tipo === 'CODBASE') 
  }

  listarParametrosDP() {
    this.parametros.map(r => {
      if (r.tipo === 'PAQUETE') {
        const item: SelectItem = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaTipoPaqueteDP.push(item)
      }
      if (r.tipo === 'TRANSPORTISTA') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaTodosTransportistaDP.push(item)
      }
      if (r.tipo === 'TMC') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaServicio.push(item)
      }
      if (r.tipo === 'TIPE') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaTipoEntidad.push(item)
      }
      if (r.tipo === 'CLIENTE' || r.tipo === 'SHIPP' || r.tipo === 'TRANSPO' || r.tipo === 'AGE') { //chiwa
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaProveedorG.push(item)
      }
      if (r.tipo === 'PROVEEDOR' || r.tipo === 'AGE' || r.tipo === 'DepositoVacio' || r.tipo === 'TERMINALPORTUARIO'
        || r.tipo === 'DepositoTemp' || r.tipo === 'TRANSPORTISTA' || r.tipo === 'SHIPPER' || r.tipo === 'CLIENTE') {
        const item = { label: r.nombre, value: r.codigo, tipo: r.tipo }
        this.ListaNombreEntidadesDP.push(item)
      }
      if (r.tipo === 'BAS') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaBase.push(item)
      }
      if (r.tipo === 'MND') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaMoneda.push(item)
      }
      if (r.tipo === 'TDO') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaTipoDocumento.push(item)
      }
      if (r.tipo === 'DESCSERVL') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaTodosDescripcionServiciosLocales.push(item)
      }
      if (r.tipo === 'CDT') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaComodity.push(item)
      }
      if (r.tipo === 'UNM') {
        const item = {
          label: r.nombre,
          value: r.codigo
        }
        this.ListaUnidadMedida.push(item)
      }

    })




  }

  @ViewChild('dropdownRegimen') dropdownRegimen!: Dropdown;
  focusRegimenDropdown() {
    setTimeout(() => {
      this.dropdownRegimen.focus();
    }, 0);
    // this.dropdownRegimen.show();
  }

  onRegimenChange(event: any) {
    const selectedRegimen = event.value;
    if (selectedRegimen === '001') {
      this.group_tabcotizacion?.get('incoterm')?.clearValidators();
      this.group_tabcotizacion?.get('incoterm')?.updateValueAndValidity();
      this.group_tabcotizacion.get('lineanegocio')?.setValue('001');

    } else if (selectedRegimen === '002') {
      this.group_tabcotizacion?.get('incoterm')?.setValidators([Validators.required]);
      this.group_tabcotizacion?.get('incoterm')?.updateValueAndValidity();
      this.group_tabcotizacion.get('lineanegocio')?.setValue('001');

    } else {
      this.group_tabcotizacion.get('lineanegocio')?.setValue('');
      this.group_tabcotizacion?.get('incoterm')?.clearValidators();
      this.group_tabcotizacion?.get('incoterm')?.updateValueAndValidity();

    }
    this.filtrarServicios();
    this.cargarTarifasDefault();
  }

  onViaChange(event: any) {
    this.filtrarServicios();
    this.filtrarPuertosSegunVia()
  }

  onLineaNegocioChange(event: any) {
    this.filtrarServicios();
  }

  onClienteChange(event: any) {
    // this.ListaTodosRazonSocial = this.ListaTodosCliente
    var nombreCliente = event.value
    // var nombreCliente = this.group_tabcotizacion.get('razonSocial')?.value
    this.codigoRazonSocial = this.ListaTodosCliente.find(item => item.nombre === nombreCliente)?.codigo
    this.group_tarifasAdicionales.get('clienteDSL')?.setValue(this.razonSocial ?? null);
    if (this.group_tabcotizacion.get('razonSocial')?.value != null) {
      this.cargarServiciosEnTablaSegunCliente()
      this.cargaRucInterno('I')
      this.buscarCustomerEjecutivoSegunCliente()
    }
    this.group_datosAdicionales.get('consignee')?.setValue(event.value);
    this.group_datosAdicionales.get('notify')?.setValue(event.value);
  }

  onClienteClear() {
    this.ListaTodosRazonSocial = this.ListaTodosCliente
    this.group_tabcotizacion.get('ruc')?.setValue(null)
    this.group_tabcotizacion.get('customer')?.setValue(null)
    this.codCustomer = null
    this.group_tabcotizacion.get('ejecutivo')?.setValue(null)
    this.codEjecutivo = null
    this.group_tabcotizacion.get('contacto')?.setValue(null)
    this.group_datosGenerales.get('consignee')?.setValue(null);
    this.group_datosGenerales.get('notify')?.setValue(null);
  }

  onFechaEmiChange(event: any) {
    // this.group_tabcotizacion.get('fechaemision')?.setValue(this.group_tabcotizacion.value["fechaemision"]);
    this.group_tabcotizacion.get('fechavencimiento')?.setValue(this.group_tabcotizacion.value["fechaemision"]);
    this.group_datosGenerales.get('fechatarifa')?.setValue(this.group_tabcotizacion.value["fechaemision"]);
    this.group_tarifasAdicionales.get('fechaemision')?.setValue(this.group_tabcotizacion.value["fechaemision"]);


  }

  codEjecutivo: number;
  onEjecutivoChange($event: any) {
    var nom: string = this.group_tabcotizacion.value["ejecutivo"]
    this.codEjecutivo = Number(this.ListaTodosEjecutivos.find(item => item.nombre === nom)?.codigo)
  }

  codCustomer: number;
  onCustomerChange($event: any) {
    var nom: string = this.group_tabcotizacion.value["customer"]
    this.codCustomer = Number(this.ListaTodosCustomer.find(item => item.nombre === nom)?.codigo)
  }

  codTransporte: number;
  dopesEliminados: any[] = [];
  async onTransporteChange(event) {
    console.log('event', event)
    this.group_datosGenerales.get("transportista").setValue(this.transportistaSeleccionado)
    if (this.servicioslocales_datadetalle.length > 0) {
      this.confirmationService.confirm({
        message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR? SE ELIMINARÁN LOS SERVICIOS ASOCIADOS A ESTE TRANSPORTISTA",
        icon: 'pi pi-exclamation-triangle',
        key: 'T',
        rejectButtonProps: {
          label: 'Cancelar',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Aceptar',
        },
        header: 'Confirmation',
        closable: false,
        closeOnEscape: false,
        accept: async () => {
          this.transportistaSeleccionado = event.value
          var nombreTransportista: string = event.value
          this.codTransporte = Number(this.ListaTodosTransportista.find(item => item.nombre === nombreTransportista)?.codigo)
          this.group_datosGenerales.get("transportista").setValue(nombreTransportista)
          this.group_tarifasAdicionales.get('transportistaam')?.setValue(nombreTransportista);
          this.dopesEliminados = [];
          const Request: EliminarOPTransportistaRequest = <EliminarOPTransportistaRequest>{}
          Request.COPE_Codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0;
          Request.ENTC_Codigo = this.codTransporte;
          try {
            const response = await firstValueFrom(this.ordenventaService.EliminarOPTransportista(Request));
            if (response.datos.status === 200) {
              console.log('Transportista eliminado correctamente');
              this.dopesEliminados = response.datos.result ?? [];
              console.log('Dopes eliminados:', this.dopesEliminados);
            }
          } catch (error) {
            console.error('Error eliminando transportista:', error);
          }

          this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.filter(item => {
            const servCodigo = Number(item.serv_codigo);
            const entcCodigo = Number(item.entc_codigo);
            const existeEnOriginal = this.listadoOriginal.some(orig => orig.dope_item === item.dope_item && orig.ctar_codigo === item.ctar_codigo && orig.entc_codigo === item.entc_codigo);
            const existeEnEliminados = this.dopesEliminados?.some(orig => orig.dopE_Item === item.dope_item);
            if ((servCodigo === 1107 || servCodigo === 1057) && entcCodigo !== this.codTransporte && item.ESTADO_OBJ !== 'D') {
              if (item.ESTADO_OBJ === 'A') {
                item.ESTADO_OBJ = existeEnOriginal ? 'U' : 'I';
              }
              if (item.ESTADO_OBJ === 'I') {
                return false;
              } else {
                if (!item.cons_codest) {
                  return false;
                } else {
                  if (existeEnEliminados) {
                    return false;
                  } else {
                    item.ESTADO_OBJ = 'D';
                  }
                }
              }
            }
            return true;
          });
          this.servicioslocales_detalleTarifa = this.servicioslocales_detalleTarifa
            .filter(item => {
              if (
                (Number(item.serv_codigo) === 1107 || Number(item.serv_codigo) === 1057) && Number(item.entc_codigo) !== this.codTransporte && item.ESTADO_OBJ !== 'D') {
                if (item.ESTADO_OBJ === 'I') { return false; } else { item.ESTADO_OBJ = 'D'; }
              }
              return true;
            });
          const agrupadosActivos = this.servicioslocales_detalleAgrupacion.filter(agrupado => agrupado.ESTADO_OBJ !== 'D' && agrupado.ESTADO_OBJ !== 'E');

          const promises = agrupadosActivos.map(async agrupado => {
            const hijosLocales = this.servicioslocales_datadetalle.filter(item => item.cod_padre === agrupado.dope_item && item.ESTADO_OBJ != 'D' && item.ESTADO_OBJ != 'E');
            let hijosRemotos: any[] = [];

            const Request: ListarAgrupacionRequest = {
              CODE_Agrupador: agrupado.dope_item,
              COPE_Codigo: agrupado.cope_codigo
            };

            try {
              const response = await firstValueFrom(this.ordenventaService.ListarAgrupacion(Request));
              if (response.datos.status === 200 && Array.isArray(response.datos.result)) {
                hijosRemotos = response.datos.result.filter(
                  item =>
                    (Number(item.serv_codigo) !== 1107) &&
                    (Number(item.serv_codigo) !== 1057) &&
                    Number(item.entc_codigo) !== this.codTransporte
                );
              }
            } catch (error) {
              console.log('Error al obtener agrupación remota:', error);
            }

            const todosLosHijos = [...hijosLocales, ...hijosRemotos];
            const total = todosLosHijos.reduce((acc, item) => acc + Number(item.dope_preciototvta || 0), 0);

            if (total === 0) {
              return { ...agrupado, ESTADO_OBJ: 'E' };
            } else {
              const existeEnOriginal = this.listadoOriginalAgrupados.some(
                orig => orig.dope_item === agrupado.dope_item && orig.cope_codigo === agrupado.cope_codigo
              );
              return {
                ...agrupado,
                dope_preciototvta: total.toFixed(2),
                dope_preciounitvta: total.toFixed(2),
                ESTADO_OBJ: existeEnOriginal ? 'U' : 'I'
              };
            }
          });

          const agrupadosActualizados = await Promise.all(promises);
          const agrupadosInactivos = this.servicioslocales_detalleAgrupacion.filter(agrupado => agrupado.ESTADO_OBJ === 'D' || agrupado.ESTADO_OBJ === 'E');

          this.servicioslocales_detalleAgrupacion = [...agrupadosInactivos, ...agrupadosActualizados];
          console.log("this.servicioslocales_datadetalle", this.servicioslocales_datadetalle)
          console.log("this.servicioslocales_detalleTarifa", this.servicioslocales_detalleTarifa)
          console.log("this.servicioslocales_detalleAgrupacion", this.servicioslocales_detalleAgrupacion)
        },
        reject: () => {
          this.group_datosGenerales.get("transportista").setValue(this.transportistaSeleccionado)
          this.group_tarifasAdicionales.get('transportistaam')?.setValue(this.transportistaSeleccionado);
        }
      }
      );
    } else {
      this.transportistaSeleccionado = event.value
      var nombreTransportista: string = event.value
      this.codTransporte = Number(this.ListaTodosTransportista.find(item => item.nombre === nombreTransportista)?.codigo)
      this.group_datosGenerales.get("transportista").setValue(nombreTransportista)
      this.group_tarifasAdicionales.get('transportistaam')?.setValue(nombreTransportista);
    }

    this.cargarTarifasDefault();
  }

  onCargaPeligrosaChange(event: any) {
    const isChecked = event.checked;
    if (isChecked) {
      this.readonlyImoClassDE = false;
      this.readOnlyImoUnDE = false;
    } else {
      this.readonlyImoClassDE = true;
      this.readOnlyImoUnDE = true;
    }
  }

  codTransTerr: number;
  onTransTerrChange(event: any) {
    this.codTransTerr = this.group_tarifasAdicionales.get('transportistaTerre')?.value;

  }

  onCondicionChange(event: any) {
    const depositoEncontrado = this.ListaTodosCondicion.find(deposito => deposito.codigo === this.group_datosGenerales.value["condicion"]);
    this.group_tarifasAdicionales.get('condicion')?.setValue(depositoEncontrado.nombre);
    this.group_Transporte.get('condicion')?.setValue(depositoEncontrado.codigo);

    if (this.group_datosGenerales.value["condicion"] == '001') {
      this.inputtype = 'decimal';
    } else { this.inputtype = 'int'; }

    let paquetesFiltrados: any[] = []
    this.parametros.map(r => {
      if (r.tipo === 'PAQUETE') {
        paquetesFiltrados.push(r)
      }
    })

    if (event.value && event.value === '001') {
      this.ListaTipoPaquete = this.ListaPaqueteOriginal.filter(r => r.adicional2 !== "001")
      paquetesFiltrados = this.ListaPaqueteOriginal.filter(r => r.adicional2 !== "001")
    } else {
      this.ListaTipoPaquete = this.ListaPaqueteOriginal.filter(r => r.adicional2 === "001")
      paquetesFiltrados = this.ListaPaqueteOriginal.filter(r => r.adicional2 === "001")
    }

    paquetesFiltrados = paquetesFiltrados.map(e => ({ label: e.nombre, value: e.codigo }));
    this.logicaMetadataFlete(paquetesFiltrados);

    this.cargarTarifasDefault();
  }

  codConsignee: number;
  onConsigneeChange(event: any) {
    var nom: string = this.group_datosAdicionales.value["consignee"]
    this.codConsignee = Number(this.ListaTodosConsignee.find(item => item.nombre === nom)?.codigo)
  }

  codNotify: number;
  onNotifyChange(event: any) {
    var nom: string = this.group_datosAdicionales.value["notify"]
    this.codNotify = Number(this.ListaTodosNotify.find(item => item.nombre === nom)?.codigo)
  }

  codShipper: number;
  onShipperChange(event: any) {
    var nom: string = this.group_datosAdicionales.value["shipper"]
    this.codShipper = Number(this.ListaTodosShipper.find(item => item.nombre === nom)?.codigo)
  }

  codAgente: number;
  onAgenteChange(event: any) {
    if (this.group_tabcotizacion.value["agente"] != null) {
      var nom: string = this.group_tabcotizacion.value["agente"]
      this.codAgente = Number(this.ListaTodosAgentes.find(item => item.nombre === nom)?.codigo)
    }
  }

  onServiciosLocalesChange() {
    this.group_tarifasAdicionales.get('fechaemision')?.setValue(this.group_tabcotizacion.value["fechaemision"]);
    this.group_tarifasAdicionales.get('clienteDSL')?.setValue(this.razonSocial ?? null);
    this.group_tarifasAdicionales.get('transportistaam')?.setValue(this.group_datosGenerales.value["transportista"]);
    const depositoEncontrado = this.ListaTodosCondicion.find(deposito => deposito.codigo === this.group_datosGenerales.value["condicion"]);
    this.group_tarifasAdicionales.get('condicion')?.setValue(depositoEncontrado.nombre);
  }

  codDeposito: number;
  onDepositoChange(event: any) {
    var nom: string = this.group_datosAdicionales.value["deposito"]
    this.codDeposito = Number(this.ListaTodosDeposito.find(item => item.nombre === nom)?.codigo)
  }
  labelcontenedor: string
  codContenedor: string
  onContenedorChange(event: any) {

    this.codContenedor = this.group_datosGenerales.value["contenedor"]
    const selectedItem = this.ListaTipoPaquete.find(item => item.codigo === this.codContenedor)?.label;
    if (selectedItem) {
      // Aquí setea el control con el label (nombre)
      this.labelcontenedor = selectedItem
    }
  }

  onPuertoChange(event: any) {
    const codPuerto = this.group_datosGenerales.value["puertoorigen"];
    const puertoSeleccionado = this.ListaTodosPuertoOrigenyDestino.find(
      (item) => item.codigo === codPuerto
    );
    if (puertoSeleccionado) {
      const valorAdicional3 = puertoSeleccionado.adicional3;
      const traficoSeleccionado = this.ListaTodosTrafico.find(
        (item) => item.nombre === valorAdicional3
      );
      this.group_datosGenerales.get('trafico')?.setValue(traficoSeleccionado?.codigo || null);
    }
  }

  listaContactoJ: ListaContactoJ[] = []
  cargaContacto(value) {
    const requestContacto: contactoRequest = <contactoRequest>{}
    requestContacto.pintENTC_CodPadre = value
    requestContacto.pvchENT_NombreCompleto = ""
    this.proformaService.listaContacto(requestContacto).subscribe(response => {
      this.listaContactoJ = []
      for (let i = 0; i < response.datos.result.length; i++) {
        if (response.datos.result[i].relA_Tipos == "CON") {
          const contactoJ: ListaContactoJ = {
            entC_CodHijo: response.datos.result[i].entC_CodHijo,
            entC_NomCompleto: response.datos.result[i].entC_NomCompleto
          };
          this.listaContactoJ.push(contactoJ);
        }
      }

      if (this.listaContactoJ.length <= 0) {
        this.util.showMessageError('NO EXISTE CONTACTOS PARA ESTE CLIENTE');
      } else {
        this.util.showMessageError('Tiene CLIENTES');
      }
    });
  }

  crear_contacto: boolean
  openModalContacto(value, panel) {
    const values = this.group_tabcotizacion.value;
    if ((values["razonSocial"] == null)) {
      this.util.showMessage("seleccione primero un cliente");
      return;
    }
    const codcliente = this.codigoRazonSocial
    const options = { disableClose: true, panelClass: panel, data: codcliente };
    const reference = this.util.openModal(value, options);
    reference.subscribe((response) => {
      if (response) this.listadocontacto();
    });
  }

  requestcontacto: requestcontacto;
  listContacto: listcontacto[];
  listadocontacto() {
    const values = this.group_tabcotizacion.value
    this.requestcontacto = <requestcontacto>{}
    this.requestcontacto.ENTC_CodCliente = parseInt(this.codigoRazonSocial);
    this.proformaService.listarcontacto(this.requestcontacto).subscribe
      ((response) => {
        if (response.datos.status === 200) {
          this.listContacto = response.datos.result.map(contacto => {
            return {
              ...contacto,
              nombreCompleto: `${contacto.nombre} ${contacto.apellidos}`
            }
          })
          if (this.listContacto.length = 1) {
            this.group_tabcotizacion.get('contacto')?.setValue(this.listContacto[0].nombre)
          }

        }
      }, (errorServicio) => {
        this.util.showMessage(errorServicio.error.meta.mensaje);
      });
  }

  filtrarServicios() {
    const via = this.group_tabcotizacion.value["via"];
    const regimen = this.group_tabcotizacion.value["regimen"];
    const lineaNegocio = this.group_tabcotizacion.value["lineanegocio"];
    if (!via || !regimen || !lineaNegocio) return;
    this.ListaServiciosByViaRgmLngDP = this.ListaTodosServicios.filter(servicio =>
      servicio.via === via &&
      servicio.regimen === regimen &&
      servicio.lineaNegocio === lineaNegocio
    ).map(item => ({
      label: item.nombre,
      value: item.codigo.toString()
    }));



    // // Actualiza el dropdown
    this.metadatableServicio[2].dropdown = this.ListaServiciosByViaRgmLngDP;
    this.metadatableServicio = [
      { title: 'EXONERADO', field: 'scot_exonerado', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'SERVICIO', field: 'serv_nombre', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP },
      { title: 'INGRESO/EGRESO', field: 'ccot_ingresogasto', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServicio },
      { title: 'TIPO ENTIDAD', field: 'tipedescripcion', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, buscar: 'tipe_codigo', children: 'entc_nomcom' },
      { title: 'PROVEEDOR', field: 'entc_nomcom', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaProveedorG },
      { title: 'BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase },
      { title: 'CANTIDAD', field: 'scot_cantidad', filterType: 'text', inputType: 'int' },
      { title: 'MONEDA', field: 'tipo_descmnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaMoneda },
      { title: 'PRECIO UNITARIO', field: 'scot_preciouni', filterType: 'text', inputType: 'decimal' },
      { title: 'IMPORTE INGRESO', field: 'scot_importe_ingreso', filterType: 'text', inputType: 'decimal' },
      { title: 'IMPORTE EGRESO', field: 'scot_importe_egreso', filterType: 'text', inputType: 'decimal' },
      { title: 'AFECTO IGV', field: 'serv_afeigv', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'AFECTO DETRACCIÓN', field: 'serv_afedet', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'TIPO DOCUMENTO', field: 'tipo_desctdo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoDocumento },
      { title: 'SERIE DOCUMENTO', field: 'scot_serietdo', filterType: 'text', inputType: 'text' },
      { title: 'NRO. DOCUMENTO', field: 'scot_numerotdo', filterType: 'text', inputType: 'text' },
      { title: 'FEC. EMISIÓN', field: 'audi_feccrea', filterType: 'text', inputType: 'date' },
    ]
  }

  filtrarPuertosSegunVia() {
    const viaSeleccionada = this.group_tabcotizacion.value["via"] || (this.datosRecibidos != null ? this.datosRecibidos.cons_codvia : null);

    if (!viaSeleccionada) return;
    const puertosFiltrados = this.ListaTodosPuertoOrigen.filter(puerto => {
      return puerto.via === viaSeleccionada;
    });
    this.ListaTodosPuertoOrigenyDestino = puertosFiltrados;
    this.ListaPuertosByVia = puertosFiltrados;


  }

  buscarCustomerEjecutivoSegunCliente() {
    const clientesFiltrados = this.ListaTodosCliente.filter(cliente => cliente.codigo === this.codigoRazonSocial);
    if (clientesFiltrados.length === 0) return;

    clientesFiltrados.forEach(cliente => {
      let tipoRelacion: string = '';
      if (cliente.adicional1 && cliente.adicional1.trim() !== '') {
        tipoRelacion = 'CUSTOMER SERVICE';
        this.group_tabcotizacion.get('customer')?.setValue(cliente.adicional1);
        this.codCustomer = Number(this.ListaTodosCustomer.find(item => item.nombre === cliente.adicional1)?.codigo)
      }
      if (cliente.adicional2 && cliente.adicional2.trim() !== '') {
        tipoRelacion = 'EJECUTIVO';
        this.group_tabcotizacion.get('ejecutivo')?.setValue((cliente.adicional2).toUpperCase());
        this.codEjecutivo = Number(this.ListaTodosEjecutivos.find(item => item.nombre === cliente.adicional2)?.codigo)
      }
      if (cliente.adicional3 && cliente.adicional3.trim() !== '') {
        tipoRelacion = 'DEPOSITO TEMPORAL';
        this.group_datosAdicionales.get('deposito')?.setValue(cliente.adicional3);
        this.codDeposito = Number(this.ListaTodosDeposito.find(item => item.nombre === cliente.adicional3)?.codigo)
      }
    });
  }

  cargaSunat() {
    const rucControl = this.group_tabcotizacion.get('ruc');
    if (rucControl.value == null) { this.util.showMessage("ingrese primero un ruc"); return; }
    const values = this.group_tabcotizacion.value
    const requestSunat: sunatRequest = <sunatRequest>{}
    const razonSocialControl = this.group_tabcotizacion.get('razonSocial');
    requestSunat.razonsocial = values["razonSocial"]
    requestSunat.ruc = values["ruc"]

    this.proformaService.listarSunat(requestSunat).subscribe(response => {
      if (response.datos.result.length > 0) {
        this.group_tabcotizacion.get('customer')?.setValue(null)
        this.group_tabcotizacion.get('ejecutivo')?.setValue(null)
        this.group_tabcotizacion.get('contacto')?.setValue(null)
        this.razonSocial = response.datos.result[0].nombre_o_razon_social
        this.ruc = response.datos.result[0].ruc
        razonSocialControl.setValue(this.razonSocial);
        rucControl.setValue(this.ruc);
        this.cargaRucInterno('I')
      } else {
        this.cargaRucInterno('E')
      }
    },
      error => {
        this.cargaRucInterno('E')

      }
    )
  }

  codPadreContacto: string;
  cargaRucInterno(value) {
    const values = this.group_tabcotizacion.value;
    const requestRucInterno: rucInternoRequest = <rucInternoRequest>{};
    const razonSocialControl = this.group_tabcotizacion.get('razonSocial');
    const rucControl = this.group_tabcotizacion.get('ruc');

    requestRucInterno.pvchTIPE_Codigo = "1";
    requestRucInterno.pvchENTC_NomCompleto = values["razonSocial"];

    if (requestRucInterno.pvchENTC_DocIden == null) {
      requestRucInterno.pvchENTC_DocIden = "";
    }
    if (value == 'I') {
      requestRucInterno.pvchENTC_DocIden = "";
    }
    if (value == 'E') {
      requestRucInterno.pvchENTC_DocIden = values["ruc"];
      requestRucInterno.pvchENTC_NomCompleto = "";
      this.proformaService.listarRucInterno(requestRucInterno).subscribe(response => {
        this.razonSocial = response.datos.result[0].entC_RazonSocial
        this.codigoRazonSocial = String(response.datos.result[0].entC_Codigo)
        this.codPadreContacto = response.datos.result[0].entC_Codigo.toString()

        razonSocialControl.setValue(this.razonSocial);
      })
    }

    if (requestRucInterno.pvchENTC_NomCompleto.length > 3) {
      this.proformaService.listarRucInterno(requestRucInterno).subscribe(response => {
        this.listRazonSocial = []

        for (let i = 0; i < response.datos.result.length; i++) {
          this.listRazonSocial.push({
            nombre: response.datos.result[i].entC_RazonSocial
          });
        }

        for (let i = 0; i < this.listRazonSocial.length; i++) {
          if (response.datos.result[i].entC_NomCompleto == values["razonSocial"]) {
            this.ruc = response.datos.result[i].entC_DocIden
          }
        }

        // this.ruc = response.datos.result[0].entC_DocIden
        this.codigoRazonSocial = String(response.datos.result[0].entC_Codigo)

        rucControl.setValue(this.ruc);
        //this.cargaContacto(response.datos.result[0].entC_Codigo)
        this.listadocontacto();
        this.ListaTodosRazonSocial = this.listRazonSocial.slice(0, 10);


      });
    }
  }

  listaTarifas: itemsTarifaFleteResponse[] = []
  contratoSeleccionado: any = [];
  buscarContratoAyudaPivot(value, panel) {
    const values = this.group_datosGenerales.value;
    const camposRequeridos = {
      puertodestino: "Puerto Destino", puertoorigen: "Puerto Origen", contenedor: "Contenedor"
      //  , regimen: "Régimen", via: "Vía"
    };
    const camposFaltantes = Object.entries(camposRequeridos).filter(([key]) => !values[key]).map(([, label]) => label);

    if (camposFaltantes.length > 0) {
      this.util.showMessage(`Campos faltantes: ${camposFaltantes.join(", ")}`);
      return;
    }

    const requestTarifa: tarifaRequest = <tarifaRequest>{}
    const valuesCotizacion = this.group_tabcotizacion.value
    const valuesGenerales = this.group_datosGenerales.value

    let codigotrans = ""
    if (this.codTransporte >= 0) codigotrans = this.codTransporte.toString()

    requestTarifa.psinEMPR_Codigo = 1;
    requestTarifa.pchrCONS_TabRGM = "RGM"
    requestTarifa.pchrCONS_CodRGM = valuesCotizacion["regimen"];
    requestTarifa.pchrCONS_TabVIA = "VIA"
    requestTarifa.pchrCONS_CodVIA = valuesCotizacion.via;
    requestTarifa.pdtmCONT_Fecha = valuesCotizacion["fechaemision"]
    requestTarifa.pdtmCONT_Fecha2 = valuesGenerales["fechatarifa"]
    requestTarifa.pintPACK_Codigo = valuesGenerales["contenedor"]
    requestTarifa.pintENTC_CodTransportista = codigotrans
    requestTarifa.pintCONT_Codigo = ""
    requestTarifa.pintPUER_CodOrigen = valuesGenerales["puertoorigen"]
    requestTarifa.pintPUER_CodDestino = valuesGenerales["puertodestino"]
    requestTarifa.pbitCONT_Activo = 1

    let dataTarifa: any[] = [];
    dataTarifa.push({
      requestTarifa: requestTarifa,
      cantidad: valuesGenerales["cantidad"],
    });


    const options = { disableClose: true, panelClass: panel, data: JSON.stringify(dataTarifa) };
    const reference = this.util.openModal(value, options);
    reference.subscribe((response) => {
      if (response != null) {
        console.log("response buscar contrato", response)
        if (response == 'ERROR') {
          this.util.ShowMessage({
            titulo: "ERROR", mensaje: "No se encontró ningún contrato",
            tipo: "error", icono: 'pi pi-exclamation-triangle'
          });
        } else {
          const ultimoItem = this.serviciosytarifas_dataflete.length > 0
            ? Math.max(...this.serviciosytarifas_dataflete.map(item => item.dcot_item ?? this.serviciosytarifas_dataflete.length))
            : 0;

          const filaSeleccionada = response.filaSeleccionada;
          this.listaTarifas = response.listaTarifas;

          const nuevosDatos = filaSeleccionada.map((item, index) => {
            const transportista = this.ListaTodosTransportistaDP.find(t => t.value === item.entC_CodTransportista.toString());
            const contenedor = this.ListaTipoPaqueteDP.find(t => t.value === item.pacK_Codigo.toString());

            return {
              ...item,
              paqueteObj: {
                value: item.pacK_Codigo.toString(),
                label: contenedor ? contenedor.label : null
              },
              transportistaObj: {
                value: item.entC_CodTransportista.toString(),
                label: transportista ? transportista.label : null
              },
              dcot_item: item.dcot_item ?? ultimoItem + index + 1,
              select: false,
              soes_diassobrestadiacliente: item.soes_diassobrestadiacliente,
            };
          });

          const nuevaFila = nuevosDatos[0];
          const contrato = nuevaFila?.codigo;
          const puertoOrigen = this.group_datosGenerales.get('puertoorigen')?.value;
          const puertoDestino = this.group_datosGenerales.get('puertodestino')?.value;
          const packActual = nuevaFila.pack_codigo?.toString() ?? nuevaFila.pacK_Codigo?.toString();

          const tarifaNuevaFila = this.listaTarifas.find((t: any) =>
            t.pack_codigo?.toString() === packActual &&
            t.puer_codorigen === puertoOrigen &&
            t.puer_coddestino === puertoDestino
          );
          nuevaFila.tari_codigo = tarifaNuevaFila.tari_codigo;
          nuevaFila.select = true;

          const noEliminados = this.serviciosytarifas_dataflete.filter(
            item => (item.ESTADO_OBJ ?? "") !== "D"
          );

          const row = nuevaFila;
          this.group_datosGenerales.get('transportista').setValue(row.transportistaObj.label);
          this.group_datosGenerales.get('numerocontrato').setValue(row.descripcion)
          this.group_datosGenerales.get('adicional').setValue(`${row.descripcion} FI: ${this.util.formatearfecha(row.conT_FecIni, 'dd-mm-yyyy')} FF: ${this.util.formatearfecha(row.conT_FecFin, 'dd-mm-yyyy')}`)
          this.group_datosGenerales.get('diaslibres').setValue(row?.soes_diassobrestadiacliente)
          this.cont_codigo = row.codigo
          this.codTransporte = row.transportistaObj.value
          this.codContenedor = row.pack_codigo ?? row.pacK_Codigo
          this.group_datosGenerales.get('contenedor').setValue(row.pacK_Codigo.toString())
          this.contratoSeleccionado = nuevaFila;

          if (noEliminados.length > 0) {

            this.util.ShowMessage({
              titulo: "Cotización", mensaje: "¿Desea actualizar el precio de Venta?", icono: "pi pi-exclamation-triangle", tipo: "warning",
              textoBtn: { textoBtnOpcion1: "Sí", textoBtnOpcion2: "No", },
              pregunta: {
                onAccept: () => {
                  nuevaFila.ESTADO_OBJ = "U";
                  this.group_datosGenerales.get('fletetotal').setValue(row.dcot_totaluniventa)

                  const eliminados = this.serviciosytarifas_dataflete.filter(item => item.ESTADO_OBJ === "D");
                  let actualizados = [];

                  if (contrato && puertoOrigen && puertoDestino && packActual) {
                    const noEliminados = this.serviciosytarifas_dataflete.filter(item => item.ESTADO_OBJ !== "D");

                    for (const fila of noEliminados) {
                      const otroPack = fila.paqueteObj?.value?.toString();

                      if (otroPack !== packActual) {
                        const tarifa = this.listaTarifas.find((t: any) =>
                          t.pack_codigo?.toString() === otroPack &&
                          t.puer_codorigen === puertoOrigen &&
                          t.puer_coddestino === puertoDestino
                        );

                        if (!tarifa) {
                          this.util.ShowMessage({
                            titulo: "Tarifa no encontrada", mensaje: `No se encontró una tarifa adecuada para el paquete: ${fila.pack_desc ?? 'Desconocido'}`,
                            tipo: "error", icono: 'pi pi-exclamation-triangle'
                          });
                        }

                        const filaActualizada = {
                          ...fila,
                          cot_codigo: contrato,
                          contrato: nuevaFila.contrato,
                          ESTADO_OBJ: "U",
                          select: false,
                          soes_diassobrestadiacliente: nuevaFila.soes_diassobrestadiacliente,
                          tari_codigo: tarifa.tari_codigo,
                          dcot_item: fila.dcot_item,
                        };

                        const cantidad = fila.dcot_cantidad ?? 1.00;
                        if (tarifa.tari_costo != null && tarifa.tari_costo > 0) {
                          filaActualizada.dcot_preciounicosto = tarifa.tari_costo;
                          filaActualizada.dcot_preciototalcosto = tarifa.tari_costo * cantidad;
                          filaActualizada.dcot_totalunicosto = tarifa.tari_costo * cantidad;
                        }

                        if (tarifa.tari_pventa1 != null && tarifa.tari_pventa1 > 0) {
                          filaActualizada.dcot_preciouniventa = tarifa.tari_pventa1;
                          filaActualizada.dcot_importe = tarifa.tari_pventa1;
                          filaActualizada.dcot_preciototalventa = tarifa.tari_pventa1 * cantidad;
                          filaActualizada.dcot_totaluniventa = tarifa.tari_pventa1 * cantidad;
                        }

                        actualizados.push(filaActualizada);
                      } else {
                        nuevaFila.dcot_item = fila.dcot_item;
                      }
                    }
                  }

                  this.serviciosytarifas_dataflete = [
                    ...eliminados,
                    nuevaFila,
                    ...actualizados
                  ];
                  console.log("this.serviciosytarifas_dataflete", this.serviciosytarifas_dataflete)
                  console.log("nuevaFila", nuevaFila)
                  console.log("actualizados", actualizados)
                },
                onReject: () => { return; }
              }
            });
          } else {
            this.serviciosytarifas_dataflete = [
              ...this.serviciosytarifas_dataflete,
              ...nuevosDatos
            ];
            console.log("this.serviciosytarifas_dataflete", this.serviciosytarifas_dataflete)
            this.group_datosGenerales.get('fletetotal').setValue(nuevaFila.dcot_totaluniventa)
          }

          this.cargarTarifasDefault();
        }
      }
    });

  }

  getSelectedRows() {
    // return this.serviciosytarifas_dataflete.filter(row => row.select === true);
    return this.serviciosytarifas_dataflete.find(row => row.ESTADO_OBJ !== 'D') || {};
  }

  aceptar() {
    const filasSeleccionadas = this.getSelectedRows()
    if (filasSeleccionadas.length <= 0) { this.util.showMessage("Debe asignar un contrato como principal"); return; }
  }

  onCheckboxChange(event: { rowIndex: number, isChecked: boolean, rowdata: any }): void {
    const { rowIndex, isChecked, rowdata } = event;
    console.log('event', event)
    this.serviciosytarifas_dataflete.forEach((row, index) => {
      row['select'] = (index === rowIndex && isChecked);
    });
    this.serviciosytarifas_dataflete = [...this.serviciosytarifas_dataflete];

    if (isChecked) {
      this.cargarTarifasDefault();
    }

    this.serviciosytarifas_dataflete.forEach((row, index) => {
      if (index === rowIndex) {

        this.group_datosGenerales.get('transportista').setValue(row.transportistaObj.label);
        this.group_datosGenerales.get('numerocontrato').setValue(row.contrato)
        this.group_datosGenerales.get('adicional').setValue(row.descripcion)
        this.group_datosGenerales.get('fletetotal').setValue(row.dcot_totaluniventa)
        if (row.soes_diassobrestadiacliente) {
          this.group_datosGenerales.get('diaslibres').setValue(row.soes_diassobrestadiacliente)
        }
        this.cont_codigo = row.codigo
        this.codTransporte = row.transportistaObj.value
        this.codContenedor = row.pack_codigo ?? row.pacK_Codigo
        this.group_datosGenerales.get('contenedor').setValue(row.pack_codigo.toString())
      }
    });
    console.log('serviciosytarifas_dataflete', this.serviciosytarifas_dataflete)
  }

  cargarServiciosEnTablaSegunCliente() {


    const via = this.group_tabcotizacion.value["via"];
    const regimen = this.group_tabcotizacion.value["regimen"];
    const lineaNegocio = this.group_tabcotizacion.value["lineanegocio"];
    if (!via || !regimen || !lineaNegocio) return;

    const prolrequest: ConsultarEntidadServicio_Request = {
      pintENTC_Codigo: parseInt(this.codigoRazonSocial) || null,
      cons_tabvia: 'VIA',
      cons_codvia: this.group_tabcotizacion.value["via"],
      cons_tabrgm: 'RGM',
      cons_codrgm: this.group_tabcotizacion.value["regimen"],
      cons_tablng: 'LNG',
      cons_codlng: this.group_tabcotizacion.value["lineanegocio"],
    };

    this.ordenventaService.BuscarEntidadServicio(prolrequest).subscribe(
      (response: ConsultarEntidadServicioResponse) => {
        if (response.datos.status === 200) {


          const mappedData = response.datos.result.map((item, index) => {
            const proveedor = this.ListaProveedorG.find(r => r.value === item.entC_Codigo.toString());
            const proveedorNombre = proveedor ? proveedor.label : item.entC_Codigo;
            const moneda = this.ListaMoneda.find(r => r.value === item.tipO_CodMnd);
            const monedaDescripcion = moneda ? moneda.label : item.tipO_CodMnd;

            return {
              scot_item: index + 1,
              scot_exonerado: item.eseR_Exonerado,
              serv_nombre: item.serV_Nombre,
              ccot_ingresogasto: "INGRESO",
              tipedescripcion: "CLIENTE",
              entc_nomcom: proveedorNombre,
              cons_desc_spa: item.conS_DescBAS,
              scot_cantidad: 1,
              tipo_descmnd: monedaDescripcion,
              scot_preciouni: item.eseR_Valor || 0.00,
              scot_importe_ingreso: item.eseR_Valor || 0.00,
              scot_importe_egreso: 0.00,
              serv_afeigv: true,
              serv_afedet: true,
              tipo_desctdo: null,
              scot_serietdo: null,
              scot_numerotdo: null,
              audi_feccrea: new Date()
            };
          });
          this.serviciosytarifas_dataservicios = mappedData;

        }
      }
    );
  }


  buscarTarifas() {

    this.onServiciosLocalesChange();
    const transportistaCodigo = this.group_datosGenerales.value["transportista"];

    if (!transportistaCodigo) {
      this.util.ShowMessage({
        titulo: "ERROR",
        mensaje: `Debe elegir a un transportista.`,
        tipo: "warning"
      });
      return;
    }

    const prolrequest: ConsultarTarifaRequest = {
      IdBusinessUnit: null,
      DateFrom: this.group_tarifasAdicionales.value["vigenciadesde"] || null,
      DateTo: this.group_tarifasAdicionales.value["vigenciahasta"] || null,
      TariffStatus: null,
      ENTC_CodTransportista: Number(this.ListaTodosTransportista.find(item => item.nombre === this.group_datosGenerales.value["transportista"])?.codigo),
    };

    this.ordenventaService.BuscarTarifasServiciosLocales(prolrequest).subscribe(
      (response: ConsultarTarifaResponse) => {
        if (response.datos.result.length <= 0) {
          this.util.ShowMessage({
            titulo: "ERROR",
            mensaje: "No se encontraron coincidencias.",
            tipo: "warning"
          });
        } else {
          if (response.datos.status == "200") {

            if (response.datos.result.length > 0) { this.servicioslocales_tarifa = response.datos.result }
          }
        }
      },
      error => {
        console.error('Error en la obtención del contrato:', error);
      }
    );

  }

  idTarifa: number;
  aplicarTarifa(row: any) {
    this.group_tarifasAdicionales.get('descripcion')?.setValue(row.descripcion);
    this.group_tarifasAdicionales.get('vigenciadesde')?.setValue(new Date(row.vigente_desde));
    this.group_tarifasAdicionales.get('vigenciahasta')?.setValue(new Date(row.vigente_hasta));
    this.group_tarifasAdicionales.get('terminal')?.setValue(row.terminal_portuario);
    this.group_tarifasAdicionales.get('almacen')?.setValue(row.almacen);


    const tarDetRequest = <ConsultarTariffDetailByIdRequest>{};
    tarDetRequest.idTariff = row.idtariff;
    this.idTarifa = row.idtariff;
    const servTarfRequest = <GetServiceCalculatedByTariffRequest>{};
    servTarfRequest.idTariff = row.idtariff;
    servTarfRequest.pintCCOTNumero = this.datosRecibidos != null ? this.datosRecibidos.ccot_numero : null;
    servTarfRequest.psinCCOTTipo = 1;
    servTarfRequest.pvchDOOVHBL = this.datosRecibidos != null ? this.datosRecibidos.doov_hbl : null;
    this.listarTarifaDetalle = [];
    this.listarServTariff = [];

    forkJoin({
      tarifaDetalle: this.ordenventaService.BuscarTariffDetailById(tarDetRequest),
      servicioCalculado: this.ordenventaService.GetServiceCalculatedByTariff(servTarfRequest)
    }).subscribe({
      next: (response) => {
        this.servicioslocales_datadetalle.forEach(det => {
          if (det.ESTADO_OBJ === 'U' || !det.ESTADO_OBJ) {
            det.ESTADO_OBJ = 'D';
          }
        });
        for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
          if (this.servicioslocales_datadetalle[i].ESTADO_OBJ === 'I') {
            this.servicioslocales_datadetalle.splice(i, 1);
          }
        }
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle]
        console.log('this.servicioslocales_datadetalle', this.servicioslocales_datadetalle)
        if (response.tarifaDetalle.datos.status === "200" && response.tarifaDetalle.datos.result.length > 0) {
          this.listarTarifaDetalle.push(...response.tarifaDetalle.datos.result.map((item: ItemsTarifaDetalleResponse) => ({
            idTariffDetail: item.idTariffDetail,
            idTariff: item.idTariff,
            unitDescription: item.unitDescription,
            idUnit: item.idUnit,
            conceptDescription: item.conceptDescription,
            idConcept: item.idConcept,
            salesAmount: item.salesAmount,
            costsAmount: item.costsAmount,
            currency: item.currency,
            validaForm: item.validFrom,
            validTo: item.validTo,
            remarks: item.remarks,
            tariffType: item.tariffType
          })));
          console.log("listarTarifaDetalle", this.listarTarifaDetalle)
        }

        if (response.servicioCalculado.datos.status === "200" && response.servicioCalculado.datos.result.length > 0) {
          this.listarServTariff.push(...response.servicioCalculado.datos.result.map((item: ItemsServiciosCalculadosTarifaResponse) => ({
            equivalentCode: item.equivalentCode,
            serv_codigo: item.serv_codigo,
            conceptDescription: item.conceptDescription,
            idUnit: item.idUnit,
            cons_codbas: item.cons_codbas,
            cons_desc_spa: item.cons_desc_spa,
            dope_preciounitvta: item.dope_preciounitvta,
            dope_preciounitcosto: item.dope_preciounitcosto,
            dope_cantidad: item.dope_cantidad,
            dope_preciototvta: item.dope_preciototvta,
            // dope_preciototcosto: item.dope_preciounitcosto * (item.dope_cantidad || 1),
            tipe_codigo: item.tipe_codigo,
            idTariffDetail: item.idTariffDetail,
            entc_codigo: item.entc_codigo,
            dtar_item: item.dtar_item,
            currency: item.currency,
            tipo_codmnd: item.tipo_codmnd,
            idTariff: item.idTariff,
            totalProfit: item.totalProfit
          })));
          console.log("listarServTariff", this.listarServTariff)
        }
        let dopeItemCounter = this.servicioslocales_datadetalle.length > 0
          ? Math.max(...this.servicioslocales_datadetalle.map(d => d.dope_item || 0))
          : 0;

        const nuevosDetalles = this.listarTarifaDetalle.map(tarifa => {
          const matchingServicio = this.listarServTariff.find(servicio =>
            servicio.idTariffDetail === tarifa.idTariffDetail &&
            servicio.idTariff === tarifa.idTariff
          );
          const rowsConMismoId = this.servicioslocales_tarifa.find(fila => fila.idtariff === tarifa.idTariff);
          const codtransportista = this.ListaTodosTransportista.find(item => (item.nombre).toUpperCase() === (rowsConMismoId.transportista).toUpperCase())?.codigo
          const descBase = this.ListaBase.find(item => item.value === matchingServicio.cons_codbas)?.label;
          const monedaLabel = this.ListaMoneda.find(item => item.value === matchingServicio.currency)?.label;
          dopeItemCounter++;
          console.log('rowsConMismoId', rowsConMismoId)

          if (matchingServicio) {

            const serv_nombre_spa = tarifa?.conceptDescription;
            let dope_cantidad = 1;
            if (serv_nombre_spa == "ALMACEN" || serv_nombre_spa == "GATE IN") {
              dope_cantidad = this.serviciosytarifas_dataflete.length > 0
                ? (this.serviciosytarifas_dataflete[0].dcot_cantidad || 1)
                : 1;
            } else if (serv_nombre_spa == "VISTO BUENO") {
              dope_cantidad = 1;
            }

            return {
              ...tarifa,
              ...matchingServicio,
              dope_item: dopeItemCounter,
              serv_nombre_spa: serv_nombre_spa,
              cons_desc_spa: descBase,
              tipoentidad: "PROVEEDOR",
              entc_razonsocial: rowsConMismoId?.transportista,
              dope_preciounitvta: matchingServicio.dope_preciounitvta,
              nombremnd: monedaLabel,
              dope_cantidad: dope_cantidad,
              dope_preciototvta: matchingServicio.dope_preciounitvta * dope_cantidad,
              dope_preciototcosto: matchingServicio.dope_preciounitcosto * dope_cantidad,
              entc_codigo: codtransportista,
              // key: dopeItemCounter,
              ESTADO_OBJ: 'I'
            };
          } else {
            return []
          }
        });
        this.servicioslocales_datadetalle.push(...nuevosDetalles);
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];
        console.log('this.servicioslocales_datadetalle despues', this.servicioslocales_datadetalle)

      },
      error: (err) => {
        console.error('Error en las consultas:', err);
        this.util.ShowMessage({
          titulo: "ERROR",
          mensaje: "Hubo un error al consultar los datos de tarifa. Intenta nuevamente.",
          tipo: "error",
        });
      }
    });
  }

  tranformarDa(dato: string): string {
    if (dato === "C") {

      return "C  ";
    } else if (dato === "P") {

      return "P  ";
    }
    return "";
  }

  obtenerTransportista() {

    const prolrequest: TransportistaRequest = {
      CCOT_Numero: this.datosRecibidos.ccot_numero,
      CCOT_TIPO: 1
    };

    this.ordenventaService.ObtenerTransportistaPorCotizacion(prolrequest).subscribe(
      (response: TransportistaCotizacionResponse) => {
        if (response.data.status === "OK") {
          this.transportistasAdicionales = true;
          this.transportistasAdicionalesData = {
            ...response.data.result,
            enT_CodTransportistaAdicMain: this.datosRecibidos.entc_codtransportista,
            conT_CodigoMain: this.datosRecibidos.cont_codigo,
            transportistaMain: this.datosRecibidos.entc_nomtransportista,
            serviceContractMain: this.datosRecibidos.cont_numero,
            pacK_CodigoMain: this.datosRecibidos.doov_cntr,
            opcionSeleccionada: 1
          };

        }
      }
    );

  }

  inicializarCodigos() {
    this.codConsignee = this.datosRecibidos.entc_codconsignee
    this.codCustomer = this.datosRecibidos.entc_codcustomer
    this.codEjecutivo = this.datosRecibidos.entc_codejecutivo
    this.codNotify = this.datosRecibidos.entc_codnotify
    this.codShipper = this.datosRecibidos.entc_codshipper
    this.codAgente = this.datosRecibidos.entc_codagente
    this.codDeposito = this.datosRecibidos.entc_coddeptemporal
    this.codigoRazonSocial = this.datosRecibidos.entc_codcliente
    this.cont_codigo = this.datosRecibidos.cont_codigo
    this.codContenedor = this.datosRecibidos.doov_cntr
  }

  visualizarTransportista(value, panel) {
    if (!this.transportistasAdicionales) { this.util.showMessage("No hay transportistas adicionales"); return; }

    const enviarData = {
      dataTransportistas: this.transportistasAdicionalesData,
      listaPaquete: this.ListaTipoPaquete
    }
    const options = { disableClose: true, panelClass: panel, data: JSON.stringify(enviarData) };
    const reference = this.util.openModal(value, options);
    reference.subscribe((response) => {
      if (response != null) {

        this.opcionalTransportista = response
        this.transportistasAdicionalesData.opcionSeleccionada = response.opcionSeleccionada;
        const nuevoTransportista = response[response.opcionSeleccionada];


        // calcular nueva tarifa

        const requestTarifa: tarifaRequest = <tarifaRequest>{}
        const valuesCotizacion = this.group_tabcotizacion.value
        const valuesGenerales = this.group_datosGenerales.value

        requestTarifa.psinEMPR_Codigo = 1;
        requestTarifa.pchrCONS_TabRGM = "RGM"
        requestTarifa.pchrCONS_CodRGM = valuesCotizacion["regimen"];
        requestTarifa.pchrCONS_TabVIA = "VIA"
        requestTarifa.pchrCONS_CodVIA = valuesCotizacion.via;
        requestTarifa.pdtmCONT_Fecha = valuesCotizacion["fechaemision"]
        requestTarifa.pdtmCONT_Fecha2 = valuesGenerales["fechatarifa"]
        requestTarifa.pintPACK_Codigo = nuevoTransportista.packCodigo
        requestTarifa.pintENTC_CodTransportista = nuevoTransportista.codigoTransportista
        requestTarifa.pintCONT_Codigo = nuevoTransportista.codigoContrato
        requestTarifa.pintPUER_CodOrigen = valuesGenerales["puertoorigen"]
        requestTarifa.pintPUER_CodDestino = valuesGenerales["puertodestino"]
        requestTarifa.pbitCONT_Activo = 1

        this.proformaService.listarTarifa(requestTarifa).subscribe(response => {
          if (response.datos.status === 200) {
            const resultado = response.datos.result;
            if (resultado && resultado.length > 0) {
              const registro = resultado[0];
              const total = this.group_datosGenerales.value.cantidad * registro.valor;
              this.dataTarifa = {
                ...registro,
                select: false,
                Item: 1,
                total: total,
              };


              // actualizar tabla de fletes
              this.cont_codigo = this.dataTarifa.codigo
              this.codContenedor = this.dataTarifa.pacK_Codigo
              this.serviciosytarifas_dataflete = this.serviciosytarifas_dataflete.map((flete, index) => ({
                ...flete,
                transportistaObj: {
                  label: nuevoTransportista.transportistaNombre,
                  value: nuevoTransportista.codigoTransportista.toString(),
                },
                cantidad: this.group_datosGenerales.value.cantidad || 1,
                codigo: nuevoTransportista.codigoContrato,
                contrato: nuevoTransportista.numeroContrato,
                descripcion: this.dataTarifa.descripcion || "", //flete.cont_descrip || this.datosRecibidos.cont_descrip,
                paqueteObj: {
                  label: this.dataTarifa.paquete,
                  value: this.dataTarifa.pacK_Codigo
                },
                Item: index + 1,
                select: false,
                dcot_preciounicosto: this.dataTarifa.dcot_preciounicosto || "", // flete.dcot_preciounicosto || null,
                dcot_preciouniventa: this.dataTarifa.valor || "", // flete.dcot_preciouniventa || null,
                dcot_totaluniventa: this.dataTarifa.total || "", //flete.dcot_totaluniventa || 0
                dcot_totalunicosto: this.dataTarifa.dcot_preciounicosto * this.group_datosGenerales.value.cantidad || "",
                soes_diassobrestadiacliente: this.dataTarifa.soes_diassobrestadiacliente,
              }));



              this.datosembarque_dataflete = [...this.serviciosytarifas_dataflete];
              this.group_datosGenerales.get('transportista').setValue(nuevoTransportista.transportistaNombre);
              this.group_datosGenerales.get('numerocontrato').setValue(nuevoTransportista.numeroContrato);
              this.group_datosGenerales.get('adicional').setValue(this.dataTarifa.descripcion);
              this.group_datosGenerales.get('fletetotal').setValue(this.dataTarifa.total);
              this.group_datosGenerales.get('diaslibres').setValue(this.dataTarifa.soes_diassobrestadiacliente);
              this.group_datosGenerales.get('contenedor').setValue(nuevoTransportista.packCodigo.toString());

              this.asignacionTransportistasParaEditar();
            }
          }
        })


      };
    });


  }

  asignacionTransportistasParaEditar() {
    const opcionSeleccionada = this.opcionalTransportista.opcionSeleccionada;
    for (const key in this.opcionalTransportista) {
      if (key !== 'opcionSeleccionada') {
        const transportista = this.opcionalTransportista[key];
        if (key !== opcionSeleccionada) {
          const requestItem: Transportista_CAB_Cotizacion_OV_Request = {
            CCOT_Numero: this.datosRecibidos.ccot_numero,
            CCOT_TIPO: this.datosRecibidos.ccot_tipo,
            ENT_CodTransportistaAdic1: transportista.codigoTransportista,
            CONT_Codigo1: transportista.codigoContrato,
            ENT_CodTransportistaAdic2: transportista.codigoTransportista,
            CONT_Codigo2: transportista.codigoContrato,
            Usuario: this.datosRecibidos.usuario,
            PACK_Codigo1: transportista.packCodigo,
            PACK_Codigo2: transportista.packCodigo
          };
          this.listartransportistasAdicionales.push(requestItem);
        }
      }
    }

  }

  asignacionTransportistasParaGuardarNuevo() {
    if (!this.listartransportistasAdicionales) {
      this.listartransportistasAdicionales = [];
    }

    const filasGuardadas = this.serviciosytarifas_dataflete.filter(fila => fila.select === false);
    if (filasGuardadas != null && filasGuardadas.length > 1) {
      const requestItem: Transportista_CAB_Cotizacion_OV_Request = {
        CCOT_Numero: 100,
        CCOT_TIPO: 1,
        ENT_CodTransportistaAdic1: parseInt(filasGuardadas[0].entC_CodTransportista) ?? null,
        CONT_Codigo1: filasGuardadas[0].codigo ?? null,
        ENT_CodTransportistaAdic2: parseInt(filasGuardadas[1].entC_CodTransportista) ?? null,
        CONT_Codigo2: filasGuardadas[1].codigo ?? null,
        Usuario: this.nombreUsuario,
        PACK_Codigo1: filasGuardadas[0].pacK_Codigo ?? null,
        PACK_Codigo2: filasGuardadas[1].pacK_Codigo ?? null
      };

      this.listartransportistasAdicionales.push(requestItem);

    }

  }

  @ViewChild('botonSiguiente', { read: ElementRef }) botonSiguiente!: ElementRef;
  focusBotonSiguiente() {
    setTimeout(() => {
      const buttonElement = this.botonSiguiente.nativeElement.querySelector('button');
      if (buttonElement) {
        buttonElement.focus();
      }
    }, 0);
  }

  @ViewChild('dropdownRazonSocial', { static: true }) dropdownRazonSocial!: ElementRef;
  onDropdownHide() {
    if (this.group_tabcotizacion.get('razonSocial')?.value != null) {
      this.focusBotonSiguiente();
    }
  }

  custombTarifas = [
    { icon: 'pi pi-search', function: () => this.buscarTarifas() }
  ];

  onCheckboxChangeTarifas(event: { rowIndex: number, isChecked: boolean, rowdata: any }) {
    const { rowIndex, isChecked } = event;
    const row = event.rowdata;
    if (isChecked == true) { this.aplicarTarifa(row); }
  }

  @ViewChild('autocompleteTransportista') autocompleteTransportista!: AutoComplete;
  focusTransportistaDropdown() {
    setTimeout(() => {
      this.autocompleteTransportista.el.nativeElement.querySelector('.p-dropdown-trigger').click();
    }, 0);
  }

  onDropdownHideTransportista() {
    // if (this.group_datosGenerales.get('transportista')?.value != null) {
    //   this.focusPuertoOrigenDropdown();
    // }
    this.focusPuertoOrigenDropdown();
  }

  @ViewChild('dropdownPuertoOrigen') dropdownPuertoOrigen!: AutoComplete;
  focusPuertoOrigenDropdown() {
    setTimeout(() => {
      this.dropdownPuertoOrigen.el.nativeElement.querySelector('.p-dropdown-trigger').click()
    }, 0);
  }

  onDropdownHidePuertoOrigen() {
    if (this.group_datosGenerales.get('puertoorigen')?.value != null) {
      this.focusPuertoDestinoDropdown();
    }
  }

  @ViewChild('dropdownPuertoDestino') dropdownPuertoDestino!: AutoComplete;
  focusPuertoDestinoDropdown() {
    setTimeout(() => {
      this.dropdownPuertoDestino.el.nativeElement.querySelector('.p-dropdown-trigger').click()
    }, 0);
  }

  onDropdownHidePuertoDestino() {
    if (this.group_datosGenerales.get('puertodestino')?.value != null) {
      this.focusContenedorDropdown();
    }
  }

  @ViewChild('dropdownContenedor') dropdownContenedor!: AutoComplete;
  focusContenedorDropdown() {
    setTimeout(() => {
      this.dropdownContenedor.el.nativeElement.querySelector('.p-dropdown-trigger').click()
    }, 0);
  }

  onDropdownHideContenedor() {
    if (this.group_datosGenerales.get('contenedor')?.value != null) {
      this.focusBotonContrato();
    }
  }

  @ViewChild('botonContrato', { read: ElementRef }) botonContrato!: ElementRef;
  focusBotonContrato() {
    setTimeout(() => {
      const buttonElement = this.botonContrato.nativeElement.querySelector('button');
      if (buttonElement) {
        buttonElement.focus();
      }
    }, 0);
  }

  onTabDatosGenerales(event: any) {
    this.activeIndex = 1
    this.focusTransportistaDropdown();
  }

  formatDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');

    if (value.length > 2) {
      value = `${value.substring(0, 2)}/${value.substring(2)}`;
    }
    if (value.length > 5) {
      value = `${value.substring(0, 5)}/${value.substring(5)}`;
    }
    input.value = value.substring(0, 10);
  }

  setFiltrosBusqueda() {
    const filtrosBusquedaCot = JSON.parse(localStorage.getItem("filtrosBusquedaCot"));

    if (typeof filtrosBusquedaCot === 'object' && filtrosBusquedaCot !== null) {
      filtrosBusquedaCot.origen = "mantenimiento-cot";

      localStorage.setItem("filtrosBusquedaCot", JSON.stringify(filtrosBusquedaCot));
    }
  }

  async onChangeFletes(event: { field: string; event: any; index: any; rowdata }) {
    const index = event.index;
    let valorDP: string = String(event?.event?.value?.value);
    const fieldCambiado = event.field;
    const rowdata = event.rowdata;
    let dcot_preciounicosto = 0.00;
    let dcot_preciouniventa = 0.00;
    let dcot_totalunicosto = 0.00;
    let dcot_totaluniventa = 0.00;

    if (fieldCambiado == "paqueteObj") { // TIPO PAQUETE
      let valor = 0.00;
      let cantidad = 1.00;

      let rowdataModificado: any;
      try { rowdataModificado = await this.ConsultarTarifario(rowdata, true, true); } catch (error) { return; }

      dcot_preciounicosto = rowdataModificado.dcot_preciounicosto;
      dcot_preciouniventa = rowdataModificado.dcot_preciouniventa;
      const tarifa = rowdataModificado.tari_codigo;

      if (rowdata.dcot_cantidad == null || rowdata.dcot_cantidad == undefined || rowdata.dcot_cantidad == 0) {
        this.enviarNuevoValorToDatatableFlete(cantidad, index, 'dcot_cantidad');
      } else {
        cantidad = rowdata.dcot_cantidad;
      }

      dcot_preciounicosto = dcot_preciounicosto;
      dcot_totalunicosto = cantidad * dcot_preciounicosto;
      dcot_preciouniventa = dcot_preciouniventa;
      dcot_totaluniventa = cantidad * dcot_preciouniventa;
      this.enviarNuevoValorToDatatableFlete(dcot_preciounicosto, index, 'dcot_preciounicosto');
      this.enviarNuevoValorToDatatableFlete(dcot_preciouniventa, index, 'dcot_preciouniventa');
      this.enviarNuevoValorToDatatableFlete(dcot_totalunicosto, index, 'dcot_totalunicosto');
      this.enviarNuevoValorToDatatableFlete(dcot_totaluniventa, index, 'dcot_totaluniventa');
      this.enviarNuevoValorToDatatableFlete(tarifa, index, 'tari_codigo');
      this.group_datosGenerales.get('fletetotal')?.setValue(dcot_totaluniventa);
    }

    if (fieldCambiado == "dcot_cantidad") { // CANTIDAD
      if (rowdata.dcot_cantidad != null && rowdata.dcot_cantidad != 0) {
        dcot_preciouniventa = rowdata.dcot_preciouniventa;
        dcot_totaluniventa = rowdata.dcot_preciouniventa * rowdata.dcot_cantidad;
        this.enviarNuevoValorToDatatableFlete(dcot_preciouniventa, index, 'dcot_preciouniventa');
        this.enviarNuevoValorToDatatableFlete(dcot_totaluniventa, index, 'dcot_totaluniventa');
        // this.group_datosGenerales.get('fletetotal').setValue(dcot_totaluniventa);
      }
    }

  }

  async ConsultarTarifario(rowdata: any, actualizarCosto: boolean, actualizarPrecioVenta: boolean): Promise<any> {
    try {
      let PACK_Codigo;

      if (typeof rowdata.paqueteObj === 'object' && rowdata.paqueteObj !== null) {
        PACK_Codigo = Number(rowdata.paqueteObj.value);
      } else if (typeof rowdata.pack_desc === 'string') {
        const packCod = this.ListaTipoPaqueteDP.find(r => r.label === rowdata.pack_desc);
        PACK_Codigo = Number(packCod ? packCod.value : rowdata.pack_desc);
      }

      if (!isNaN(PACK_Codigo) && PACK_Codigo > 0) {

        const contrato = this.contratoSeleccionado?.codigo;
        const puertoOrigen = this.group_datosGenerales.get('puertoorigen')?.value;
        const puertoDestino = this.group_datosGenerales.get('puertodestino')?.value;

        if (contrato && puertoOrigen && puertoDestino) {
          const tarifa = this.listaTarifas.find((t: any) =>
            t.pack_codigo === PACK_Codigo &&
            t.puer_codorigen === puertoOrigen &&
            t.puer_coddestino === puertoDestino
          );

          if (!tarifa) {
            throw new Error("No se encontró una tarifa adecuada para el flete que está ingresando.");
          }

          rowdata.tari_codigo = tarifa.tari_codigo;

          if ((tarifa.tari_costo != null && tarifa.tari_costo > 0) || actualizarCosto) {
            rowdata.dcot_preciounicosto = tarifa.tari_costo;
          }

          if ((tarifa.tari_pventa1 != null && tarifa.tari_pventa1 > 0) || actualizarPrecioVenta) {
            rowdata.dcot_preciouniventa = tarifa.tari_pventa1;
          }
        }
      }
    } catch (error: any) {
      this.util.ShowMessage({
        titulo: "Tarifa no encontrada", mensaje: "Ha ocurrido un error al configurar flete: "
          + error.message, tipo: "error", icono: "pi pi-exclamation-triangle"
      });
    }

    return rowdata;
  }

  enviarNuevoValorToDatatableFlete(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpValueChangeFleteEvento.emit(eventToEmit);
  }

  tipos: any[] = []
  searchTarifa() {
    this.cancelarFilasEdicion();
    if (this.group_tarifasAdicionales.value.fechasl === null || this.group_tarifasAdicionales.value.fechasl === undefined) {
      this.util.ShowMessage({
        titulo: "Campo requerido",
        mensaje: "Seleccione una fecha para filtrar Tarifas.",
        tipo: "warning"
      });
      return;
    }

    // const haySeleccionado = this.serviciosytarifas_dataflete?.some(item => item.select === true);

    // if (!haySeleccionado) {
    //   this.util.ShowMessage({
    //     titulo: "Alerta",
    //     mensaje: "Debe seleccionar al menos un flete antes de continuar.",
    //     tipo: "warning"
    //   });
    //   return;
    // }

    const value = this.group_Transporte.value["condicion"]
    if (value === null) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado una Condición para esta Cotización.', life: 3000, key: "tl" });
      return;
    }
    const valuergm = this.group_tabcotizacion?.value?.regimen
    if (valuergm === null) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado Régimen.', life: 3000, key: "tl" });
      // return;
    } else {
      const valuetrans = this.group_datosGenerales.value["transportista"]
      if (valuetrans === null) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Campo Requerido para el tarifario de VB / Gate In / Gate Out', detail: 'No se ha seleccionado transportista. Elegir uno si desea ver el tarifario.', life: 4000, key: "tl" });
        // return;
      } else {
        this.buscarServicioLogistico()
      }
      this.visibleTarifa = true
      const fakeEvent = { value: value };
      const valueRuta = this.group_tarifasAdicionales.value["rutas"]
      if (valueRuta === null) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Campo Requerido para el tarifario de Transporte', detail: 'No se ha seleccionado una ruta. Elegir uno si desea ver el tarifario.', life: 4000, key: "tl" });
        // return;
      } else {
        this.buscarTransporte(fakeEvent);
      }
      this.buscarTarifaAlmacen()
      this.buscarAgenteAduana()
      this.buscarTarifasExtra(fakeEvent);
      this.buscarTarifasTacna(fakeEvent);
    }
  }

  onClickRecargo(event: any) {

    const request = <BuscarCamposRequest>{}
    request.tipo_codtabla = 'PRI';
    request.tipo_codtipo = null;
    request.desde = null;
    request.hasta = null;
    this.mantenimientoservice.BuscarCampos(request).subscribe({
      next: (res) => {
        if (res.datos.status === 200) {
          this.tipos = res.datos.result.map(e => ({
            tipo: e.tipo_codtabla?.toString() ?? "",
            nombre: e.tipo_desc1?.toString() ?? "",
            codigo: e.tipo_codtipo?.toString() ?? "",
            via: e.tipo_desc3?.toString() ?? null,
            regimen: e.tipo_mascara?.toString() ?? null,
            lineaNegocio: e.tipo_codsap?.toString() ?? null,
            adicional1: e.tipo_desc2?.toString() ?? "",
            adicional2: e.tipo_descc?.toString() ?? null,
            adicional3: "",
            pais: "",
            codpais: "",
            listados_data: e.listados_data
          }));
        }
      },
      error: (err) => { this.tipos = []; this.util.showMessageError(err.error?.meta?.mensaje); }
    })
  }

  dope_items: number[] = []
  cope_codigos: number[] = []
  datosAdesagrupar: any[] = []
  desagrupar: boolean = true
  agrupar: boolean = true
  async desagruparServicio() {
    this.desagrupar = true;
    console.log("this.dope_items", this.dope_items);

    for (let index = 0; index < this.dope_items.length; index++) {
      const codigoAgrupado = this.dope_items[index];
      const copecodigo = this.cope_codigos[index];

      const Request: ListarAgrupacionRequest = {
        CODE_Agrupador: codigoAgrupado,
        COPE_Codigo: copecodigo
      };

      try {
        const response = await firstValueFrom(this.ordenventaService.ListarAgrupacion(Request));

        if (response.datos.status === 200) {
          const datosModificados = response.datos.result.map(item => ({
            ...item,
            ESTADO_OBJ: 'U',
            cod_padre: null,
            agrupado: false
          }));

          this.servicioslocales_datadetalle = [
            ...this.servicioslocales_datadetalle,
            ...datosModificados
          ];
        }
      } catch (errorServicio) {
        this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.map(item => {
          if (item.cod_padre === codigoAgrupado && item.ESTADO_OBJ !== 'D') {
            const enOriginal = this.listadoOriginal.some(orig =>
              orig.dope_item === item.dope_item &&
              orig.ctar_codigo === item.ctar_codigo &&
              orig.entc_codigo === item.entc_codigo
            );
            return {
              ...item,
              cod_padre: null,
              agrupado: false,
              ESTADO_OBJ: enOriginal ? 'U' : 'I'
            };
          }
          return item;
        });

        this.servicioslocales_detalleTarifa = this.servicioslocales_detalleTarifa.map(item => {
          if (item.cod_padre === codigoAgrupado && item.ESTADO_OBJ !== 'D') {
            const enOriginal = this.listadoOriginal.some(orig =>
              orig.dope_item === item.dope_item &&
              orig.ctar_codigo === item.ctar_codigo &&
              orig.entc_codigo === item.entc_codigo
            );
            return {
              ...item,
              cod_padre: null,
              agrupado: false,
              ESTADO_OBJ: enOriginal ? 'U' : 'I'
            };
          }
          return item;
        });
      }

      // Eliminar de tablaAgrupados
      for (let i = this.tablaAgrupados.length - 1; i >= 0; i--) {
        const item = this.tablaAgrupados[i];
        if (item.dope_item === codigoAgrupado || item.cod_padre === codigoAgrupado) {
          this.tablaAgrupados.splice(i, 1);
        }
      }

      // Eliminar de servicioslocales_detalleAgrupacion
      for (let i = this.servicioslocales_detalleAgrupacion.length - 1; i >= 0; i--) {
        const item = this.servicioslocales_detalleAgrupacion[i];
        if (item.dope_item === codigoAgrupado) {
          const encontrado = this.listadoOriginalAgrupados.find(o =>
            o.dope_item === item.dope_item && o.cope_codigo === item.cope_codigo
          );
          if (encontrado) {
            item.ESTADO_OBJ = 'D';
          } else {
            this.servicioslocales_detalleAgrupacion.splice(i, 1);
          }
        }
      }

      // Refrescar tabla
      this.tablaAgrupados = [...this.tablaAgrupados];
      this.servicioslocales_detalleAgrupacion = [...this.servicioslocales_detalleAgrupacion];
      this.edicion = this.tablaAgrupados.length === 0 ? false : true;

      console.log('codigoAgrupado', codigoAgrupado);
      console.log('copecodigo', copecodigo);
      console.log("this.servicioslocales_detalleTarifa", this.servicioslocales_detalleTarifa);
      console.log("this.tablaAgrupados", this.tablaAgrupados);
      console.log("this.servicioslocales_datadetalle", this.servicioslocales_datadetalle);
      console.log("this.servicioslocales_detalleAgrupacion", this.servicioslocales_detalleAgrupacion);
    }

    // Limpiar listas al final
    this.dope_items = [];
    this.cope_codigos = [];
  }

  temp_servicioslocales_datadetalle: any[] = []
  temp_servicioslocales_detalleTarifa: any[] = []
  viewTarifas(row) {
    this.modovisualizar = false;
    this.reset = structuredClone(this.reset);
    this.agrupar = true;
    this.desagrupar = true;
    this.dataTableDetalleAgrupado = [];

    this.leyendasAgrupacionRow = [
      { color: '#9CA3AF', texto: 'NO AGRUPADO' },
      { color: '#2563EB', texto: 'AGRUPADO' },
    ]

    this.temp_servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];
    this.temp_servicioslocales_detalleTarifa = [...this.servicioslocales_detalleTarifa];
    if (row.row.cope_codigo !== null) { // cuando ya existia

      // const datosFiltradosOriginal = this.temp_servicioslocales_datadetalle
      //   .filter(item => item.cod_padre === row.row.dope_item && item.cope_codigo === row.row.cope_codigo);
      // const datosFiltrados = datosFiltradosOriginal.map(item => ({ ...item, ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ }));

      const datosActualizar = this.temp_servicioslocales_datadetalle
        .filter(item => item.cod_padre === row.row.dope_item && item.cope_codigo === row.row.cope_codigo)
        .map(item => ({
          ...item,
          ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ
        }));

      const datosNormales = this.temp_servicioslocales_datadetalle
        .filter(item => !(item.cod_padre === row.row.dope_item && item.cope_codigo === row.row.cope_codigo));

      const datosUnificados = [...datosNormales, ...datosActualizar];

      if (datosActualizar.length > 0) {
        this.servicioslocales_datadetalle = [...datosUnificados];
        this.servicioslocales_detalleTarifa = [...datosUnificados];
      } else {
        const Request: ListarAgrupacionRequest = <ListarAgrupacionRequest>{};
        Request.CODE_Agrupador = row.row.dope_item;
        Request.COPE_Codigo = row.row.cope_codigo;

        this.ordenventaService.ListarAgrupacion(Request).subscribe(response => {
          if (response.datos.status === 200) {
            const datosActualizar = response.datos.result.map(item => {
              return {
                ...item,
                ESTADO_OBJ: ''
              }
            });

            const datosNormales = this.temp_servicioslocales_datadetalle.filter(tempItem =>
              !datosActualizar.some(actualizarItem =>
                tempItem.cope_codigo === actualizarItem.cope_codigo &&
                tempItem.dope_item === actualizarItem.dope_item
              )
            );

            const datosUnificados = [...datosNormales, ...datosActualizar];

            this.servicioslocales_datadetalle = [...datosUnificados];
            this.servicioslocales_detalleTarifa = [...datosUnificados];
          }
        }, (errorServicio) => {
          this.servicioslocales_datadetalle = [];
          this.servicioslocales_detalleTarifa = [];
        });
      }

    } else {
      //cope_codigo es null → solo filtrar por cod_padre
      // const datosFiltradosOriginal = this.temp_servicioslocales_datadetalle
      //   .filter(item => item.cod_padre === row.row.dope_item)
      // const datosFiltrados = datosFiltradosOriginal.map(item => ({ ...item, ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ }));

      const datosActualizar = this.temp_servicioslocales_datadetalle
        .filter(item => item.cod_padre === row.row.dope_item)
        .map(item => ({
          ...item,
          ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ
        }));

      const datosNormales = this.temp_servicioslocales_datadetalle
        .filter(item => item.cod_padre !== row.row.dope_item);

      const datosUnificados = [...datosNormales, ...datosActualizar];

      this.servicioslocales_datadetalle = [...datosUnificados];
      this.servicioslocales_detalleTarifa = [...datosUnificados];
    }
    console.log("this.servicioslocales_datadetalle", this.servicioslocales_datadetalle);
    console.log("this.servicioslocales_detalleTarifa", this.servicioslocales_detalleTarifa);
  }

  AgruparPoppup() {

    if (this.tablaAgrupados.some(t => t.cons_codest !== '001')) {
      this.messageService.add({ severity: 'error', summary: 'Agrupación no permitida', detail: 'No se puede agrupar un servicio que ya ha sido prefacturado o cancelado.', key: 'tl' });
      return;
    }

    if (this.tablaAgrupados.length > 0) {
      const monedaReferencia = this.tablaAgrupados[0].tipo_codmndventa;
      if (this.tablaAgrupados.some(t => t.tipo_codmndventa !== monedaReferencia)) {

        this.messageService.add({
          severity: 'error', summary: 'Agrupación no permitida',
          detail: 'No se pueden agrupar. Todas las operaciones deben tener la misma moneda de venta.', key: 'tl'
        });
        return;
      }
    }

    // validación con profit grupal
    const request: SLI_ValidacionGruposProfitMinimo_Request = {
      profit_t: this.tablaAgrupados.map((item: any): itemsValidacionGrupos => ({
        costo: item.dope_preciototcosto ?? null,
        venta: item.dope_preciototvta ?? null,
        costo_mnd: item.tipo_codmndcosto ?? null,
        venta_mnd: item.tipo_codmndventa ?? null
      }))
    };

    // this.ordenventaService.validacionProfitMinimoGrupal(request).subscribe(res => {
    //   if (res.datos.status === 200) {

    //   }
    // }, err => {
    //   const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
    //   this.messageService.add({ key: 'tl', severity: 'warning', summary: 'Agrupación no permitida', detail: mensaje });
    // })

    // resto de lógica original

    const elementosParaAgrupar = this.tablaAgrupados.filter(row => row.cod_padre === null);
    const existentes = [
      ...this.servicioslocales_datadetalle,
      ...(this.servicioslocales_detalleAgrupacion || [])
    ]
      .filter(i => i.dope_item != null)
      .map(i => Number(i.dope_item));

    const siguienteDope = existentes.length > 0 ? Math.max(...existentes) + 1 : 1;
    // this.tablaAgrupados = this.tablaAgrupados.map(row => {
    //   if (row.cod_padre === null) { return { ...row, cod_padre: siguienteDope, agrupado: true }; }
    //   return row;
    // });

    this.tablaAgrupados = []

    const elementosOriginales = this.servicioslocales_datadetalle.filter(i =>
      elementosParaAgrupar.some(row => i.dope_item === row.dope_item && i.ctar_codigo === row.ctar_codigo && i.cope_codigo === row.cope_codigo)
    );

    const sumaCantidad = elementosOriginales.reduce((acc, cur) => acc + (cur.dope_cantidad || 0), 0);
    const sumaPrecioUnit = elementosOriginales.reduce((acc, cur) => acc + (Number(cur.dope_preciounitvta) || 0), 0);
    const sumaPrecioTotal = elementosOriginales.reduce((acc, cur) => acc + (Number(cur.dope_preciototvta) || 0), 0);

    this.servicioslocales_detalleTarifa = this.servicioslocales_detalleTarifa?.map(item => {
      if (elementosOriginales.some(elim => elim?.dope_item === item?.dope_item && elim?.ctar_codigo === item?.ctar_codigo && elim?.cope_codigo === item?.cope_codigo)) {
        return { ...item, cod_padre: siguienteDope, ESTADO_OBJ: 'A', agrupado: true };
      }
      return item;
    });
    this.servicioslocales_detalleTarifa = [...this.servicioslocales_detalleTarifa];

    this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.map(item => {
      if (elementosOriginales.some(elim => elim.dope_item === item.dope_item && elim.ctar_codigo === item.ctar_codigo && elim.cope_codigo === item.cope_codigo)) {
        return { ...item, cod_padre: siguienteDope, ESTADO_OBJ: 'A', agrupado: true };
      }
      return item;
    });

    this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];

    const itemAgrupado = {
      ctar_codigo: null,
      dtar_codigo: null,
      cope_codigo: elementosOriginales[0].cope_codigo,
      dope_item: siguienteDope,
      dope_cantidad: sumaCantidad,
      dope_preciototvta: sumaPrecioTotal,
      dope_preciounitvta: sumaPrecioUnit,
      serv_nombre_spa: "Servicio Local",
      agrupado: true,
      cod_padre: null,
      ESTADO_OBJ: 'I'
    };

    this.servicioslocales_detalleAgrupacion = [...this.servicioslocales_detalleAgrupacion, itemAgrupado];
    this.edicion = false
    this.agrupar = true;
    console.log("this.servicioslocales_detalleTarifa", this.servicioslocales_detalleTarifa);
    console.log("this.tablaAgrupados", this.tablaAgrupados);
    console.log("this.servicioslocales_datadetalle", this.servicioslocales_datadetalle);
    console.log("this.servicioslocales_detalleAgrupacion", this.servicioslocales_detalleAgrupacion);
  }
  edicion: boolean = false
  async addTarifa(event, row, accion, tipo) {
    console.log("verTarifa", event)
    console.log("verTarifa row", row)
    if (event.checked.length > 0) {
      const existentes = [
        ...this.servicioslocales_datadetalle,
        ...(this.servicioslocales_detalleAgrupacion || [])
      ].filter(i => i.dope_item != null).map(i => Number(i.dope_item));
      const siguienteDope = existentes.length > 0 ? Math.max(...existentes) + 1 : 1;
      let item
      const unidadCodigo = row.unidad?.value || row.cons_codbas;
      const packCodigo = row.contenedor?.value;
      let ventaUnit = row.tipo_codmndcosto === '001' ? Number(row.montoventadolares) : Number(row.venta)
      let costo_tariff = Number(row.costo) ?? 0;

      if (row.proveedor === null) {
        row.select = false;
        this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No se puede agregar un servicio local sin proveedor asignado.', life: 5000, key: "tar" });
        return;
      }
      // if (unidadCodigo === undefined || unidadCodigo === null || unidadCodigo === '') {
      //   row.select = false;
      //   this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No se puede agregar un servicio local sin contenedor asignado.', life: 5000, key: "tl" });
      //   return;
      // }

      const tiposValidos = ['ALM', 'TNS', 'SLI', 'AGE', 'EXT', 'TC'];

      const sinTipoEntidad = !row.tipo_entidad || row.tipo_entidad === "" || (typeof row.tipo_entidad === 'object' && !row.tipo_entidad.value);

      // if (sinTipoEntidad && tiposValidos.includes(tipo) && accion === 'I'
      // && !['003', '004', '006', '007'].includes(row.tipO_CodTAR ?? '')) {
      //   row.select = false;

      //   if (event && Array.isArray(event.checked)) {
      //     const index = event.checked.indexOf(row.key ?? row);
      //     if (index !== -1) {
      //       event.checked.splice(index, 1);
      //     } else {
      //       event.checked = [];
      //     }
      //   }
      //   this.cdr.detectChanges();

      //   this.messageService.clear();
      //   this.messageService.add({
      //     severity: 'error', summary: 'Tarifa no disponible', life: 6000, key: 'tl',
      //     detail: 'No se puede seleccionar esta tarifa porque no tiene un tipo de proveedor registrado. Por favor, comunícate con el equipo de analistas de costos.',
      //   });

      //   return; 
      // }

      if (tiposValidos.includes(tipo) && accion === 'I' && row.select == true) {
        this.cancelarFilasEdicion();
      }

      if (tipo === 'ALM') {
        const cantidad = this.serviciosytarifas_dataflete.find(item => Number(item.paqueteObj?.value) === Number(packCodigo) && unidadCodigo === '002').dcot_cantidad ?? 1
        const tipecodigo = this.obtenerCodigoPorEntidad(row.almacen?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.almacen?.value ?? row.entc_codigo, 'tipe')
        item = {
          "cons_desc_spa": row.unidad?.label || row.cons_desc_spa,
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": row.almacen?.label || row.entc_razonsocial,
          "entc_codigo": row.almacen?.value || row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label || row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value || row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "cons_codbas": row.unidad?.value || row.cons_codbas,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_tabbas": "BAS",
          "tipoentidad": "PROVEEDOR",
          "tipe_codigo": 2,
          "profit_local": row.profit,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "puedemodRZ": false,
          "verTarifario": true,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'TNS') {
        const cantidad =
          unidadCodigo === '002'
            ? this.serviciosytarifas_dataflete
              .filter(item => item.ESTADO_OBJ !== 'D')
              .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1 : 1;
        const tipecodigo = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'tipe')
        const condicion = this.group_datosGenerales.get('condicion')?.value;
        item = {
          "cons_desc_spa": condicion != '001' ? row.unidad?.label ?? "CONTENEDOR" : "CARGA SUELTA",
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": row.proveedor?.label ?? row.entc_razonsocial,
          "entc_codigo": row.proveedor?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": "Transporte",
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": condicion != '001' ? row.unidad?.value === null ? "002" : row.unidad?.value : '004',
          "cons_tabbas": "BAS",
          "tipoentidad": "PROVEEDOR",
          "tipe_codigo": 2,
          "profit_local": row.profit ?? 0,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'SLI') {
        const cant_cntr = this.serviciosytarifas_dataflete
          .filter(item => item.ESTADO_OBJ !== 'D')
          .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1;
        let cantidad = unidadCodigo === '002' ? cant_cntr : 1;
        const tipecodigo = this.obtenerCodigoPorEntidad(row.linea?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.linea?.value ?? row.entc_codigo, 'tipe')
        let ventaTotal = ventaUnit * cantidad;
        let costoTotal = costo_tariff * cantidad;

        if (row?.tariff_accion === 'PRINCIPAL') {
          const hijos = this.dataTableTarifaServicioLogistico.filter(item => item.tariff_accion === 'HIJO' && item.codigo_grupo === row.codigo_grupo);

          console.log("tarif_hijo", hijos)

          let totalCosto = 0;
          let totalVenta = 0;

          for (let i = 0; i < hijos.length; i++) {

            const hijo = hijos[i];
            const codBase = hijo.unidad?.value || hijo.cons_codbas;
            const canti = await this.calcularCantidadBase(codBase, i, 'servicios_sli', { soloRetornar: true }) || 0;
            cantidad = Math.min(cantidad, Number(canti)); // para almacenar la cantidad mayor 
            const costoUnitario = Number(hijo.costo) || 0;

            const ventaUnitario = hijo.tipo_codmndventa === '001' ? Number(hijo.montoventadolares) : Number(hijo.venta) || 0;
            const costoTotalFila = canti * costoUnitario;
            const ventaTotalFila = canti * ventaUnitario;

            totalCosto += costoTotalFila;
            totalVenta += ventaTotalFila;
          }

          costoTotal = totalCosto;
          ventaTotal = totalVenta;

          // reescribir para que salga el total como unitario
          ventaUnit = ventaTotal;
          costo_tariff = costoTotal;
        }

        item = {
          "cons_desc_spa": row.unidad?.label ?? row.cons_desc_spa,
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": row.proveedor?.label ?? row.entc_razonsocial,
          "entc_codigo": row.proveedor?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label ?? row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": row.unidad?.value ?? row.cons_codbas,
          "cons_tabbas": "BAS",
          "tipoentidad": "PROVEEDOR",
          "tipe_codigo": 2,
          "profit_local": row.profit ?? 0,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'AGE') {
        if (this.group_tarifasAdicionales?.value?.montocif === null && row.concepto?.value === '001' && this.group_tabcotizacion.get('regimen')?.value === '001') {
          row.select = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Para agregar agentes de aduana, primero debe ingresar el monto CIF en el servicio local.', life: 5000, key: "tar" });
          return;
        }
        if (this.group_tarifasAdicionales?.value?.montodam === null && row.concepto?.value === '002') {
          row.select = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Para agregar agentes de aduana, primero debe ingresar el monto DAM en el servicio local.', life: 5000, key: "tar" });
          return;
        }
        // const cantidad = unidadCodigo === undefined || unidadCodigo === '002' ? this.serviciosytarifas_dataflete.find(item => item.select === true)?.dcot_cantidad : 1
        const cantidad = 1;
        const tipecodigo = this.obtenerCodigoPorEntidad(row.agente?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        let profit_minimo = 0; let tipo_profit = 0;
        const tipe = this.obtenerCodigoPorEntidad(row.agente?.value ?? row.entc_codigo, 'tipe')
        const montocif = this.group_tarifasAdicionales?.value?.montocif;
        const montodam = this.group_tarifasAdicionales?.value?.montocif;
        let valorfvta = 0
        let valorfcosto = 0
        if (montocif !== null && row.concepto?.value === '001') { //&& 
          const costo = this.calcularValor(row.tipo_codmndcosto, row.costo, row.tipocambioventa)
          const venta = this.calcularValor(row.tipo_codmndventa, row.venta, row.tipocambioventa)

          const costopm = row.tipo_codmndcosto === null ? 0 : row.tipo_codmndcosto !== '004' ? costo : montocif * costo
          const ventapm = row.tipo_codmndventa === null ? 0 : row.tipo_codmndventa !== '004' ? venta : montocif * venta

          let costominc: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.costo ?? 0;
          let profiminc: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.profitminimo ?? 0;
          let tipoprofitm: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.tipo_codmndprofit ?? 0;
          // let gastoopec: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '004')?.costo ?? 0;

          let costominv: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.venta ?? 0;
          // let gastoopev: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '004')?.venta ?? 0;

          // valorfcosto = Number(costopm) > Number(costominc) ? Number(costopm) + Number(gastoopec) : Number(costominc) + Number(gastoopec)
          // valorfvta = Number(ventapm) > Number(costominv) ? Number(ventapm) + Number(gastoopev) : Number(costominv) + Number(gastoopev)

          if (Number(costopm) > Number(costominc)) {
            valorfcosto = Number(costopm);
            //profit_minimo = row.profitminimo;
            profit_minimo = row.profit;
            //tipo_profit = row.tipoprofitm;
            tipo_profit = row.tipo_codmndprofit;
          } else {
            valorfcosto = Number(costominc);
            profit_minimo = profiminc;
            tipo_profit = tipoprofitm;
          }

          if (Number(ventapm) > Number(costominv)) {
            valorfvta = Number(ventapm);
          } else {
            valorfvta = Number(costominv);
          }

          // valorfcosto = Number(costopm) > Number(costominc) ? Number(costopm) : Number(costominc)
          // valorfvta = Number(ventapm) > Number(costominv) ? Number(ventapm) : Number(costominv)

          row.descripcion_monedacosto = "USD";
          row.descripcion_monedaventa = "USD";
        }
        if (montodam !== null && row.concepto?.value === '002') {
          valorfcosto = this.calcularValor(row.tipo_codmndcosto, row.costo, row.tipocambioventa)
          valorfvta = this.calcularValor(row.tipo_codmndventa, row.venta, row.tipocambioventa)
        }
        if (row.concepto?.value !== '001' && row.concepto?.value !== '002') {
          valorfcosto = this.calcularValor(row.tipo_codmndcosto, row.costo, row.tipocambioventa)
          valorfvta = this.calcularValor(row.tipo_codmndventa, row.venta, row.tipocambioventa)
        }
        const costo_tariff = Number(Math.round(valorfcosto * 100) / 100);
        const venta_tariff = Math.round(valorfvta * 100) / 100;
        item = {
          "cons_desc_spa": 'CONTENEDOR',
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": venta_tariff * cantidad,
          "dope_preciounitvta": venta_tariff,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": row.agente?.label ?? row.entc_razonsocial,
          "entc_codigo": row.agente?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label ?? row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": "002",
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": "002",
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": "002", // codigo de contenedor
          "cons_tabbas": "BAS",
          "tipoentidad": "PROVEEDOR",
          "tipe_codigo": 2,
          "profit_local": profit_minimo ?? 0, //row.profit ?? 0,
          "profit_fijo": profit_minimo ?? 0, //row.profit ?? 0,
          "profitminimo": profit_minimo ?? 0,
          "tipoprofitm": tipo_profit,//row.tipoprofitm,
          "tipomonedam": tipo_profit,//row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(Math.round(valorfcosto * 100) / 100) ?? 0,
          "dope_preciotot_prom": Number(Math.round(valorfcosto * 100) / 100) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": venta_tariff,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'EXT' || tipo === 'TC') {
        const cantidad =
          unidadCodigo === '002'
            ? this.serviciosytarifas_dataflete
              .filter(item => item.estado_obj !== 'D')
              .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1 : 1;

        const tipecodigo = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'tipe')
        item = {
          "cons_desc_spa": row.unidad?.label,
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": this.adicional === true ? { label: row.proveedor?.label || row.proveedor, value: String(row.proveedor?.value) || row.entc_codigo.toString(), tipo: 'PROVEEDOR' } : row.proveedor?.label,
          "entc_codigo": row.proveedor?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label ?? row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": row.unidad?.value,
          "cons_tabbas": "BAS",
          "tipoentidad": 'PROVEEDOR',
          "tipe_codigo": 2,
          "profit_local": row.profit ?? 0,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "msd_editable": true,
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "cliente_tariff": row.cliente_tariff,
        }
      }

      if (tiposValidos.includes(tipo) && accion === 'I' && row.select == true) {
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se agregó un nuevo Servicio SLI.', life: 3000, key: "tl" });
      }

      if (accion === 'I') {
        this.servicioslocales_detalleTarifa = [...this.servicioslocales_detalleTarifa, item];
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle, item];
      } else if (accion === 'A') {
        this.edicion = true;
        this.tablaAgrupados = [...this.tablaAgrupados, row];
        this.agrupar = this.tablaAgrupados.length > 1 ? false : true;
        this.edicion = this.tablaAgrupados.length === 0 ? false : true;
      } else if (accion === 'D') {
        this.desagrupar = false;
        this.dope_items.push(row.dope_item);
        this.cope_codigos.push(row.cope_codigo);
      }
    } else {
      if (accion === 'I') {
        let idx = -1;
        for (let i = this.servicioslocales_detalleTarifa.length - 1; i >= 0; i--) {
          const item = this.servicioslocales_detalleTarifa[i];
          if (
            Number(item.ctar_codigo) === Number(row.ctaR_Codigo) &&
            Number(item.dtar_codigo) === Number(row.dtar_Codigo) &&
            Number(item.rtar_codigo) === Number(row.rtar_Codigo)
          ) {
            idx = i;
            break;
          }
        }
        if (idx !== -1) {
          this.servicioslocales_detalleTarifa = [
            ...this.servicioslocales_detalleTarifa.slice(0, idx),
            ...this.servicioslocales_detalleTarifa.slice(idx + 1)
          ];
        }

        let idx2 = -1;
        for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
          const item = this.servicioslocales_datadetalle[i];
          if (
            Number(item.ctar_codigo) === Number(row.ctaR_Codigo) &&
            Number(item.dtar_codigo) === Number(row.dtar_Codigo) &&
            Number(item.rtar_codigo) === Number(row.rtar_Codigo)
          ) {
            idx2 = i;
            break;
          }
        }

        // if (idx2 !== -1) {
        //   this.servicioslocales_datadetalle = [
        //     ...this.servicioslocales_datadetalle.slice(0, idx2),
        //     ...this.servicioslocales_datadetalle.slice(idx2 + 1)
        //   ];
        // }

        if (idx2 !== -1) {
          const item = this.servicioslocales_datadetalle[idx2];

          if (item.ESTADO_OBJ === 'I') {
            this.servicioslocales_datadetalle = [
              ...this.servicioslocales_datadetalle.slice(0, idx2),
              ...this.servicioslocales_datadetalle.slice(idx2 + 1)
            ];
          } else if (item.ESTADO_OBJ === 'D') {
            return;
          } else {
            // this.servicioslocales_datadetalle[idx2].ESTADO_OBJ = 'D'; no debería hacer nada
          }
        }
      } else if (accion === 'A') {
        let idx = this.tablaAgrupados.findIndex(i =>
          i.dope_item === row.dope_item
          && i.cope_codigo === row.cope_codigo && i.ctar_codigo === row.ctar_codigo
        );

        if (idx === -1) {
          idx = this.tablaAgrupados.findIndex(i => i.dope_item === row.dope_item && i.ctar_codigo === row.ctar_codigo);
        }

        if (idx !== -1) {
          this.tablaAgrupados = [
            ...this.tablaAgrupados.slice(0, idx),
            ...this.tablaAgrupados.slice(idx + 1)
          ];
        }
        if (this.tablaAgrupados.length < 2) {
          this.agrupar = true;
        }
        this.edicion = this.tablaAgrupados.length === 0 ? false : true;
      } else if (accion === 'D') {
        this.desagrupar = true;
        const index = this.dope_items.findIndex((dope, i) =>
          dope === row.dope_item && this.cope_codigos[i] === row.cope_codigo
        );

        if (index !== -1) {
          this.dope_items.splice(index, 1);
          this.cope_codigos.splice(index, 1);
        }
      }
    }
    console.log("this.servicioslocales_detalleTarifa", this.servicioslocales_detalleTarifa);
    console.log("this.servicioslocales_datadetalle", this.servicioslocales_datadetalle);
    console.log("this.tablaAgrupados", this.tablaAgrupados);
    console.log("this.servicioslocales_detalleAgrupacion", this.servicioslocales_detalleAgrupacion);
  }

  eliminarServicio(row, tipo) {
    this.confirmationService.confirm({
      target: event.target,
      message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR?",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (tipo === 'D') {
          for (let i = this.servicioslocales_detalleTarifa.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_detalleTarifa[i];
            if (item?.dope_item === row.dope_item) {
              if (item.ESTADO_OBJ === 'I') {
                this.servicioslocales_detalleTarifa.splice(i, 1);
              } else if (item.ESTADO_OBJ === 'U') {
                item.ESTADO_OBJ = 'D';
              }
            } else if (row.agrupado && row.cod_padre === null && row.ESTADO_OBJ === 'I') {
              if (item.cod_padre === row.dope_item && item.ESTADO_OBJ === 'A') {
                const encontrado = this.listadoOriginal.find(o =>
                  o.dope_item === item.dope_item &&
                  o.cope_codigo === item.cope_codigo
                );

                if (encontrado) {
                  item.ESTADO_OBJ = 'D';
                } else {
                  this.servicioslocales_detalleTarifa.splice(i, 1);
                }
              }
            }
          }
          for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_datadetalle[i];

            if (item?.dope_item === row.dope_item) {
              if (item.ESTADO_OBJ === 'I') {
                this.servicioslocales_datadetalle.splice(i, 1);
              } else if (item.ESTADO_OBJ === 'U') {
                item.ESTADO_OBJ = 'D';
              }
            }

            else if (row.agrupado && row.cod_padre === null && row.ESTADO_OBJ === 'I') {
              if (item.cod_padre === row.dope_item && item.ESTADO_OBJ === 'A') {
                const encontrado = this.listadoOriginal.find(o =>
                  o.dope_item === item.dope_item &&
                  o.cope_codigo === item.cope_codigo
                );

                if (encontrado) {
                  item.ESTADO_OBJ = 'D';
                } else {
                  this.servicioslocales_datadetalle.splice(i, 1);
                }
              }
            }
          }
        } else if (tipo === 'A') {
          for (let i = this.tablaAgrupados.length - 1; i >= 0; i--) {
            if (this.tablaAgrupados[i].cod_padre === row.dope_item) {
              this.tablaAgrupados.splice(i, 1);
            }
          }

          for (let i = this.servicioslocales_detalleAgrupacion.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_detalleAgrupacion[i];
            if (item?.dope_item === row.dope_item) {
              const encontrado = this.listadoOriginalAgrupados.find(o =>
                o.dope_item === item.dope_item && o.cope_codigo === item.cope_codigo
              )?.dope_item;
              if (encontrado != null || encontrado !== undefined) {
                item.ESTADO_OBJ = 'E';
              } else {
                this.servicioslocales_detalleAgrupacion.splice(i, 1);
              }
            }
          }
          for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_datadetalle[i];
            if (item?.cod_padre === row.dope_item) {
              const existeEnOriginal = this.listadoOriginal.some(o =>
                o.dope_item === item.dope_item && o.serv_codigo === item.serv_codigo && o.entc_codigo === item.entc_codigo
              );
              if (existeEnOriginal) {
                item.ESTADO_OBJ = 'D';
              } else {
                if (!item.cons_codest) {
                  item.ESTADO_OBJ = 'D';
                } else {
                  this.servicioslocales_datadetalle.splice(i, 1);
                }
              }
            }
          }
          for (let i = this.servicioslocales_detalleTarifa.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_detalleTarifa[i];
            if (item?.cod_padre === row.dope_item) {
              const existeEnOriginal = this.listadoOriginal.some(o =>
                o.dope_item === item.dope_item && o.cope_codigo === item.cope_codigo
              );
              if (existeEnOriginal) {
                item.ESTADO_OBJ = 'D';
              } else {
                this.servicioslocales_detalleTarifa.splice(i, 1);
              }
            }
          }
        }

        this.servicioslocales_detalleTarifa = [...this.servicioslocales_detalleTarifa];
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];
        this.tablaAgrupados = [...this.tablaAgrupados];
        this.servicioslocales_detalleAgrupacion = [...this.servicioslocales_detalleAgrupacion];
        console.log("this.servicioslocales_detalleTarifa", this.servicioslocales_detalleTarifa)
        console.log("this.servicioslocales_datadetalle", this.servicioslocales_datadetalle)
        console.log("this.tablaAgrupados", this.tablaAgrupados)
        console.log("this.servicioslocales_detalleAgrupacion", this.servicioslocales_detalleAgrupacion)
        this.confirmationService.close();
      },
      reject: () => { this.confirmationService.close(); }
    })
  }

  data_busqueda: any[] = [];
  buscarServicioLogistico(): Promise<void> {

    return new Promise((resolve, reject) => {
      this.dataTableTarifaServicioLogistico = []
      this.metadataTableTarifaServicioLogistico = []

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => item?.paqueteObj?.label?.toLowerCase()?.includes('reefer')
      );

      let entc_codtermport = null;
      if (this.listaItinerariosOV.length > 0) {
        let entc_codtermport;
        switch (this.group_tabcotizacion?.value?.regimen) {
          case "001":
            entc_codtermport = this.listaItinerariosOV?.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
            break;
          case "002":
            entc_codtermport = this.listaItinerariosOV?.[0]?.entc_codtermport;
            break;
          default:
            break;
        }
      }

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_tabcotizacion.get('razonSocial')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_datosGenerales.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "001"
      request.fechaVig = this.group_tarifasAdicionales.value.fechasl
      request.solopromedio = this.group_tarifasAdicionales.value.promedio === null ? false : this.group_tarifasAdicionales.value.promedio
      request.regimen = this.group_tabcotizacion.value.regimen
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.entc_codtermport = entc_codtermport;
      request.transportista = cod_transportista ?? null;
      request.contrato = this.group_datosGenerales.get('numerocontrato')?.value ?? null;
      request.contenedores = this.serviciosytarifas_dataflete
        .filter(x => x.ESTADO_OBJ !== 'D')
        .map(x => ({
          label: String(x.paqueteObj?.value ?? x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '')
        }));
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.metadataTableTarifaServicioLogistico.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            console.log(response.datos.result);
            this.data_busqueda = response.datos.result;
            const resultados = this.data_busqueda;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            const nuevasFilas: any[] = [];
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));

              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }
                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  // row['proft'] = recargo.profit;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['tipoequipo'] = r.tipO_CodCTR
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['cliente_tariff'] = cli_tariff
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTarifaServicioLogistico.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTarifaServicioLogistico.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTarifaServicioLogistico.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTarifaServicioLogistico[index] = item;
                    } else {
                      this.metadataTableTarifaServicioLogistico.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            this.metadataTableTarifaServicioLogistico = this.metadataTableTarifaServicioLogistico.filter(item =>
              !item.field.toLowerCase().includes('costo') &&
              !item.field.toLowerCase().includes('profit')
            );

            this.dataTableTarifaServicioLogistico.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTarifaServicioLogistico.forEach(row => {
              this.metadataTableTarifaServicioLogistico.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });
            const transportistaSeleccionado = this.group_datosGenerales.value.transportista;
            const promedioSeleccionado = this.group_tarifasAdicionales.value.promedio
            if (transportistaSeleccionado && (promedioSeleccionado === false || promedioSeleccionado === null)) {
              this.dataTableTarifaServicioLogistico = this.dataTableTarifaServicioLogistico.filter(row => {
                return row.linea?.label === transportistaSeleccionado;
              });
            }

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {//!existeProveedor
              this.dataTableTarifaServicioLogistico.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['linea'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'linea',
                title: 'Línea',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTarifaServicioLogistico.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTarifaServicioLogistico.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTarifaServicioLogistico.push(itemProveedor);
              }
            }

            // logica filtro por contenedor
            // const packCodigos = this.serviciosytarifas_dataflete.map(item => Number(item.paqueteObj?.value ?? item.pack_desc?.value ?? item.pack_codigo ?? item.pacK_Codigo));

            // this.dataTableTarifaServicioLogistico = this.dataTableTarifaServicioLogistico.filter(row => {
            //   const contenedorVal = String(row.contenedor?.value ?? '');
            //   const almacenVal = String(row.almacen?.value ?? '');

            //   const coincide = packCodigos.includes(Number(contenedorVal));

            //   if (coincide || contenedorVal === '' || contenedorVal === null) {
            //     return true;
            //   }

            //   return false;
            // });

            this.metadataTableTarifaServicioLogistico = this.metadataTableTarifaServicioLogistico.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            // lógica lotes

            const sumasPorPack: Record<string, any> = {};
            this.serviciosytarifas_dataflete
              .filter(x => x.ESTADO_OBJ !== 'D')
              .forEach(x => {
                const key = x.paqueteObj?.value ?? x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '';
                const cantidad = x.dcot_cantidad || 0;
                if (!sumasPorPack[key]) {
                  sumasPorPack[key] = {
                    pack_codigo: key,
                    cantidad: 0
                  };
                }
                sumasPorPack[key].cantidad += cantidad;
              });

            const sumaTotalGlobal = Object.values(sumasPorPack).reduce((acc, curr) => acc + curr.cantidad, 0);

            this.dataTableTarifaServicioLogistico = this.dataTableTarifaServicioLogistico.filter(elemento => {
              if ((elemento.lote_desde === undefined || Number(elemento.lote_desde) === 0) &&
                (elemento.lote_hasta === undefined || Number(elemento.lote_hasta) === 0)) {
                return true;
              }

              const contenedorValue = elemento.contenedor?.value ?? '';
              let cantidadAComparar = 0;

              if (contenedorValue !== '' && contenedorValue != null) {
                const packData = sumasPorPack[contenedorValue];
                cantidadAComparar = packData ? packData.cantidad : 0;
              } else {
                cantidadAComparar = sumaTotalGlobal;
              }

              return cantidadAComparar > 0 &&
                cantidadAComparar >= elemento.lote_desde &&
                cantidadAComparar <= elemento.lote_hasta;
            });

            // logica para tarifa con unidades combinadas (cont + fijo)

            let codigoGrupo = 1;

            for (let i = 0; i < this.dataTableTarifaServicioLogistico.length; i++) {

              const item = this.dataTableTarifaServicioLogistico[i];

              if (item.codigo_grupo) { continue; }

              const grupo = this.dataTableTarifaServicioLogistico.filter(x =>
                x.ctaR_Codigo === item.ctaR_Codigo &&
                x.servicio?.value === item.servicio?.value &&
                x.linea?.value === item.linea?.value &&
                x.proveedor?.value === item.proveedor?.value &&
                x.lote_desde === item.lote_desde &&
                x.lote_hasta === item.lote_hasta
              );

              if (grupo.length > 1) {

                grupo.forEach(x => {
                  x.tariff_accion = 'HIJO';
                  x.codigo_grupo = codigoGrupo;
                });
                const costoTotal = grupo.reduce((sum, x) => sum + Number(x.costo || 0), 0);
                const ventaTotal = grupo.reduce((sum, x) => sum + Number(x.venta || 0), 0);
                const montoVentaDolaresTotal = grupo.reduce((sum, x) => sum + Number(x.montoventadolares || 0), 0);
                const profitTotal = grupo.reduce((sum, x) => sum + Number(x.profit || 0), 0);
                const profitMinimoTotal = grupo.reduce((sum, x) => sum + Number(x.profitminimo || 0), 0);
                const rtaRValueCostoTotal = grupo.reduce((sum, x) => sum + Number(x.rtaR_ValueCosto || 0), 0);
                const rtaRValueVentaTotal = grupo.reduce((sum, x) => sum + Number(x.rtaR_ValueVenta || 0), 0);

                const principal = {
                  ...grupo[0],
                  tariff_accion: 'PRINCIPAL',
                  codigo_grupo: codigoGrupo,
                  costo: costoTotal,
                  venta: ventaTotal,
                  montoventadolares: montoVentaDolaresTotal,
                  profit: profitTotal,
                  profitminimo: profitMinimoTotal,
                  rtaR_ValueCosto: rtaRValueCostoTotal,
                  rtaR_ValueVenta: rtaRValueVentaTotal
                };

                this.dataTableTarifaServicioLogistico.push(principal);

                codigoGrupo++;
              }
            }

            this.metadataTableTarifaServicioLogistico.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTarifaServicioLogistico.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTarifaServicioLogistico = [...this.metadataTableTarifaServicioLogistico];
            this.dataTableTarifaServicioLogistico = [...this.dataTableTarifaServicioLogistico];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableTarifaServicioLogistico", this.dataTableTarifaServicioLogistico);
      console.log("metadataTableTarifaServicioLogistico", this.metadataTableTarifaServicioLogistico);
    })
  }
  data_Almacen: any[] = [];
  buscarTarifaAlmacen(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.data_Almacen = []
      this.metadataTableTarifaAlmacen = []
      this.dataTableTarifaAlmacen = []
      let entc_codtermport = null;
      if (this.listaItinerariosOV.length > 0) {
        switch (this.group_tabcotizacion?.value?.regimen) {
          case "001":
            entc_codtermport = this.listaItinerariosOV?.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
            break;
          case "002":
            entc_codtermport = this.listaItinerariosOV?.[0]?.entc_codtermport;
            break;
          default:
            break;
        }
      }

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_tabcotizacion.get('razonSocial')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_datosGenerales.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = this.codTransporte
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "003"
      request.fechaVig = this.group_tarifasAdicionales.value.fechasl
      request.solopromedio = this.group_tarifasAdicionales.value.promedio === null ? false : this.group_tarifasAdicionales.value.promedio
      request.regimen = this.group_tabcotizacion.value.regimen
      request.cliente = cod_cliente ?? null;
      request.entc_codtermport = entc_codtermport;
      request.contenedores = this.serviciosytarifas_dataflete
        .filter(x => x.ESTADO_OBJ !== 'D')
        .map(x => ({
          label: String(x.paqueteObj?.value ?? x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '')
        }));
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            console.log(response.datos.result);
            this.metadataTableTarifaAlmacen.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.data_Almacen = response.datos.result;
            const resultados = this.data_Almacen;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));

              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }
                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['color'] = detalle.eshijo === true ? '#9aef9e' : 'white'
                  row['cons_tabtds'] = "TDS";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['cliente_tariff'] = cli_tariff
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTarifaAlmacen.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTarifaAlmacen.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTarifaAlmacen.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTarifaAlmacen[index] = item;
                    } else {
                      this.metadataTableTarifaAlmacen.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            this.metadataTableTarifaAlmacen = this.metadataTableTarifaAlmacen.filter(item =>
              !item.field.toLowerCase().includes('costo') &&
              !item.field.toLowerCase().includes('profit')
            );

            this.dataTableTarifaAlmacen.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTarifaAlmacen.forEach(row => {
              this.metadataTableTarifaAlmacen.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            // const packCodigos = this.serviciosytarifas_dataflete.map(item => Number(item.paqueteObj?.value ?? item.pack_desc?.value ?? item.pack_codigo ?? item.pacK_Codigo));

            // this.dataTableTarifaAlmacen = this.dataTableTarifaAlmacen.filter(row => {
            //   const contenedorVal = String(row.contenedor?.value ?? '');
            //   const almacenVal = String(row.almacen?.value ?? '');
            //   const clave = `${contenedorVal}-${almacenVal}`;

            //   const coincide = packCodigos.includes(Number(contenedorVal));

            //   // if (coincide && !vistos.has(clave)) {
            //   //   vistos.add(clave);
            //   //   return true;
            //   // }

            //   if (coincide || contenedorVal === '' || contenedorVal === null) {

            //     return true;
            //   }

            //   return false;
            // });

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableTarifaAlmacen.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['almacen'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'almacen',
                title: 'Almacén',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTarifaAlmacen.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTarifaAlmacen.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTarifaAlmacen.push(itemProveedor);
              }
            }

            // filtro terminal portuario
            // if (this.listaItinerariosOV.length > 0) {
            //   let entc_codtermport;
            //   switch (this.group_tabcotizacion?.value?.regimen) {
            //     case "001":
            //       entc_codtermport = this.listaItinerariosOV?.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
            //       break;
            //     case "002":
            //       entc_codtermport = this.listaItinerariosOV?.[0]?.entc_codtermport;
            //       break;
            //     default:
            //       break;
            //   }
            //   if (entc_codtermport !== null && !isNaN(entc_codtermport)) {
            //     this.dataTableTarifaAlmacen = this.dataTableTarifaAlmacen.filter(
            //       (row: any) => Number(row.terminal?.value) === Number(entc_codtermport)
            //     );
            //   }
            // }

            this.metadataTableTarifaAlmacen = this.metadataTableTarifaAlmacen.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableTarifaAlmacen.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTarifaAlmacen.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTarifaAlmacen = [...this.metadataTableTarifaAlmacen];
            this.dataTableTarifaAlmacen = [...this.dataTableTarifaAlmacen];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableTarifaAlmacen", this.dataTableTarifaAlmacen);
      console.log("metadataTableTarifaAlmacen", this.metadataTableTarifaAlmacen);
    })
  }

  dataTransporte: any[] = [];
  buscarTransporte(event): Promise<void> {
    return new Promise((resolve, reject) => {
      console.log(event)

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => item?.paqueteObj?.label?.toLowerCase()?.includes('reefer')
      );

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_tabcotizacion.get('razonSocial')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_datosGenerales.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = event.value === '004' ? "002" : "006"
      request.CONS_CodFLE = event.value
      request.fechaVig = this.group_tarifasAdicionales.value.fechasl
      request.solopromedio = this.group_tarifasAdicionales.value.promedio === null ? false : this.group_tarifasAdicionales.value.promedio
      request.regimen = this.group_tabcotizacion?.value?.regimen
      request.peso_sli = this.group_tarifasAdicionales.get('peso')?.value ?? null;
      request.unmd_peso = this.group_tarifasAdicionales.get('unmd_peso')?.value ?? null;
      request.volumen_sli = this.group_tarifasAdicionales.get('volumen')?.value ?? null;
      request.unmd_volumen = this.group_tarifasAdicionales.get('unmd_volumen')?.value ?? null;
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.ruta = this.group_tarifasAdicionales.get('rutas')?.value;
      request.puerto = request.regimen == '001' ? this.group_datosGenerales.get('puertodestino').value : request.regimen == '002' ? this.group_datosGenerales.get('puertoorigen').value : null
      request.puerto2 = request.regimen == '002' ? this.group_datosGenerales.get('puertodestino').value : request.regimen == '001' ? this.group_datosGenerales.get('puertoorigen').value : null
      this.dataTransporte = []
      this.dataTableTransporte = []
      this.metadataTableTransporte = []
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            console.log(response.datos.result);
            this.metadataTableTransporte.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.dataTransporte = response.datos.result;
            const resultados = this.dataTransporte;
            const tipocambioventa = resultados[0].tipocambioventa;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));
              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    // row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                    //   value: recargo.rtaR_CodigoInterno,
                    //   label: recargo.rtaR_ValueDescripcion,
                    //   tipovalue: recargo.recO_Lista
                    // } : '';
                    row[columnName] = (recargo.rtaR_CodigoInterno && recargo.rtaR_ValueDescripcion)
                      ? { value: recargo.rtaR_CodigoInterno, label: recargo.rtaR_ValueDescripcion, tipovalue: recargo.recO_Lista }
                      : null;

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }

                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'valor_unm') {
                    if (recargo.recO_Codigo === 15) {
                      //  if (recargo.recO_Codigo === 15 || recargo.recO_Codigo === 41 || recargo.recO_Codigo === 43) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      // } else if (recargo.recO_Codigo === 16 || recargo.recO_Codigo === 42 || recargo.recO_Codigo === 44) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }

                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['cliente_tariff'] = cli_tariff
                  // row['tipoequipo'] = recargo.carga?.label
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTransporte.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTransporte.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
              if (totalColumn && !columnasSet.has(totalColumn)) {
                this.dataTableTransporte.push({ field: totalColumn, title: totalColumn, inputType: 'text', filterType: 'text', });
                columnasSet.add(totalColumn);
              }
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTransporte.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTransporte[index] = item;
                    } else {
                      this.metadataTableTransporte.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            this.metadataTableTransporte = this.metadataTableTransporte.filter(item =>
              !item.field.toLowerCase().includes('costo') &&
              !item.field.toLowerCase().includes('profit') && !item.field.toLowerCase().includes('distrito')
            );

            this.metadataTableTransporte.push(
              { field: 'tipocambioventa', title: 'Tipo Cambio Venta', inputType: 'decimal' },
              { field: 'montoventadolares', title: 'Monto Venta Dólares', inputType: 'decimal' }
            );

            this.dataTableTransporte.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTransporte.forEach(row => {
              this.metadataTableTransporte.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            const rutaSeleccionada = this.group_tarifasAdicionales?.value?.rutas;
            if (rutaSeleccionada !== null) {
              this.dataTableTransporte = this.dataTableTransporte.filter(row => {
                return Number(row.ruta?.value) === Number(rutaSeleccionada);
              });
            }

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableTransporte.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['proveedor'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'proveedor',
                title: 'Proveedor',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTransporte.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTransporte.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTransporte.push(itemProveedor);
              }
            }

            // const hayReefer = this.serviciosytarifas_dataflete?.some(
            //   (item: any) => item?.paqueteObj?.label?.toLowerCase()?.includes('reefer')
            // );
            // if (event.value === '004') {
            //   if (hayReefer === true) {
            //     this.dataTableTransporte = this.dataTableTransporte.filter(
            //       (row: any) => String(row.carga?.value) === '001'
            //     );
            //   } else {
            //     this.dataTableTransporte = this.dataTableTransporte.filter(
            //       (row: any) => String(row.carga?.value) === '002'
            //     );
            //   }
            // }

            this.metadataTableTransporte = this.metadataTableTransporte.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableTransporte.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTransporte.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTransporte = [...this.metadataTableTransporte];
            this.dataTableTransporte = [...this.dataTableTransporte];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableTransporte", this.dataTableTransporte);
      console.log("metadataTableTransporte", this.metadataTableTransporte);
    });
  }
  dataAgeAduana: any[] = [];
  buscarAgenteAduana(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.dataTableAgeAduana = []
      this.metadataTableAgeAduana = []
      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "004";
      request.fechaVig = this.group_tarifasAdicionales.value.fechasl
      request.solopromedio = this.group_tarifasAdicionales.value.promedio === null ? false : this.group_tarifasAdicionales.value.promedio
      request.regimen = this.group_tabcotizacion?.value?.regimen
      request.cliente = this.codigoRazonSocial ?? null;
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status == 200) {
            this.metadataTableAgeAduana.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            console.log(response.datos.result);
            this.dataAgeAduana = response.datos.result;
            const resultados = this.dataAgeAduana;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            const nuevasFilas: any[] = [];
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));

              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'unidad_valor') {
                    if (recargo.recO_Codigo === 15 || recargo.recO_Codigo === 35) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16 || recargo.recO_Codigo === 36) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }
                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  // row['proft'] = recargo.profit;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['tipo_codrgm'] = r.conS_CodRGM
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['cliente_tariff'] = cli_tariff
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableAgeAduana.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableAgeAduana.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableAgeAduana.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableAgeAduana[index] = item;
                    } else {
                      this.metadataTableAgeAduana.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });


            this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
              !item.field.toLowerCase().includes('costo') &&
              !item.field.toLowerCase().includes('profit') &&
              !item.field.toLowerCase().includes('tipo') &&
              !item.field.toLowerCase().includes('cif')
            );

            this.dataTableAgeAduana.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableAgeAduana.forEach(row => {
              this.metadataTableAgeAduana.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });
            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableAgeAduana.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['agente'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'agente',
                title: 'Agente',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableAgeAduana.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableAgeAduana.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableAgeAduana.push(itemProveedor);
              }
            }

            const montocif = this.group_tarifasAdicionales?.value?.montocif;

            if (montocif !== null && montocif !== undefined) {
              this.dataTableAgeAduana = this.dataTableAgeAduana.filter(row => {
                if (row.concepto?.value === '001') {
                  const min = parseFloat(row.rango_minimo);
                  const max = parseFloat(row.rango_maximo);
                  return !isNaN(min) && !isNaN(max) && montocif >= min && montocif <= max;
                }
                return true;
              });
            }


            const montodam = this.group_tarifasAdicionales?.value?.montodam;

            if (montodam !== null && montodam !== undefined) {
              this.dataTableAgeAduana = this.dataTableAgeAduana.filter(row => {
                if (row.concepto?.value === '002') {
                  const min = parseFloat(row.rango_minimo);
                  const max = parseFloat(row.rango_maximo);
                  return !isNaN(min) && !isNaN(max) && montodam >= min && montodam <= max;
                }
                return true;
              });
            }

            this.metadataTableAgeAduana = this.metadataTableAgeAduana.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableAgeAduana.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableAgeAduana.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableAgeAduana = [...this.metadataTableAgeAduana];
            this.dataTableAgeAduana = [...this.dataTableAgeAduana];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableAgeAduana", this.dataTableAgeAduana);
      console.log("metadataTableAgeAduana", this.metadataTableAgeAduana);
    });
  }
  dataTableExtras: any[] = []
  metadataTableExtras: newmetadate[] = []
  dataExtras: any[] = [];
  buscarTarifasExtra(event): Promise<void> {
    return new Promise((resolve, reject) => {
      console.log(event)

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => {
          const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
          return label?.toLowerCase()?.includes('reefer');
        }
      );

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_tabcotizacion.get('razonSocial')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_datosGenerales.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "007"
      request.CONS_CodFLE = event.value
      request.fechaVig = this.group_tarifasAdicionales.value.fechasl
      request.solopromedio = this.group_tarifasAdicionales.value.promedio === null ? false : this.group_tarifasAdicionales.value.promedio
      request.regimen = this.group_tabcotizacion?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_datosGenerales.get('puertodestino').value : request.regimen == '002' ? this.group_datosGenerales.get('puertoorigen').value : null
      request.peso_sli = this.group_tarifasAdicionales.get('peso')?.value ?? null;
      request.unmd_peso = this.group_tarifasAdicionales.get('unmd_peso')?.value ?? null;
      request.volumen_sli = this.group_tarifasAdicionales.get('volumen')?.value ?? null;
      request.unmd_volumen = this.group_tarifasAdicionales.get('unmd_volumen')?.value ?? null;
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.ruta = this.group_tarifasAdicionales.value.ruta;
      request.transportista = cod_transportista ?? null;
      this.dataTableExtras = []
      this.dataExtras = []
      this.metadataTableExtras = []
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            console.log(response.datos.result);
            this.metadataTableExtras.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.dataExtras = response.datos.result;
            const resultados = this.dataExtras;
            const tipocambioventa = resultados[0].tipocambioventa;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));
              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'valor_unm') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }

                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['cliente_tariff'] = cli_tariff
                  // row['tipoequipo'] = recargo.carga?.label
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableExtras.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableExtras.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
              if (totalColumn && !columnasSet.has(totalColumn)) {
                this.dataTableExtras.push({ field: totalColumn, title: totalColumn, inputType: 'text', filterType: 'text', });
                columnasSet.add(totalColumn);
              }
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableExtras.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableExtras[index] = item;
                    } else {
                      this.metadataTableExtras.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableExtras = this.metadataTableExtras.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit') && !item.field.toLowerCase().includes('distrito')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('distrito')
              );
            }

            // this.metadataTableExtras.push(
            //   { field: 'tipocambioventa', title: 'Tipo Cambio Venta', inputType: 'decimal' },
            //   { field: 'montoventadolares', title: 'Monto Venta Dólares', inputType: 'decimal' }
            // );

            this.dataTableExtras.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableExtras.forEach(row => {
              this.metadataTableExtras.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            // const rutaSeleccionada = this.group_servicioslocales?.value?.rutas;
            // if (rutaSeleccionada !== null) {
            //   this.dataTableExtras = this.dataTableExtras.filter(row => {
            //     return Number(row.ruta?.value) === Number(rutaSeleccionada);
            //   });
            // }

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableExtras.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['proveedor'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'proveedor',
                title: 'Proveedor',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableExtras.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableExtras.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableExtras.push(itemProveedor);
              }
            }
            this.metadataTableExtras = this.metadataTableExtras.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableExtras.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableExtras.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableExtras = [...this.metadataTableExtras];
            this.dataTableExtras = [...this.dataTableExtras];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableExtras", this.dataTableExtras);
      console.log("metadataTableExtras", this.metadataTableExtras);
    });
  }
  dataTableTc: any[] = []
  metadataTableTc: newmetadate[] = []
  dataTc: any[] = [];
  buscarTarifasTacna(event): Promise<void> {
    return new Promise((resolve, reject) => {
      console.log(event)

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => {
          const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
          return label?.toLowerCase()?.includes('reefer');
        }
      );

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_tabcotizacion.get('razonSocial')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_datosGenerales.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "008"
      request.CONS_CodFLE = event.value
      request.fechaVig = this.group_tarifasAdicionales.value.fechasl
      request.solopromedio = this.group_tarifasAdicionales.value.promedio === null ? false : this.group_tarifasAdicionales.value.promedio
      request.regimen = this.group_tabcotizacion?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_datosGenerales.get('puertodestino').value : request.regimen == '002' ? this.group_datosGenerales.get('puertoorigen').value : null
      request.cliente = cod_cliente ?? null;
      request.ruta = this.group_tarifasAdicionales.value.ruta;
      request.transportista = cod_transportista ?? null;
      this.dataTableTc = []
      this.dataTc = []
      this.metadataTableTc = []
      request.contenedores = this.serviciosytarifas_dataflete
        .filter(x => x.ESTADO_OBJ !== 'D')
        .map(x => ({
          label: String(x.paqueteObj?.value ?? x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '')
        }));
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            console.log(response.datos.result);
            this.metadataTableTc.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.dataTc = response.datos.result;
            const resultados = this.dataTc;
            const tipocambioventa = resultados[0].tipocambioventa;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';

            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));
              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }

                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'valor_unm') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }

                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['cliente_tariff'] = cli_tariff
                  // row['tipoequipo'] = recargo.carga?.label
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTc.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTc.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
              if (totalColumn && !columnasSet.has(totalColumn)) {
                this.dataTableTc.push({ field: totalColumn, title: totalColumn, inputType: 'text', filterType: 'text', });
                columnasSet.add(totalColumn);
              }
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTc.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTc[index] = item;
                    } else {
                      this.metadataTableTc.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableTc = this.metadataTableTc.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit') && !item.field.toLowerCase().includes('distrito')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('distrito')
              );
            }

            // this.metadataTableTc.push(
            //   { field: 'tipocambioventa', title: 'Tipo Cambio Venta', inputType: 'decimal' },
            //   { field: 'montoventadolares', title: 'Monto Venta Dólares', inputType: 'decimal' }
            // );

            this.dataTableTc.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTc.forEach(row => {
              this.metadataTableTc.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            // const packCodigos = this.serviciosytarifas_dataflete
            //   .filter(item => item.ESTADO_OBJ !== 'D')
            //   .map(item =>
            //     Number(item.paqueteObj?.value ?? item.pack_desc?.value ?? item.pack_codigo ?? item.pacK_Codigo)
            //   );

            // this.dataTableTc = this.dataTableTc.filter(row => {
            //   const contenedorVal = String(row.contenedor?.value ?? '');

            //   const coincide = packCodigos.includes(Number(contenedorVal));

            //   if (coincide || contenedorVal === '' || contenedorVal === null) {
            //     return true;
            //   }

            //   return false;
            // });

            // const rutaSeleccionada = this.group_servicioslocales?.value?.rutas;
            // if (rutaSeleccionada !== null) {
            //   this.dataTableTc = this.dataTableTc.filter(row => {
            //     return Number(row.ruta?.value) === Number(rutaSeleccionada);
            //   });
            // }

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableTc.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['proveedor'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'proveedor',
                title: 'Proveedor',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTc.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTc.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTc.push(itemProveedor);
              }
            }
            this.metadataTableTc = this.metadataTableTc.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableTc.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTc.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTc = [...this.metadataTableTc];
            this.dataTableTc = [...this.dataTableTc];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableTc", this.dataTableTc);
      console.log("metadataTableTc", this.metadataTableTc);
    });
  }
  ResetTabla() {
    this.leyendasAgrupacionRow = [];
    this.servicioslocales_datadetalle = [];
    this.servicioslocales_detalleTarifa = [];
    this.servicioslocales_datadetalle = this.temp_servicioslocales_datadetalle;
    this.servicioslocales_detalleTarifa = this.temp_servicioslocales_detalleTarifa;
    this.temp_servicioslocales_datadetalle = [];
    this.temp_servicioslocales_detalleTarifa = [];
    this.modovisualizar = true
    this.reset = structuredClone(this.reset);
  }

  visibleOCompra: boolean
  crearOrdenServicio() {
    this.visibleOCompra = true
  }

  rowAuth: any[] = [];
  btnToken: boolean = true;
  SolicitarAutorizacion(row) {
    this.rowAuth = [];
    this.groupAuth.reset();
    if (this.rol === '9' || this.rol === '2' || this.rol === '1' || this.rol === '15' || this.rol === '1030' || this.rol === '4') {
      this.visibleAuth = true
      this.groupAuth.get('tipoauth').setValue('U');
      if (row?.row) {
        this.rowAuth = row?.row;
        const Request: ConsultarVigenciaTokenRequest = <ConsultarVigenciaTokenRequest>{}
        Request.COPE_Codigo = this.rowAuth['cope_codigo'];
        Request.DOPE_Item = this.rowAuth['dope_item'];
        Request.SERV_Codigo = this.rowAuth['serv_codigo'];
        Request.AUDI_Usuario = 'ext_ichumpitaz'//this.storage.get('usuario');
        Request.ENTC_CodCliente = Number(this.codigoRazonSocial);
        Request.monto_solicitado = this.rowAuth['dope_preciounitvta'];
        this.ordenventaService.ConsultarVigenciaToken(Request).subscribe(response => {
          if (response.datos.status === 200) {
            switch (response.datos.result[0].vigencia) {
              case 'NV':
                this.btnToken = true;
                break;
              default:
                this.btnToken = false;
                this.mensajeIntento = `Le quedan solo ${response.datos.result[0].vigencia} intentos para ingresar el token.`;
            }
          }
        })
      }
      console.log(row?.row)
    } else {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Sin permisos', detail: 'No cuenta con permisos suficientes para realizar esta acción.', life: 3000, key: "tl" });
    }
  }

  GenerarTokenAuth() {
    if (this.rowAuth != null || this.rowAuth != undefined) {
      const costoDolares = this.rowAuth['tipo_codmnd'] === '001'
        ? Number(this.rowAuth['dope_preciounitcosto']) / Number(this.rowAuth['tipocambioventa'])
        : Number(this.rowAuth['dope_preciounitcosto']);
      const ventaOrigin = Number(this.rowAuth['profit_fijo']) + Number(costoDolares.toFixed(2));
      const Request: GenerarTokenAutorizacionRequest = <GenerarTokenAutorizacionRequest>{}
      Request.COPE_Codigo = this.rowAuth['cope_codigo'];
      Request.DOPE_Item = this.rowAuth['dope_item'];
      Request.SERV_Codigo = this.rowAuth['serv_codigo'];
      Request.AUDI_Usuario = 'ext_ichumpitaz'//this.storage.get('usuario');
      Request.CCOT_NumDoc = this.datosRecibidos?.ccot_numdoc || null
      Request.ventaTarifa = ventaOrigin
      Request.ventaSolicitada = Number(this.rowAuth['dope_preciounitvta']);
      Request.asunto = this.datosRecibidos?.ccot_numdoc != null || this.datosRecibidos?.ccot_numdoc != undefined ?
        `(PRUEBA)Solicito autorización para cambio de flete - Cotización ${this.datosRecibidos?.ccot_numdoc}` :
        `(PRUEBA)Solicito autorización para cambio de flete - Cliente ${this.group_tarifasAdicionales.value.clienteDSL}`
      Request.servicio = this.rowAuth['serv_nombre_spa'];
      Request.monedaVenta = this.ListaTodosMoneda.find(m => m.codigo === this.rowAuth['tipo_codmndventa'])?.adicional2;
      Request.ENTC_CodCliente = Number(this.codigoRazonSocial)
      Request.monto_solicitado = Number(this.rowAuth['dope_preciounitvta']);
      Request.nombreCliente = this.group_tabcotizacion.value.razonSocial
      Request.tipoAuth = 'V'
      this.ordenventaService.GenerarTokenAutorizacion(Request).subscribe(response => {
        if (response.datos.status === 200) {
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se generó el token de autorización correctamente. Solicite a su supervisor.', life: 3000, key: "tl" });
          this.btnToken = false
          this.mensajeIntento = "Solo tiene 3 intentos para ingresar el token."
        }
      }, (errorServicio) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorServicio.error.meta.mensaje, life: 3000, key: "tl" });
      })
    }
  }

  modoT: boolean = false;
  mensajeError: string;
  mensajeIntento: string;
  mostrarModAuth(event) {
    console.log(event)
    if (event === 'U') {
      this.modoT = false;
      this.groupAuth.get('usuario')?.setValidators([Validators.required]);
      this.groupAuth.get('contrasenia')?.setValidators([Validators.required]);
      this.groupAuth.get('token')?.clearValidators();
      this.groupAuth.get('token')?.updateValueAndValidity();
      this.groupAuth.get('token')?.reset();
      this.mensajeError = null
    } else {
      this.modoT = true;
      this.groupAuth.get('token')?.setValidators([Validators.required]);
      this.groupAuth.get('usuario')?.clearValidators();
      this.groupAuth.get('usuario')?.updateValueAndValidity();
      this.groupAuth.get('usuario')?.reset();
      this.groupAuth.get('contrasenia')?.clearValidators();
      this.groupAuth.get('contrasenia')?.updateValueAndValidity();
      this.groupAuth.get('contrasenia')?.reset();
      this.mensajeError = 'Este campo es obligatorio'
    }
  }

  async login() {
    const values = this.groupAuth.value;
    const Request: ListarDatosLoginRequest = {
      Usuario: values.usuario,
      Clave: values.contrasenia
    };
    const response = await firstValueFrom(this.ordenventaService.ListarDatosLogin(Request));
    if (response.datos.status === 200) {
      return response.datos.result[0];
    }
    return []
  }
  intentoU: number = 0;
  monto_original: number;
  async AutorizarCambioVenta(accion) {
    const Request: TransaccionAuthCambioVtaRequest = <TransaccionAuthCambioVtaRequest>{}
    Request.COPE_Codigo = this.rowAuth['cope_codigo'];
    Request.DOPE_Item = this.rowAuth['dope_item'];
    Request.SERV_Codigo = this.rowAuth['serv_codigo'];
    Request.AUDI_Usuario = 'ext_ichumpitaz'//this.storage.get('usuario');
    Request.token = this.groupAuth.get('token').value;
    Request.usuario_autoriza = this.groupAuth.get('usuario').value;
    Request.monto_solicitado = this.rowAuth['dope_preciounitvta'];
    Request.ENTC_CodCliente = Number(this.codigoRazonSocial)
    Request.monto_original = this.monto_original
    Request.tipoAuth = 'V'
    if (this.groupAuth.get('tipoauth').value === 'U') {
      const datosLogin = await this.login();
      const esTodoNull = Object.values(datosLogin).every(value => value === null);
      if (esTodoNull) {
        this.intentoU++;
        Request.tipo = accion === 'N' ? 'N' : null;
        if (this.intentoU >= 3) {
          this.visibleAuth = false;
          this.intentoU = 0;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Se acabaron los intentos, vuelva a intentarlo más tarde.', life: 3000, key: "tl" });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Credenciales incorrectas', life: 3000, key: "tl" });
        }
      } else {
        switch (datosLogin['codigoRol']) {
          case 1:
          case 2:
          case 9:
          case 15:
          case 1030:
            Request.tipo = accion === 'A' ? this.groupAuth.get('tipoauth').value : accion;
            break;
          default:
            this.intentoU++;
            if (this.intentoU >= 3) {
              this.visibleAuth = false;
              this.intentoU = 0;
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Se acabaron los intentos, vuelva a intentarlo más tarde.', life: 3000, key: "tl" });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No cuenta con permisos suficientes para realizar esta acción.', life: 3000, key: "tl" });
            }
            break;
        }
      }
    } else {
      Request.tipo = accion === 'A' ? this.groupAuth.get('tipoauth').value : accion;
    }

    this.ordenventaService.TransaccionAuthCVta(Request).subscribe(response => {
      if (response.datos.status === 200) {
        const mensaje = response.datos.result
        switch (mensaje) {
          case 'OK':
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se autorizó el cambio de venta correctamente.', life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.btnToken = true;
            this.mensajeIntento = 'Token correcto.';
            this.groupAuth.reset();
            this.dtServiciosRef.onRowEditSave(this.rowAuth, this.rowAuth['key'] - 1);
            this.dtServiciosRef2.onRowEditSave(this.rowAuth, this.rowAuth['key'] - 1);
            this.intentoU = 0;
            break;
          case 'NV':
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'No vigente', detail: 'Se acabó el tiempo de vigencia de este token, genere uno nuevo.', life: 3000, key: "tl" });
            this.btnToken = true;
            this.groupAuth.get('token').setValue(null);
            break;
          case 'NA':
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Falta generar Token', detail: 'No se ha generado ningún Token para este servicio.', life: 3000, key: "tl" });
            this.btnToken = true;
            this.groupAuth.get('token').setValue(null);
            break;
          case 'DT':
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'No autorizado', detail: 'No se autorizó el cambio de venta.', life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.btnToken = true;
            this.groupAuth.reset();
            const index = this.servicioslocales_datadetalle.findIndex(d => d['key'] === this.rowAuth['key']);
            this.dtServiciosRef.onRowEditCancel(this.rowAuth, index);
            const index2 = this.servicioslocales_detalleTarifa.findIndex(d => d['key'] === this.rowAuth['key']);
            this.dtServiciosRef2.onRowEditCancel(this.rowAuth, index2);
            this.groupAuth.reset();
            this.intentoU = 0;
            break;
          case 'AU':
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se autorizó el cambio de venta correctamente.', life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.btnToken = true;
            this.groupAuth.reset();
            this.dtServiciosRef.onRowEditSave(this.rowAuth, this.rowAuth['key'] - 1);
            this.dtServiciosRef2.onRowEditSave(this.rowAuth, this.rowAuth['key'] - 1);
            this.intentoU = 0;
            break;
          case '0':
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Token incorrecto', detail: 'Se ha acabado el número de intentos para este token, genere uno nuevo.', life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.groupAuth.get('token').setValue(null);
            break;
          default:
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Token incorrecto', detail: 'El token no coincide, vuelva a intentarlo.', life: 3000, key: "tl" });
            this.btnToken = false;
            this.mensajeIntento = `Le quedan solo ${mensaje} intentos para ingresar el token.`;
            this.groupAuth.get('token').setValue(null);
            break;
        }
      }
    })
  }
  erroresValidacion: { [key: string]: string } = {};
  async onEditRowInit(product: any): Promise<void> {
    console.log("Edit Init triggered from child", product);
    const key = product.key;
    this.dtServiciosRef.puedeValidar[key] = false;
    this.monto_original = null
    // if (product['tipocambioventa'] === null || product['tipocambioventa'] === undefined || product['tipocambioventa'] === 0) {
    const Request: ConsultarProfitTCambioRequest = <ConsultarProfitTCambioRequest>{}
    Request.SERV_Codigo = product['serv_codigo']
    Request.tipo = "TC"
    try {
      const response = await firstValueFrom(this.ordenventaService.ConsultarTCambio(Request));
      if (response.datos.status === 200) {
        product['tipocambiocompra'] = response.datos.result[0].tipocambiocompra
        product['tipocambioventa'] = response.datos.result[0].tipocambioventa
        if (this.dtServiciosRef && this.dtServiciosRef.puedeValidar) {
          this.dtServiciosRef.puedeValidar[key] = true;
        }
      }
    } catch (error) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'El tipo de cambio de venta no está definido para el día de hoy. Por favor, verifique.', life: 3000, key: "tl" });
      this.dtServiciosRef.onRowEditCancel(product, product['key'] - 1);
      this.dtServiciosRef2.onRowEditCancel(product, product['key'] - 1);
      return;
    }
    // }
    // if (product['profitminimo'] === null || product['profitminimo'] === undefined || product['profitminimo'] === 0) {

    const RequestP: ConsultarProfitTCambioRequest = <ConsultarProfitTCambioRequest>{}
    RequestP.SERV_Codigo = product['serv_codigo']
    RequestP.tipo = "PM"
    try {
      const response = await firstValueFrom(this.ordenventaService.ConsultarProfit(RequestP));
      if (response.datos.status === 200) {
        product['profitminimo'] = response.datos.result[0].profitminimo
        product['tipomonedam'] = response.datos.result[0].tipomonedam
        product['tipoprofitm'] = response.datos.result[0].tipoprofitm
        if (this.dtServiciosRef && this.dtServiciosRef.puedeValidar) {
          this.dtServiciosRef.puedeValidar[key] = true;
        }
      }
    } catch (error) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No existe un profit mínimo para esta Tarifa. Por favor, verifique.', life: 3000, key: "tl" });
      this.dtServiciosRef.onRowEditCancel(product, product['key'] - 1);
      this.dtServiciosRef2.onRowEditCancel(product, product['key'] - 1);
      return;
    }
    // }
    this.monto_original = product['dope_preciounitvta']
  }
  cargarLNGAgente(event) {
    this.group_tabcotizacion.get('lineanegocio').setValue(null)
    const regimen = this.group_tabcotizacion.get('regimen')?.value
    if (regimen !== null) {
      if (regimen === '002') {
        this.group_tabcotizacion.get('lineanegocio').setValue("002")
      } else {
        if (event.value !== null) {
          const codAgente = this.ListaTodosAgentes.find(item => item.nombre === event.value)?.codigo
          const codval = this.ListaTodosAgeMND.find(item => item.codigo === codAgente)?.codigo
          if (codval !== undefined) {
            this.group_tabcotizacion.get('lineanegocio').setValue("001")
          } else {
            this.group_tabcotizacion.get('lineanegocio').setValue("004")
          }
        }
      }
    }
  }
  objPuertoOrigen: any = null;
  data: any = {
    puertoOrigen: this.objPuertoOrigen,
    data: this.datosViajePorPuerto2
  }
  calculateFlete = (evento: any) => {

    console.log("Calculando flete...");
    console.log(this.serviciosytarifas_dataflete)
    console.log(this.data)
    const total = this.serviciosytarifas_dataflete?.reduce((sum, item) => {
      const value = parseFloat(item.dcot_totaluniventa);
      return sum + (isNaN(value) ? 0 : value);
    }, 0);

    console.log("Total:", total);
    this.group_datosGenerales.get('fletetotal').setValue(total);

    // actualización de servicios SLI por cantidad de fletes

    const filaOriginal = this.dataFlete?.getFilaOriginal?.(evento);

    const filaEncontrada = this.serviciosytarifas_dataflete?.find?.(
      (fila) => fila?.key === filaOriginal?.key
    );

    if (filaOriginal?.dcot_cantidad !== filaEncontrada?.dcot_cantidad) {

      if (this.servicioslocales_datadetalle.some(item => item.ESTADO_OBJ !== 'D')) {

        if (
          this.servicioslocales_datadetalle?.filter(t => t.ESTADO_OBJ !== 'D').some(t => t.cons_codest !== '001')
        ) {
          this.messageService.add({
            severity: 'error', summary: 'Cambio de cantidad no permitido', key: 'tl',
            detail: 'No se puede cambiar la cantidad de fletes porque ya hay servicios prefacturados',
          });

          filaEncontrada.dope_cantidad = filaOriginal.dcot_cantidad;
          return;
        }

        const totalCantidad = this.serviciosytarifas_dataflete?.reduce((sum, item) => {
          const value = parseFloat(item.dcot_cantidad);
          return sum + (isNaN(value) ? 0 : value);
        }, 0);

        console.log("servicios logisticos", this.servicioslocales_datadetalle);
        console.log("getFilaOriginal", this.dataFlete.getFilaOriginal(evento))

        if (this.servicioslocales_datadetalle.length > 0) {

          this.servicioslocales_datadetalle
            ?.filter(item => item.ESTADO_OBJ !== 'D')
            .forEach(item => {
              const preciounitcosto = parseFloat(item.dope_preciounitcosto) || 0;
              const preciounit_prom = parseFloat(item.dope_preciounit_prom) || 0;
              const preciounitvta = parseFloat(item.dope_preciounitvta) || 0;

              const preciototcosto = preciounitcosto * totalCantidad;
              const preciotot_prom = preciounit_prom * totalCantidad;
              const preciototvta = preciounitvta * totalCantidad;

              item.dope_preciototcosto = Number(Math.round(preciototcosto * 100) / 100);
              item.dope_preciotot_prom = Number(Math.round(preciotot_prom * 100) / 100);
              item.dope_preciototvta = Number(Math.round(preciototvta * 100) / 100);
              item.dope_cantidad = totalCantidad;
              item.ESTADO_OBJ = item.ESTADO_OBJ == 'NA' ? 'U' : item.ESTADO_OBJ;
            });

        }

        this.messageService.add({ severity: 'warn', summary: 'Actualización Servicios SLI', detail: 'Se actualizó el Costo y Venta Total considerando la nueva cantidad.', life: 3000, key: "tl" });

      }

    }

    setTimeout(() => {
      const rowIndexValido = this.serviciosytarifas_dataflete.indexOf(evento);
      this.seleccionarFlete(rowIndexValido, evento);
    }, 1000);

  }

  obtenerCodigoPorEntidad = (valueEntidad: string | number, tipo: string): string | null => {
    const tiposMap: Record<string, string> = {
      '15': 'DepositoVacio',
      '14': 'DepositoTemp',
      '3': 'EJEC',
      '4': 'CUS',
      '5': 'TRANSPORTISTA',
      '9': 'CONTACTO',
      '6': 'AGE',
      '7': 'AGE',
      '2': 'PROVEEDOR',
      '10': 'SHIPPER',
      '17': 'TERMINALPORTUARIO',
      '1': 'CLIENTE'
    };

    const entidadEncontrada = this.ListaNombreEntidadesDP.find(
      e => Number(e.value) === Number(valueEntidad)
    );

    if (tipo === 'codigo') {
      if (!entidadEncontrada?.tipo) return null;
      const codigo = Object.keys(tiposMap).find(
        key => tiposMap[key].toUpperCase() === entidadEncontrada.tipo.toUpperCase()
      );
      return codigo ?? null;
    } else {
      return tiposMap[String(valueEntidad)] ?? null;
    }
  }
  calcularValor(tipoMoneda: string, costo: number, tipoCambio: number): number {
    if (costo === null || costo === undefined) return 0;
    if (tipoMoneda === null || tipoMoneda === undefined) return 0;

    costo = Number(costo);
    if (isNaN(costo)) return 0;

    let valor = 0
    switch (tipoMoneda) {
      case '001': // Soles -> convertir a dólares
        valor = tipoCambio && tipoCambio > 0 ? costo / tipoCambio : 0;
        break;
      case '002': // Dólares -> retorna igual
        valor = costo
        break;
      case '004': // Porcentaje -> dividir entre 100
        valor = costo / 100;
        return Math.round(valor * 10000) / 10000;
        break;
      default: // otros códigos no definidos
        valor = 0;
    }
    return Math.round(valor * 100) / 100;
  }
  styleRowAlm = (row: any) => {
    if (row.color !== null) {
      return { 'background-color': row.color } // rojo
    } else {
      return { 'background-color': "#ffffff" }//amarillo
    }
  }

  styleRow = (row: any) => {
    if (row.cons_codest === '002') {
      return { 'background-color': "rgba(4, 0, 255, 0.05)", 'color': 'rgb(4, 0, 255)' } // rojo
    } else if (row.cons_codest === '005') {
      return { 'background-color': "#ffffff", 'color': '#ff0000ff' } // verde
    } else {
      return { 'background-color': "#ffffff" }//amarillo
    }
  }

  obtenerDatosOV() {
    const request: listAllOVRequest = <listAllOVRequest>{}
    request.empresa = 1
    request.tipo = 2
    request.sucursal = 1
    request.regimen = ""
    request.flete = ""
    request.via = []
    request.estado = []
    request.ejecutivo = []
    request.customer = []
    request.agente = ""
    request.cliente = ""
    request.numdoc = this.datosRecibidos?.['ccot_numdoc']
    request.mbl = ""
    request.hbl = ""
    request.booking = ""
    request.desde = "";
    request.hasta = "";
    request.condetalle = "S"
    request.numero_cotizacion = "";
    this.ordenventaService.listAllOV(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.listaItinerariosOV = response.datos.result[0]?.listaItinerariosOV
      }
    })
    //ccot_ovnumdoc
  }

  extraerValueSinObjeto(valor: any): any {
    return typeof valor === 'object' && valor !== null ? valor.value : valor ?? null;
  }

  onChangeCif(origen: string, tipo: string) {
    if (origen == 'EVE') {
      if (tipo == 'EJEC') {
        this.group_tarifasAdicionales.get('montocif')?.setValue(this.group_tarifasAdicionales.get('cifEjecVta')?.value);
      }
      else if (tipo == 'LOG') {
        this.group_tarifasAdicionales.get('montocif')?.setValue(this.group_tarifasAdicionales.get('cifLogistico')?.value);
      }
    }
    else if (origen == 'INI') {
      if (this.item2) {
        const row = this.item2;
        const montocif = row.cope_cifLogistico == null ? row.cope_cifEjecVta : row.cope_cifLogistico;
        this.group_tarifasAdicionales.get('cifEjecVta')?.setValue(row.cope_cifEjecVta);
        this.group_tarifasAdicionales.get('cifLogistico')?.setValue(montocif);
        this.group_tarifasAdicionales.get('montocif')?.setValue(montocif);
      }
    }

    const roladd = this.rol;
    if (['1', '10', '11', '14', this.coordLog, this.gerentLog].includes(roladd)) { // es coordinador

      if (['1', this.gerentLog].includes(roladd)) { // es admin
        this.group_tarifasAdicionales.get('cifEjecVta')?.enable();
        this.group_tarifasAdicionales.get('cifLogistico')?.enable();
      }
      else { // es coord
        this.group_tarifasAdicionales.get('cifEjecVta')?.disable();
      }

    } else { // es ejec vta
      this.group_tarifasAdicionales.get('cifLogistico')?.disable();
    }
  }

  colorLeyendasAgrupacion(row: any): string {
    return row.agrupado ? '#2563EB' : '#9CA3AF';
  }

  dtZonas: any[] = []
  visibleZonas: boolean = false;
  mtZonasHijo: readonlyMetadataTable[] = [
    { title: 'Distrito', field: 'ubig_desdistrito', type: 'text' },
    { title: 'Provincia', field: 'ubig_desprovincia', type: 'text' },
    { title: 'Departamento', field: 'ubig_desdepartamento', type: 'text' },
  ];
  mtZonas: readonlyMetadataTable[] = [
    { title: 'Zona', field: 'tipo_deszon', type: 'text' },
    { title: '', field: 'detail', type: 'array', metadata: this.mtZonasHijo, key: 'dzon_codigo' }
  ];

  verZonas() {
    this.dtZonas = [];
    const request_zona_proveedor = <getZoneByProviderRequest>{
      zona: null,
      proveedor: null
    }
    this.servLogistica.getZoneByProvider(request_zona_proveedor).subscribe(res => {
      this.dtZonas = res.datos.result
      this.visibleZonas = true;
    }, err => {
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ titulo: 'Error', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    })
  }

  seleccionarFlete(index: number, rowdata: any): void {
    const algunoSeleccionado = this.serviciosytarifas_dataflete.some(row => row['select'] === true);

    // Si no hay ninguno seleccionado, seleccionar el primero por defecto
    if (!algunoSeleccionado && this.serviciosytarifas_dataflete.length > 0) {

      if (index == -1) {
        const primerRowValido = this.serviciosytarifas_dataflete.find(row => row.estado_Obj !== 'D');
        const rowIndexValido = this.serviciosytarifas_dataflete.indexOf(primerRowValido);
        this.onCheckboxChange({ rowIndex: rowIndexValido, isChecked: true, rowdata: primerRowValido });
      }
      else {
        this.onCheckboxChange({ rowIndex: index, isChecked: true, rowdata: rowdata });
      }

      return; // importante para evitar doble ejecución del resto del código
    } else {
      const primerRowValido = this.serviciosytarifas_dataflete.find(row => row.estado_Obj !== 'D');
      const rowIndexValido = this.serviciosytarifas_dataflete.indexOf(primerRowValido);
      this.onCheckboxChange({ rowIndex: index, isChecked: true, rowdata: rowdata });
    }

  }

  async cargarTarifasDefault() {
    if (this.accion === 'NUEVO') {
      if (this.group_tarifasAdicionales.get('fechasl')?.value == null || this.group_tarifasAdicionales.get('fechasl')?.value == '') {
        const hoy = new Date();
        const fechaNov4 = new Date(hoy.getFullYear(), 10, 4);
        //this.group_tarifasAdicionales.get('fechasl').setValue(fechaNov4);

        this.group_tarifasAdicionales.get('fechasl').setValue(new Date());
      }

      if (this.serviciosytarifas_dataflete.filter(row => row.ESTADO_OBJ !== 'D')?.length > 0
        && this.group_datosGenerales.get('transportista')?.value != null && this.group_Transporte.get("condicion")?.value != null && this.group_tabcotizacion?.get("regimen")?.value != null) {

        if (this.servicioslocales_datadetalle?.length > 0) {
          this.tablaAgrupados = [];
          this.servicioslocales_detalleTarifa = [];
          this.servicioslocales_datadetalle = [];
        }

        await this.buscarServicioLogistico();

        // cargar tarifa vb , gate in , gate out 
        setTimeout(() => {
          if (this.dataTableTarifaServicioLogistico.length > 0) {
            console.log("servicios logisticos automaticos", this.dataTableTarifaServicioLogistico)

            // && item.terminal?.value == "2179" terminal dp world
            const gateIn = this.dataTableTarifaServicioLogistico.find(item => item.servicio?.value === "1057");
            const gateOut = this.dataTableTarifaServicioLogistico.find(item => item.servicio?.value === "1058");
            const vb = this.dataTableTarifaServicioLogistico.find(item => item.servicio?.value === "1107");

            if (this.servicioslocales_datadetalle?.length > 0) {
              this.tablaAgrupados = [];
              this.servicioslocales_detalleTarifa = [];
              this.servicioslocales_datadetalle = [];
            }

            if (gateIn) {
              const fakeEvent = { checked: [true] };
              this.addTarifa(fakeEvent, gateIn, 'I', 'SLI');
            }

            if (gateOut) {
              const fakeEvent = { checked: [true] };
              this.addTarifa(fakeEvent, gateOut, 'I', 'SLI');
            }

            if (vb) {
              const fakeEvent = { checked: [true] };
              this.addTarifa(fakeEvent, vb, 'I', 'SLI');
            }
          }
        }, 100);

      }

    }

  }

  logicaMetadataFlete(paquetes?) {
    if (this.group_datosGenerales.value["condicion"] != null) this.metadatableFlete = Array.from([]);
    if (this.group_datosGenerales.value["condicion"] == '001' || this.group_datosGenerales.value["condicion"] == '002') {
      if (this.isadmin == true) {
        this.metadatableFlete = Array.from(this.metadatableFlete1ConCostos);
      } else {
        this.metadatableFlete = Array.from(this.metadatableFlete1);
      }
    }
    else if (this.group_datosGenerales.value["condicion"] == '003' || this.group_datosGenerales.value["condicion"] == '004') {
      if (this.isadmin == true) {
        this.metadatableFlete = Array.from(this.metadatableFlete2ConCostos);
      } else {
        this.metadatableFlete = Array.from(this.metadatableFlete2);
      }
    }

    setTimeout(() => {
      const metadataItem = this.dataFlete.metadata.find(m => m.field === "paqueteObj");
      if (metadataItem) {
        metadataItem.dropdown = [...paquetes];
      }
    }, 1000);
  }

  onNumeroContratoChange(event: any): void {
    this.cargarTarifasDefault();
  }

  verTarifarioSli() {

    let data = {
      origen: 'orden_venta',
    }

    const ref2 = this.dialogService.open(BandejaTarifarioSliComponent, {
      header: 'Tarifario SLI',
      data: data,
      width: '90%',
      contentStyle: { "overflow": "auto" },
      baseZIndex: 10000,
      maximizable: true,
      closable: true,
    });

    ref2.onClose.subscribe((res) => {
      if (res.message == "OK") {

      }
    });

  }

  verificarCambiosPorAutorizar(): { resultado: boolean, items: number[], datos: any[] } {

    const itemsTrue: number[] = [];
    const datos: any[] = [];

    const listadoOriginal = this.datos ? structuredClone(this.datos['listadoserviciosasociados'] ?? []) : [];
    const existe006 = this.servicioslocales_datadetalle?.some(x => x.cons_codest === '006');

    if (!existe006) { return { resultado: false, items: [], datos: [] }; }

    for (const item of this.servicioslocales_datadetalle ?? []) {

      if ((item.ESTADO_OBJ === 'I' || item.ESTADO_OBJ === 'U') && item.cons_codest === '006') {

        const original = listadoOriginal.find(x => x.dope_item === item.dope_item && x.cope_codigo === item.cope_codigo);
        const debeAutorizar = item.ESTADO_OBJ === 'I' || (item.ESTADO_OBJ === 'U' && original?.cons_codest !== '006');

        if (!debeAutorizar) { continue; }
        itemsTrue.push(item.dope_item);

        if (item.esadicional === true) {

          datos.push({
            nombre_servicio: item.serv_nombre_spa?.label ?? item.serv_nombre_spa,
            precio_original: item.dope_preciounitvta,
            precio_modificado: item.dope_preciounitcosto,
            tipo: 'C',
            precio_cod_mnd: item.nombremndvta?.value ?? item.tipo_codmndventa ?? null,
            precio_tab_mnd: 'MND',
            precio_desc_mnd: item.nombremndvta?.label ?? null,
            desc_moneda_solicitado: item.nombremnd?.label ?? null,
            cod_moneda_solicitado: item.nombremnd?.value ?? item.tipo_codmnd ?? null,
            tab_moneda_solicitado: 'MND',
          });

          item.tipo_autorizacion = 'C';

        } else {

          datos.push({
            nombre_servicio: item.serv_nombre_spa?.label ?? item.serv_nombre_spa,
            precio_original: item.venta_tarifa_original,
            precio_modificado: item.dope_preciounitvta,
            tipo: 'V',
            precio_cod_mnd: item.cod_mnd_venta_tariff_original,
            precio_tab_mnd: item.tab_mnd_venta_tariff_original,
            precio_desc_mnd: item.desc_mnd_venta_tariff_original,
            desc_moneda_solicitado: item.nombremndvta?.label ?? item.nombremndvta ?? null,
            cod_moneda_solicitado: item.nombremndvta?.value ?? item.tipo_codmndventa ?? null,
            tab_moneda_solicitado: item.tipo_tabmndventa ?? null,
          });

          item.mnd_tarifa = item.cod_mnd_venta_tariff_original;
          item.tab_tarifa = item.tab_mnd_venta_tariff_original;
          item.monto_tarifa = item.venta_tarifa_original;
          item.tipo_autorizacion = 'V';
        }
      }
    }

    return { resultado: itemsTrue.length > 0, items: itemsTrue, datos: datos };
  }

  async mapearEdit(product: any): Promise<void> {
    try {
      const filaOriginal = this.dtServiciosRef?.getFilaOriginal?.(product);
      const filaEncontrada = this.servicioslocales_datadetalle?.find?.(
        (fila) => fila?.key === filaOriginal?.key
      );
      if (filaEncontrada) {
        product['costo_edicion_original'] = filaEncontrada.dope_preciounitcosto;
        product['venta_edicion_original'] = filaEncontrada.dope_preciounitvta;
      }
    } catch (error) {
      console.error(error);
    }
    console.log("product", product)
  }

  async calcularCantidadBase(_CONS_CodBAS: string, index, origen: string, opts?: { soloRetornar?: boolean }
  ): Promise<number | void> {
    if (_CONS_CodBAS && _CONS_CodBAS !== null && _CONS_CodBAS !== undefined) {
      let _SCOT_Cantidad: number = 1.00;
      let _DCOT_Peso: number | null = 0.00;
      let _DCOT_Volumen: number | null = 0.00;
      const teus20 = 1;
      const teus40 = 2;
      switch (_CONS_CodBAS) {
        case "001":
          // No cambia _SCOT_Cantidad, se queda en 1
          break;
        case "002":
          _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + (dcot.dcot_cantidad || 0), 0);
          break;
        case "003":
          const paquete = this.serviciosytarifas_dataflete[0]?.pack_desc;
          if (paquete?.value == "1") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus20) || 0), 0);
          } else if (paquete?.value == "3") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus40) || 0), 0);
          } else if (paquete?.value == "4") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus40) || 0), 0);
          } else if (paquete?.value == "2") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus40) || 0), 0);
          }
          break;
        case "004":
          _DCOT_Peso = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + (dcot.dcot_peso || 0), 0);
          _DCOT_Volumen = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + (dcot.dcot_volumen || 0), 0);

          if (_DCOT_Peso !== 0 && _DCOT_Volumen !== 0) {
            if (_DCOT_Peso > _DCOT_Volumen) {
              _SCOT_Cantidad = _DCOT_Peso;
            } else {
              _SCOT_Cantidad = _DCOT_Volumen;
            }
          }
          break;
        default:
          break;
      }

      if (opts?.soloRetornar) {
        return _SCOT_Cantidad;
      }

      // if (origen == 'servicios_adicionales') {
      //   this.enviarNuevoValorToDatatable(_SCOT_Cantidad, index, 'scot_cantidad');
      // } else if (origen == 'servicios_change_control') {
      //   this.enviarValorDTServiciosChangeControl(_SCOT_Cantidad, index, 'scot_cantidad');
      // }

      return;
    }

  }

  obtenerCodigoPorValor(lista: any[], valor: any): string | null {
    if (!valor) return null;
    const encontrado = lista.find(item =>
      item.nombre === valor || item.codigo === valor
    );
    return encontrado ? encontrado.codigo : null;
  }

  cancelarFilasEdicion() {
    this.dataFlete.cancelarEdicionActiva();
    this.dtServiciosRef2.cancelarEdicionActiva();
    this.dtServiciosRef.cancelarEdicionActiva();
  }

  verColumnaMetadata(row: any, columna: string): boolean {
    // se devuelve true para que se muestre la columna
    const activos = this.servicioslocales_datadetalle.filter(item => item.ESTADO_OBJ !== 'D');

    if (activos.length === 0) return false;

    const obtenerValor = (val: any) => (val && typeof val === 'object' ? val.value : val);

    switch (columna) {
      case 'tipo_cambio': {

        const valoresMnd = activos
          .map(item => obtenerValor(item.nombremnd))
          .filter(val => val !== null && val !== undefined && val !== '');

        const valoresMndVta = activos
          .map(item => obtenerValor(item.nombremndvta))
          .filter(val => val !== null && val !== undefined && val !== '');

        const hayDiferenciaMnd = new Set(valoresMnd).size > 1;
        const hayDiferenciaMndVta = new Set(valoresMndVta).size > 1;

        return hayDiferenciaMnd || hayDiferenciaMndVta;
      }

      default:
        return false;
    }
  }

  extraerLabelSinObjeto(valor: any): any {
    if (valor === null || valor === undefined) return null;
    return typeof valor === 'object' ? valor.label : valor;
  }

}
